import type { IconSvgObject } from './types';

/**
 * Dynamic Icon Loader - stroke-rounded (5439 icons)
 * 
 * Load icons dynamically by name without importing all icons upfront.
 * Uses static import maps for maximum bundler compatibility.
 * 
 * @example
 * import { loadIcon } from '@hugeicons-pro/core-stroke-rounded/loader';
 * 
 * const icon = await loadIcon('Home01Icon');
 * // Use icon with @hugeicons/react or any other renderer
 */

// Static require map for React Native (Metro bundler)
// All icons are loaded synchronously at module evaluation
const mods: Record<string, IconSvgObject> = {
  FirstBracketCircleIcon: require('./FirstBracketCircleIcon').default,
  FirstBracketSquareIcon: require('./FirstBracketSquareIcon').default,
  FirstBracketIcon: require('./FirstBracketIcon').default,
  TwentyFourHoursClockIcon: require('./TwentyFourHoursClockIcon').default,
  SecondBracketCircleIcon: require('./SecondBracketCircleIcon').default,
  SecondBracketSquareIcon: require('./SecondBracketSquareIcon').default,
  SecondBracketIcon: require('./SecondBracketIcon').default,
  ThreeDViewIcon: require('./ThreeDViewIcon').default,
  ThreeDMoveIcon: require('./ThreeDMoveIcon').default,
  ThreeDPrinterIcon: require('./ThreeDPrinterIcon').default,
  ThreeDRotateIcon: require('./ThreeDRotateIcon').default,
  ThreeDScaleIcon: require('./ThreeDScaleIcon').default,
  ThirdBracketCircleIcon: require('./ThirdBracketCircleIcon').default,
  ThirdBracketSquareIcon: require('./ThirdBracketSquareIcon').default,
  ThirdBracketIcon: require('./ThirdBracketIcon').default,
  FourKIcon: require('./FourKIcon').default,
  SevenZ01Icon: require('./SevenZ01Icon').default,
  SevenZ02Icon: require('./SevenZ02Icon').default,
  AArrowDownIcon: require('./AArrowDownIcon').default,
  AArrowUpIcon: require('./AArrowUpIcon').default,
  ALargeSmallIcon: require('./ALargeSmallIcon').default,
  AbacusIcon: require('./AbacusIcon').default,
  AbsoluteIcon: require('./AbsoluteIcon').default,
  AccelerationIcon: require('./AccelerationIcon').default,
  AccessIcon: require('./AccessIcon').default,
  AccessibilityIcon: require('./AccessibilityIcon').default,
  AccidentIcon: require('./AccidentIcon').default,
  AccountRecoveryIcon: require('./AccountRecoveryIcon').default,
  AccountSetting01Icon: require('./AccountSetting01Icon').default,
  AccountSetting02Icon: require('./AccountSetting02Icon').default,
  AccountSetting03Icon: require('./AccountSetting03Icon').default,
  Activity01Icon: require('./Activity01Icon').default,
  Activity02Icon: require('./Activity02Icon').default,
  Activity03Icon: require('./Activity03Icon').default,
  Activity04Icon: require('./Activity04Icon').default,
  Activity05Icon: require('./Activity05Icon').default,
  ActivityCircleIcon: require('./ActivityCircleIcon').default,
  ActivitySparkIcon: require('./ActivitySparkIcon').default,
  AcuteIcon: require('./AcuteIcon').default,
  Add01Icon: require('./Add01Icon').default,
  Add02Icon: require('./Add02Icon').default,
  AddCircleHalfDotIcon: require('./AddCircleHalfDotIcon').default,
  AddCircleIcon: require('./AddCircleIcon').default,
  AddFemaleIcon: require('./AddFemaleIcon').default,
  AddInvoiceIcon: require('./AddInvoiceIcon').default,
  AddMaleIcon: require('./AddMaleIcon').default,
  AddMoneyCircleIcon: require('./AddMoneyCircleIcon').default,
  AddSquareIcon: require('./AddSquareIcon').default,
  AddTeam02Icon: require('./AddTeam02Icon').default,
  AddTeamIcon: require('./AddTeamIcon').default,
  AddToListIcon: require('./AddToListIcon').default,
  AddressBookIcon: require('./AddressBookIcon').default,
  AdjustPositionIcon: require('./AdjustPositionIcon').default,
  AdobeAfterEffectIcon: require('./AdobeAfterEffectIcon').default,
  AdobeIllustratorIcon: require('./AdobeIllustratorIcon').default,
  AdobeIndesignIcon: require('./AdobeIndesignIcon').default,
  AdobePhotoshopIcon: require('./AdobePhotoshopIcon').default,
  AdobePremierIcon: require('./AdobePremierIcon').default,
  AdobeXdIcon: require('./AdobeXdIcon').default,
  AdventureIcon: require('./AdventureIcon').default,
  AdvertisimentIcon: require('./AdvertisimentIcon').default,
  AdzanIcon: require('./AdzanIcon').default,
  AffiliateIcon: require('./AffiliateIcon').default,
  Agreement01Icon: require('./Agreement01Icon').default,
  Agreement02Icon: require('./Agreement02Icon').default,
  Agreement03Icon: require('./Agreement03Icon').default,
  AiAudioIcon: require('./AiAudioIcon').default,
  AiBeautifyIcon: require('./AiBeautifyIcon').default,
  AiBookIcon: require('./AiBookIcon').default,
  AiBrain01Icon: require('./AiBrain01Icon').default,
  AiBrain02Icon: require('./AiBrain02Icon').default,
  AiBrain03Icon: require('./AiBrain03Icon').default,
  AiBrain04Icon: require('./AiBrain04Icon').default,
  AiBrain05Icon: require('./AiBrain05Icon').default,
  AiBrowserIcon: require('./AiBrowserIcon').default,
  AiChat01Icon: require('./AiChat01Icon').default,
  AiChat02Icon: require('./AiChat02Icon').default,
  AiChemistry01Icon: require('./AiChemistry01Icon').default,
  AiChemistry02Icon: require('./AiChemistry02Icon').default,
  AiChemistry03Icon: require('./AiChemistry03Icon').default,
  AiChipIcon: require('./AiChipIcon').default,
  AiCloud01Icon: require('./AiCloud01Icon').default,
  AiCloud02Icon: require('./AiCloud02Icon').default,
  AiCloudIcon: require('./AiCloudIcon').default,
  AiComputerIcon: require('./AiComputerIcon').default,
  AiContentGenerator01Icon: require('./AiContentGenerator01Icon').default,
  AiContentGenerator02Icon: require('./AiContentGenerator02Icon').default,
  AiDnaIcon: require('./AiDnaIcon').default,
  AiEditingIcon: require('./AiEditingIcon').default,
  AiEraserIcon: require('./AiEraserIcon').default,
  AiFileIcon: require('./AiFileIcon').default,
  AiFolder01Icon: require('./AiFolder01Icon').default,
  AiFolder02Icon: require('./AiFolder02Icon').default,
  AiGameIcon: require('./AiGameIcon').default,
  AiGenerativeIcon: require('./AiGenerativeIcon').default,
  AiIdeaIcon: require('./AiIdeaIcon').default,
  AiImageIcon: require('./AiImageIcon').default,
  AiInnovation01Icon: require('./AiInnovation01Icon').default,
  AiInnovation02Icon: require('./AiInnovation02Icon').default,
  AiInnovation03Icon: require('./AiInnovation03Icon').default,
  AiLaptopIcon: require('./AiLaptopIcon').default,
  AiLearningIcon: require('./AiLearningIcon').default,
  AiLockIcon: require('./AiLockIcon').default,
  AiMagicIcon: require('./AiMagicIcon').default,
  AiMail01Icon: require('./AiMail01Icon').default,
  AiMail02Icon: require('./AiMail02Icon').default,
  AiMailIcon: require('./AiMailIcon').default,
  AiMicIcon: require('./AiMicIcon').default,
  AiNetworkIcon: require('./AiNetworkIcon').default,
  AiPhone01Icon: require('./AiPhone01Icon').default,
  AiPhone02Icon: require('./AiPhone02Icon').default,
  AiProgrammingIcon: require('./AiProgrammingIcon').default,
  AiScanIcon: require('./AiScanIcon').default,
  AiSchedulingIcon: require('./AiSchedulingIcon').default,
  AiSearch02Icon: require('./AiSearch02Icon').default,
  AiSearchIcon: require('./AiSearchIcon').default,
  AiSecurity01Icon: require('./AiSecurity01Icon').default,
  AiSecurity02Icon: require('./AiSecurity02Icon').default,
  AiSecurity03Icon: require('./AiSecurity03Icon').default,
  AiSettingIcon: require('./AiSettingIcon').default,
  AiSheetsIcon: require('./AiSheetsIcon').default,
  AiSmartwatchIcon: require('./AiSmartwatchIcon').default,
  AiUserIcon: require('./AiUserIcon').default,
  AiVideoIcon: require('./AiVideoIcon').default,
  AiViewIcon: require('./AiViewIcon').default,
  AiVisionRecognitionIcon: require('./AiVisionRecognitionIcon').default,
  AiVoiceGeneratorIcon: require('./AiVoiceGeneratorIcon').default,
  AiVoiceIcon: require('./AiVoiceIcon').default,
  AiWebBrowsingIcon: require('./AiWebBrowsingIcon').default,
  AidsIcon: require('./AidsIcon').default,
  AirVentIcon: require('./AirVentIcon').default,
  AirbnbIcon: require('./AirbnbIcon').default,
  AircraftGameIcon: require('./AircraftGameIcon').default,
  AirdropIcon: require('./AirdropIcon').default,
  Airplane01Icon: require('./Airplane01Icon').default,
  Airplane02Icon: require('./Airplane02Icon').default,
  AirplaneLanding01Icon: require('./AirplaneLanding01Icon').default,
  AirplaneLanding02Icon: require('./AirplaneLanding02Icon').default,
  AirplaneModeOffIcon: require('./AirplaneModeOffIcon').default,
  AirplaneModeIcon: require('./AirplaneModeIcon').default,
  AirplaneSeat02Icon: require('./AirplaneSeat02Icon').default,
  AirplaneSeatIcon: require('./AirplaneSeatIcon').default,
  AirplaneTakeOff01Icon: require('./AirplaneTakeOff01Icon').default,
  AirplaneTakeOff02Icon: require('./AirplaneTakeOff02Icon').default,
  AirplayLineIcon: require('./AirplayLineIcon').default,
  AirplayIcon: require('./AirplayIcon').default,
  Airpod01Icon: require('./Airpod01Icon').default,
  Airpod02Icon: require('./Airpod02Icon').default,
  Airpod03Icon: require('./Airpod03Icon').default,
  Airport02Icon: require('./Airport02Icon').default,
  AirportIcon: require('./AirportIcon').default,
  AirportTowerIcon: require('./AirportTowerIcon').default,
  AlAqsaMosqueIcon: require('./AlAqsaMosqueIcon').default,
  AlarmClockCheckIcon: require('./AlarmClockCheckIcon').default,
  AlarmClockMinusIcon: require('./AlarmClockMinusIcon').default,
  AlarmClockOffIcon: require('./AlarmClockOffIcon').default,
  AlarmClockPlusIcon: require('./AlarmClockPlusIcon').default,
  AlarmClockIcon: require('./AlarmClockIcon').default,
  AlarmSmokeIcon: require('./AlarmSmokeIcon').default,
  Album01Icon: require('./Album01Icon').default,
  Album02Icon: require('./Album02Icon').default,
  AlbumNotFound01Icon: require('./AlbumNotFound01Icon').default,
  AlbumNotFound02Icon: require('./AlbumNotFound02Icon').default,
  AlbumIcon: require('./AlbumIcon').default,
  Alert01Icon: require('./Alert01Icon').default,
  Alert02Icon: require('./Alert02Icon').default,
  AlertCircleIcon: require('./AlertCircleIcon').default,
  AlertDiamondIcon: require('./AlertDiamondIcon').default,
  AlertSquareIcon: require('./AlertSquareIcon').default,
  AlgorithmIcon: require('./AlgorithmIcon').default,
  Alien01Icon: require('./Alien01Icon').default,
  Alien02Icon: require('./Alien02Icon').default,
  AlignBottomIcon: require('./AlignBottomIcon').default,
  AlignBoxBottomCenterIcon: require('./AlignBoxBottomCenterIcon').default,
  AlignBoxBottomLeftIcon: require('./AlignBoxBottomLeftIcon').default,
  AlignBoxBottomRightIcon: require('./AlignBoxBottomRightIcon').default,
  AlignBoxMiddleCenterIcon: require('./AlignBoxMiddleCenterIcon').default,
  AlignBoxMiddleLeftIcon: require('./AlignBoxMiddleLeftIcon').default,
  AlignBoxMiddleRightIcon: require('./AlignBoxMiddleRightIcon').default,
  AlignBoxTopCenterIcon: require('./AlignBoxTopCenterIcon').default,
  AlignBoxTopLeftIcon: require('./AlignBoxTopLeftIcon').default,
  AlignBoxTopRightIcon: require('./AlignBoxTopRightIcon').default,
  AlignEndHorizontalIcon: require('./AlignEndHorizontalIcon').default,
  AlignEndVerticalIcon: require('./AlignEndVerticalIcon').default,
  AlignHorizontalCenterIcon: require('./AlignHorizontalCenterIcon').default,
  AlignHorizontalDistributeCenterIcon: require('./AlignHorizontalDistributeCenterIcon').default,
  AlignHorizontalDistributeEndIcon: require('./AlignHorizontalDistributeEndIcon').default,
  AlignHorizontalDistributeStartIcon: require('./AlignHorizontalDistributeStartIcon').default,
  AlignHorizontalJustifyCenterIcon: require('./AlignHorizontalJustifyCenterIcon').default,
  AlignHorizontalJustifyEndIcon: require('./AlignHorizontalJustifyEndIcon').default,
  AlignHorizontalJustifyStartIcon: require('./AlignHorizontalJustifyStartIcon').default,
  AlignHorizontalSpaceAroundIcon: require('./AlignHorizontalSpaceAroundIcon').default,
  AlignHorizontalSpaceBetweenIcon: require('./AlignHorizontalSpaceBetweenIcon').default,
  AlignKeyObjectIcon: require('./AlignKeyObjectIcon').default,
  AlignLeftIcon: require('./AlignLeftIcon').default,
  AlignRightIcon: require('./AlignRightIcon').default,
  AlignSelectionIcon: require('./AlignSelectionIcon').default,
  AlignStartHorizontalIcon: require('./AlignStartHorizontalIcon').default,
  AlignStartVerticalIcon: require('./AlignStartVerticalIcon').default,
  AlignTopIcon: require('./AlignTopIcon').default,
  AlignVerticalCenterIcon: require('./AlignVerticalCenterIcon').default,
  AlignVerticalDistributeCenterIcon: require('./AlignVerticalDistributeCenterIcon').default,
  AlignVerticalDistributeEndIcon: require('./AlignVerticalDistributeEndIcon').default,
  AlignVerticalDistributeStartIcon: require('./AlignVerticalDistributeStartIcon').default,
  AlignVerticalJustifyCenterIcon: require('./AlignVerticalJustifyCenterIcon').default,
  AlignVerticalJustifyEndIcon: require('./AlignVerticalJustifyEndIcon').default,
  AlignVerticalJustifyStartIcon: require('./AlignVerticalJustifyStartIcon').default,
  AlignVerticalSpaceAroundIcon: require('./AlignVerticalSpaceAroundIcon').default,
  AlignVerticalSpaceBetweenIcon: require('./AlignVerticalSpaceBetweenIcon').default,
  AllBookmarkIcon: require('./AllBookmarkIcon').default,
  AllahIcon: require('./AllahIcon').default,
  AlmsIcon: require('./AlmsIcon').default,
  AlphaCircleIcon: require('./AlphaCircleIcon').default,
  AlphaSquareIcon: require('./AlphaSquareIcon').default,
  AlphaIcon: require('./AlphaIcon').default,
  AlphabetArabicIcon: require('./AlphabetArabicIcon').default,
  AlphabetBanglaIcon: require('./AlphabetBanglaIcon').default,
  AlphabetChineseIcon: require('./AlphabetChineseIcon').default,
  AlphabetGreekIcon: require('./AlphabetGreekIcon').default,
  AlphabetHebrewIcon: require('./AlphabetHebrewIcon').default,
  AlphabetHindiIcon: require('./AlphabetHindiIcon').default,
  AlphabetJapaneseIcon: require('./AlphabetJapaneseIcon').default,
  AlphabetKoreanIcon: require('./AlphabetKoreanIcon').default,
  AlphabetThaiIcon: require('./AlphabetThaiIcon').default,
  AmazonIcon: require('./AmazonIcon').default,
  AmbulanceIcon: require('./AmbulanceIcon').default,
  AmericanFootballIcon: require('./AmericanFootballIcon').default,
  AmieIcon: require('./AmieIcon').default,
  AmmoIcon: require('./AmmoIcon').default,
  AmpersandIcon: require('./AmpersandIcon').default,
  AmpersandsIcon: require('./AmpersandsIcon').default,
  AmphoraIcon: require('./AmphoraIcon').default,
  AmpouleIcon: require('./AmpouleIcon').default,
  AnalysisTextLinkIcon: require('./AnalysisTextLinkIcon').default,
  Analytics01Icon: require('./Analytics01Icon').default,
  Analytics02Icon: require('./Analytics02Icon').default,
  Analytics03Icon: require('./Analytics03Icon').default,
  AnalyticsDownIcon: require('./AnalyticsDownIcon').default,
  AnalyticsUpIcon: require('./AnalyticsUpIcon').default,
  AnchorPointIcon: require('./AnchorPointIcon').default,
  AnchorIcon: require('./AnchorIcon').default,
  AndroidIcon: require('./AndroidIcon').default,
  AngelIcon: require('./AngelIcon').default,
  Angle01Icon: require('./Angle01Icon').default,
  AngleIcon: require('./AngleIcon').default,
  AngryBirdIcon: require('./AngryBirdIcon').default,
  AngryIcon: require('./AngryIcon').default,
  AnnoyedIcon: require('./AnnoyedIcon').default,
  AnonymousIcon: require('./AnonymousIcon').default,
  AntennaIcon: require('./AntennaIcon').default,
  AnvilIcon: require('./AnvilIcon').default,
  ApartmentIcon: require('./ApartmentIcon').default,
  ApertureIcon: require('./ApertureIcon').default,
  ApiGatewayIcon: require('./ApiGatewayIcon').default,
  ApiIcon: require('./ApiIcon').default,
  AppStoreIcon: require('./AppStoreIcon').default,
  AppWindowMacIcon: require('./AppWindowMacIcon').default,
  AppWindowIcon: require('./AppWindowIcon').default,
  Apple01Icon: require('./Apple01Icon').default,
  AppleFinderIcon: require('./AppleFinderIcon').default,
  AppleIntelligenceIcon: require('./AppleIntelligenceIcon').default,
  AppleMusicIcon: require('./AppleMusicIcon').default,
  AppleNewsIcon: require('./AppleNewsIcon').default,
  ApplePieIcon: require('./ApplePieIcon').default,
  AppleReminderIcon: require('./AppleReminderIcon').default,
  AppleStocksIcon: require('./AppleStocksIcon').default,
  AppleIcon: require('./AppleIcon').default,
  AppleVisionProIcon: require('./AppleVisionProIcon').default,
  Appointment01Icon: require('./Appointment01Icon').default,
  Appointment02Icon: require('./Appointment02Icon').default,
  ApproximatelyEqualCircleIcon: require('./ApproximatelyEqualCircleIcon').default,
  ApproximatelyEqualSquareIcon: require('./ApproximatelyEqualSquareIcon').default,
  ApproximatelyEqualIcon: require('./ApproximatelyEqualIcon').default,
  ApricotIcon: require('./ApricotIcon').default,
  ApronIcon: require('./ApronIcon').default,
  ArcBrowserIcon: require('./ArcBrowserIcon').default,
  ArcherIcon: require('./ArcherIcon').default,
  Archive01Icon: require('./Archive01Icon').default,
  Archive02Icon: require('./Archive02Icon').default,
  Archive03Icon: require('./Archive03Icon').default,
  Archive04Icon: require('./Archive04Icon').default,
  ArchiveArrowDownIcon: require('./ArchiveArrowDownIcon').default,
  ArchiveArrowUpIcon: require('./ArchiveArrowUpIcon').default,
  ArchiveOff03Icon: require('./ArchiveOff03Icon').default,
  ArchiveOff04Icon: require('./ArchiveOff04Icon').default,
  ArchiveRestoreIcon: require('./ArchiveRestoreIcon').default,
  ArchiveIcon: require('./ArchiveIcon').default,
  ArchiveXIcon: require('./ArchiveXIcon').default,
  ArmchairIcon: require('./ArmchairIcon').default,
  ArmoredBootIcon: require('./ArmoredBootIcon').default,
  ArrangeByLettersAZIcon: require('./ArrangeByLettersAZIcon').default,
  ArrangeByLettersZAIcon: require('./ArrangeByLettersZAIcon').default,
  ArrangeByNumbersOneNineIcon: require('./ArrangeByNumbersOneNineIcon').default,
  ArrangeByNumbersNineOneIcon: require('./ArrangeByNumbersNineOneIcon').default,
  ArrangeIcon: require('./ArrangeIcon').default,
  ArrowAllDirectionIcon: require('./ArrowAllDirectionIcon').default,
  ArrowBigDownDashIcon: require('./ArrowBigDownDashIcon').default,
  ArrowBigLeftDashIcon: require('./ArrowBigLeftDashIcon').default,
  ArrowBigRightDashIcon: require('./ArrowBigRightDashIcon').default,
  ArrowBigUpDashIcon: require('./ArrowBigUpDashIcon').default,
  ArrowDataTransferDiagonalIcon: require('./ArrowDataTransferDiagonalIcon').default,
  ArrowDataTransferHorizontalIcon: require('./ArrowDataTransferHorizontalIcon').default,
  ArrowDataTransferVerticalIcon: require('./ArrowDataTransferVerticalIcon').default,
  ArrowDiagonalIcon: require('./ArrowDiagonalIcon').default,
  ArrowDownZeroOneIcon: require('./ArrowDownZeroOneIcon').default,
  ArrowDown01Icon: require('./ArrowDown01Icon').default,
  ArrowDown02Icon: require('./ArrowDown02Icon').default,
  ArrowDown03Icon: require('./ArrowDown03Icon').default,
  ArrowDown04Icon: require('./ArrowDown04Icon').default,
  ArrowDown05Icon: require('./ArrowDown05Icon').default,
  ArrowDownOneZeroIcon: require('./ArrowDownOneZeroIcon').default,
  ArrowDownAZIcon: require('./ArrowDownAZIcon').default,
  ArrowDownAzIcon: require('./ArrowDownAzIcon').default,
  ArrowDownBigIcon: require('./ArrowDownBigIcon').default,
  ArrowDownDoubleIcon: require('./ArrowDownDoubleIcon').default,
  ArrowDownFromLineIcon: require('./ArrowDownFromLineIcon').default,
  ArrowDownLeft01Icon: require('./ArrowDownLeft01Icon').default,
  ArrowDownLeft02Icon: require('./ArrowDownLeft02Icon').default,
  ArrowDownNarrowWideIcon: require('./ArrowDownNarrowWideIcon').default,
  ArrowDownRight01Icon: require('./ArrowDownRight01Icon').default,
  ArrowDownRight02Icon: require('./ArrowDownRight02Icon').default,
  ArrowDownToDotIcon: require('./ArrowDownToDotIcon').default,
  ArrowDownToLineIcon: require('./ArrowDownToLineIcon').default,
  ArrowDownWideNarrowIcon: require('./ArrowDownWideNarrowIcon').default,
  ArrowDownZaIcon: require('./ArrowDownZaIcon').default,
  ArrowExpand01Icon: require('./ArrowExpand01Icon').default,
  ArrowExpand02Icon: require('./ArrowExpand02Icon').default,
  ArrowExpandDiagonal01Icon: require('./ArrowExpandDiagonal01Icon').default,
  ArrowExpandDiagonal02Icon: require('./ArrowExpandDiagonal02Icon').default,
  ArrowExpandIcon: require('./ArrowExpandIcon').default,
  ArrowHorizontalIcon: require('./ArrowHorizontalIcon').default,
  ArrowLeft01Icon: require('./ArrowLeft01Icon').default,
  ArrowLeft02Icon: require('./ArrowLeft02Icon').default,
  ArrowLeft03Icon: require('./ArrowLeft03Icon').default,
  ArrowLeft04Icon: require('./ArrowLeft04Icon').default,
  ArrowLeft05Icon: require('./ArrowLeft05Icon').default,
  ArrowLeftBigIcon: require('./ArrowLeftBigIcon').default,
  ArrowLeftDoubleIcon: require('./ArrowLeftDoubleIcon').default,
  ArrowLeftFromLineIcon: require('./ArrowLeftFromLineIcon').default,
  ArrowLeftRightIcon: require('./ArrowLeftRightIcon').default,
  ArrowLeftToLineIcon: require('./ArrowLeftToLineIcon').default,
  ArrowMoveDownLeftIcon: require('./ArrowMoveDownLeftIcon').default,
  ArrowMoveDownRightIcon: require('./ArrowMoveDownRightIcon').default,
  ArrowMoveLeftDownIcon: require('./ArrowMoveLeftDownIcon').default,
  ArrowMoveRightDownIcon: require('./ArrowMoveRightDownIcon').default,
  ArrowMoveUpLeftIcon: require('./ArrowMoveUpLeftIcon').default,
  ArrowMoveUpRightIcon: require('./ArrowMoveUpRightIcon').default,
  ArrowReloadHorizontalIcon: require('./ArrowReloadHorizontalIcon').default,
  ArrowReloadVerticalIcon: require('./ArrowReloadVerticalIcon').default,
  ArrowRight01Icon: require('./ArrowRight01Icon').default,
  ArrowRight02Icon: require('./ArrowRight02Icon').default,
  ArrowRight03Icon: require('./ArrowRight03Icon').default,
  ArrowRight04Icon: require('./ArrowRight04Icon').default,
  ArrowRight05Icon: require('./ArrowRight05Icon').default,
  ArrowRightBigIcon: require('./ArrowRightBigIcon').default,
  ArrowRightDoubleIcon: require('./ArrowRightDoubleIcon').default,
  ArrowRightFromLineIcon: require('./ArrowRightFromLineIcon').default,
  ArrowRightToLineIcon: require('./ArrowRightToLineIcon').default,
  ArrowShrink01Icon: require('./ArrowShrink01Icon').default,
  ArrowShrink02Icon: require('./ArrowShrink02Icon').default,
  ArrowShrinkIcon: require('./ArrowShrinkIcon').default,
  ArrowTurnBackwardIcon: require('./ArrowTurnBackwardIcon').default,
  ArrowTurnDownIcon: require('./ArrowTurnDownIcon').default,
  ArrowTurnForwardIcon: require('./ArrowTurnForwardIcon').default,
  ArrowTurnUpIcon: require('./ArrowTurnUpIcon').default,
  ArrowUpZeroOneIcon: require('./ArrowUpZeroOneIcon').default,
  ArrowUp01Icon: require('./ArrowUp01Icon').default,
  ArrowUp02Icon: require('./ArrowUp02Icon').default,
  ArrowUp03Icon: require('./ArrowUp03Icon').default,
  ArrowUp04Icon: require('./ArrowUp04Icon').default,
  ArrowUp05Icon: require('./ArrowUp05Icon').default,
  ArrowUpOneZeroIcon: require('./ArrowUpOneZeroIcon').default,
  ArrowUpAzIcon: require('./ArrowUpAzIcon').default,
  ArrowUpBigIcon: require('./ArrowUpBigIcon').default,
  ArrowUpDoubleIcon: require('./ArrowUpDoubleIcon').default,
  ArrowUpDownIcon: require('./ArrowUpDownIcon').default,
  ArrowUpFromDotIcon: require('./ArrowUpFromDotIcon').default,
  ArrowUpFromLineIcon: require('./ArrowUpFromLineIcon').default,
  ArrowUpLeft01Icon: require('./ArrowUpLeft01Icon').default,
  ArrowUpLeft02Icon: require('./ArrowUpLeft02Icon').default,
  ArrowUpNarrowWideIcon: require('./ArrowUpNarrowWideIcon').default,
  ArrowUpRight01Icon: require('./ArrowUpRight01Icon').default,
  ArrowUpRight02Icon: require('./ArrowUpRight02Icon').default,
  ArrowUpRight03Icon: require('./ArrowUpRight03Icon').default,
  ArrowUpRightStackIcon: require('./ArrowUpRightStackIcon').default,
  ArrowUpToLineIcon: require('./ArrowUpToLineIcon').default,
  ArrowUpWideNarrowIcon: require('./ArrowUpWideNarrowIcon').default,
  ArrowUpZAIcon: require('./ArrowUpZAIcon').default,
  ArrowUpZaIcon: require('./ArrowUpZaIcon').default,
  ArrowVerticalIcon: require('./ArrowVerticalIcon').default,
  ArrowsUpFromLineIcon: require('./ArrowsUpFromLineIcon').default,
  ArtboardIcon: require('./ArtboardIcon').default,
  ArtboardToolIcon: require('./ArtboardToolIcon').default,
  ArtificialIntelligence01Icon: require('./ArtificialIntelligence01Icon').default,
  ArtificialIntelligence02Icon: require('./ArtificialIntelligence02Icon').default,
  ArtificialIntelligence03Icon: require('./ArtificialIntelligence03Icon').default,
  ArtificialIntelligence04Icon: require('./ArtificialIntelligence04Icon').default,
  ArtificialIntelligence05Icon: require('./ArtificialIntelligence05Icon').default,
  ArtificialIntelligence06Icon: require('./ArtificialIntelligence06Icon').default,
  ArtificialIntelligence07Icon: require('./ArtificialIntelligence07Icon').default,
  ArtificialIntelligence08Icon: require('./ArtificialIntelligence08Icon').default,
  AspectRatioIcon: require('./AspectRatioIcon').default,
  AssignmentsIcon: require('./AssignmentsIcon').default,
  Asterisk02Icon: require('./Asterisk02Icon').default,
  AsteriskIcon: require('./AsteriskIcon').default,
  Asteroid01Icon: require('./Asteroid01Icon').default,
  Asteroid02Icon: require('./Asteroid02Icon').default,
  Astronaut01Icon: require('./Astronaut01Icon').default,
  Astronaut02Icon: require('./Astronaut02Icon').default,
  AtSignIcon: require('./AtSignIcon').default,
  AtIcon: require('./AtIcon').default,
  Atm01Icon: require('./Atm01Icon').default,
  Atm02Icon: require('./Atm02Icon').default,
  Atom01Icon: require('./Atom01Icon').default,
  Atom02Icon: require('./Atom02Icon').default,
  AtomicPowerIcon: require('./AtomicPowerIcon').default,
  Attachment01Icon: require('./Attachment01Icon').default,
  Attachment02Icon: require('./Attachment02Icon').default,
  AttachmentCircleIcon: require('./AttachmentCircleIcon').default,
  AttachmentSquareIcon: require('./AttachmentSquareIcon').default,
  AttachmentIcon: require('./AttachmentIcon').default,
  AuctionIcon: require('./AuctionIcon').default,
  AudioBook01Icon: require('./AudioBook01Icon').default,
  AudioBook02Icon: require('./AudioBook02Icon').default,
  AudioBook03Icon: require('./AudioBook03Icon').default,
  AudioBook04Icon: require('./AudioBook04Icon').default,
  AudioLinesIcon: require('./AudioLinesIcon').default,
  AudioWave01Icon: require('./AudioWave01Icon').default,
  AudioWave02Icon: require('./AudioWave02Icon').default,
  AudioWaveformIcon: require('./AudioWaveformIcon').default,
  Audit01Icon: require('./Audit01Icon').default,
  Audit02Icon: require('./Audit02Icon').default,
  AugmentedRealityArIcon: require('./AugmentedRealityArIcon').default,
  AuthorizedIcon: require('./AuthorizedIcon').default,
  AutoConversationsIcon: require('./AutoConversationsIcon').default,
  AutomotiveBattery01Icon: require('./AutomotiveBattery01Icon').default,
  AutomotiveBattery02Icon: require('./AutomotiveBattery02Icon').default,
  AvalancheIcon: require('./AvalancheIcon').default,
  AvocadoIcon: require('./AvocadoIcon').default,
  Award01Icon: require('./Award01Icon').default,
  Award02Icon: require('./Award02Icon').default,
  Award03Icon: require('./Award03Icon').default,
  Award04Icon: require('./Award04Icon').default,
  Award05Icon: require('./Award05Icon').default,
  AwsLambdaIcon: require('./AwsLambdaIcon').default,
  AxeIcon: require('./AxeIcon').default,
  AxisThreeDIcon: require('./AxisThreeDIcon').default,
  Baby01Icon: require('./Baby01Icon').default,
  Baby02Icon: require('./Baby02Icon').default,
  BabyBed01Icon: require('./BabyBed01Icon').default,
  BabyBed02Icon: require('./BabyBed02Icon').default,
  BabyBottleIcon: require('./BabyBottleIcon').default,
  BabyBoyDressIcon: require('./BabyBoyDressIcon').default,
  BabyGirlDressIcon: require('./BabyGirlDressIcon').default,
  BackMuscleBodyIcon: require('./BackMuscleBodyIcon').default,
  BackgroundIcon: require('./BackgroundIcon').default,
  Backpack01Icon: require('./Backpack01Icon').default,
  Backpack02Icon: require('./Backpack02Icon').default,
  Backpack03Icon: require('./Backpack03Icon').default,
  Backward01Icon: require('./Backward01Icon').default,
  Backward02Icon: require('./Backward02Icon').default,
  BacteriaIcon: require('./BacteriaIcon').default,
  BadgeAlertIcon: require('./BadgeAlertIcon').default,
  BadgeCentIcon: require('./BadgeCentIcon').default,
  BadgeCheckIcon: require('./BadgeCheckIcon').default,
  BadgeDollarSignIcon: require('./BadgeDollarSignIcon').default,
  BadgeEuroIcon: require('./BadgeEuroIcon').default,
  BadgeIndianRupeeIcon: require('./BadgeIndianRupeeIcon').default,
  BadgeInfoIcon: require('./BadgeInfoIcon').default,
  BadgeJapaneseYenIcon: require('./BadgeJapaneseYenIcon').default,
  BadgeMinusIcon: require('./BadgeMinusIcon').default,
  BadgePercentIcon: require('./BadgePercentIcon').default,
  BadgePlusIcon: require('./BadgePlusIcon').default,
  BadgePoundSterlingIcon: require('./BadgePoundSterlingIcon').default,
  BadgeQuestionMarkIcon: require('./BadgeQuestionMarkIcon').default,
  BadgeRussianRubleIcon: require('./BadgeRussianRubleIcon').default,
  BadgeIcon: require('./BadgeIcon').default,
  BadgeSwissFrancIcon: require('./BadgeSwissFrancIcon').default,
  BadgeTurkishLiraIcon: require('./BadgeTurkishLiraIcon').default,
  BadgeXIcon: require('./BadgeXIcon').default,
  BadmintonShuttleIcon: require('./BadmintonShuttleIcon').default,
  BadmintonIcon: require('./BadmintonIcon').default,
  BaggageClaimIcon: require('./BaggageClaimIcon').default,
  BalanceScaleIcon: require('./BalanceScaleIcon').default,
  BalloonIcon: require('./BalloonIcon').default,
  BalloonsIcon: require('./BalloonsIcon').default,
  BanIcon: require('./BanIcon').default,
  BananaIcon: require('./BananaIcon').default,
  BandageIcon: require('./BandageIcon').default,
  BankIcon: require('./BankIcon').default,
  BanknoteArrowDownIcon: require('./BanknoteArrowDownIcon').default,
  BanknoteArrowUpIcon: require('./BanknoteArrowUpIcon').default,
  BanknoteIcon: require('./BanknoteIcon').default,
  BanknoteXIcon: require('./BanknoteXIcon').default,
  BarChartHorizontalIcon: require('./BarChartHorizontalIcon').default,
  BarChartIcon: require('./BarChartIcon').default,
  BarCode01Icon: require('./BarCode01Icon').default,
  BarCode02Icon: require('./BarCode02Icon').default,
  BarcodeScanIcon: require('./BarcodeScanIcon').default,
  BarcodeIcon: require('./BarcodeIcon').default,
  BarnsIcon: require('./BarnsIcon').default,
  BarrelIcon: require('./BarrelIcon').default,
  BaseballBatIcon: require('./BaseballBatIcon').default,
  BaseballHelmetIcon: require('./BaseballHelmetIcon').default,
  BaseballIcon: require('./BaseballIcon').default,
  BaselineIcon: require('./BaselineIcon').default,
  BashIcon: require('./BashIcon').default,
  Basketball01Icon: require('./Basketball01Icon').default,
  Basketball02Icon: require('./Basketball02Icon').default,
  BasketballHoopIcon: require('./BasketballHoopIcon').default,
  BathIcon: require('./BathIcon').default,
  Bathtub01Icon: require('./Bathtub01Icon').default,
  Bathtub02Icon: require('./Bathtub02Icon').default,
  BatteriesEnergyIcon: require('./BatteriesEnergyIcon').default,
  BatteryCharging01Icon: require('./BatteryCharging01Icon').default,
  BatteryCharging02Icon: require('./BatteryCharging02Icon').default,
  BatteryEcoChargingIcon: require('./BatteryEcoChargingIcon').default,
  BatteryEmptyIcon: require('./BatteryEmptyIcon').default,
  BatteryFullIcon: require('./BatteryFullIcon').default,
  BatteryLowIcon: require('./BatteryLowIcon').default,
  BatteryMedium01Icon: require('./BatteryMedium01Icon').default,
  BatteryMedium02Icon: require('./BatteryMedium02Icon').default,
  BatteryPlusIcon: require('./BatteryPlusIcon').default,
  BatteryIcon: require('./BatteryIcon').default,
  BatteryWarningIcon: require('./BatteryWarningIcon').default,
  BbqGrillIcon: require('./BbqGrillIcon').default,
  Beach02Icon: require('./Beach02Icon').default,
  BeachIcon: require('./BeachIcon').default,
  BeakerIcon: require('./BeakerIcon').default,
  BeanOffIcon: require('./BeanOffIcon').default,
  BeanIcon: require('./BeanIcon').default,
  BeaterIcon: require('./BeaterIcon').default,
  BeboIcon: require('./BeboIcon').default,
  BedBunkIcon: require('./BedBunkIcon').default,
  BedDoubleIcon: require('./BedDoubleIcon').default,
  BedSingle01Icon: require('./BedSingle01Icon').default,
  BedSingle02Icon: require('./BedSingle02Icon').default,
  BedIcon: require('./BedIcon').default,
  Bedug01Icon: require('./Bedug01Icon').default,
  Bedug02Icon: require('./Bedug02Icon').default,
  BeefOffIcon: require('./BeefOffIcon').default,
  BeefIcon: require('./BeefIcon').default,
  BeerOffIcon: require('./BeerOffIcon').default,
  BeerIcon: require('./BeerIcon').default,
  Behance01Icon: require('./Behance01Icon').default,
  Behance02Icon: require('./Behance02Icon').default,
  BellDotIcon: require('./BellDotIcon').default,
  BellElectricIcon: require('./BellElectricIcon').default,
  BellMinusIcon: require('./BellMinusIcon').default,
  BellOffIcon: require('./BellOffIcon').default,
  BellPlusIcon: require('./BellPlusIcon').default,
  BellRingIcon: require('./BellRingIcon').default,
  BellIcon: require('./BellIcon').default,
  BeltIcon: require('./BeltIcon').default,
  BendToolIcon: require('./BendToolIcon').default,
  BerlinIcon: require('./BerlinIcon').default,
  BerlinTowerIcon: require('./BerlinTowerIcon').default,
  BetaIcon: require('./BetaIcon').default,
  BetweenHorizontalEndIcon: require('./BetweenHorizontalEndIcon').default,
  BetweenHorizontalStartIcon: require('./BetweenHorizontalStartIcon').default,
  BetweenVerticalEndIcon: require('./BetweenVerticalEndIcon').default,
  BetweenVerticalStartIcon: require('./BetweenVerticalStartIcon').default,
  BicepsFlexedIcon: require('./BicepsFlexedIcon').default,
  Bicycle01Icon: require('./Bicycle01Icon').default,
  BicycleIcon: require('./BicycleIcon').default,
  BikeIcon: require('./BikeIcon').default,
  Billiard01Icon: require('./Billiard01Icon').default,
  Billiard02Icon: require('./Billiard02Icon').default,
  BinaryCodeIcon: require('./BinaryCodeIcon').default,
  BinaryIcon: require('./BinaryIcon').default,
  BingIcon: require('./BingIcon').default,
  BinocularsIcon: require('./BinocularsIcon').default,
  BioEnergyIcon: require('./BioEnergyIcon').default,
  BiohazardIcon: require('./BiohazardIcon').default,
  BiomassEnergyIcon: require('./BiomassEnergyIcon').default,
  BiometricAccessIcon: require('./BiometricAccessIcon').default,
  BiometricDeviceIcon: require('./BiometricDeviceIcon').default,
  BirdIcon: require('./BirdIcon').default,
  BirdhouseIcon: require('./BirdhouseIcon').default,
  BirthdayCakeIcon: require('./BirthdayCakeIcon').default,
  BiscuitIcon: require('./BiscuitIcon').default,
  Bitcoin01Icon: require('./Bitcoin01Icon').default,
  Bitcoin02Icon: require('./Bitcoin02Icon').default,
  Bitcoin03Icon: require('./Bitcoin03Icon').default,
  Bitcoin04Icon: require('./Bitcoin04Icon').default,
  BitcoinBagIcon: require('./BitcoinBagIcon').default,
  BitcoinCircleIcon: require('./BitcoinCircleIcon').default,
  BitcoinCloudIcon: require('./BitcoinCloudIcon').default,
  BitcoinCpuIcon: require('./BitcoinCpuIcon').default,
  BitcoinCreditCardIcon: require('./BitcoinCreditCardIcon').default,
  BitcoinDatabaseIcon: require('./BitcoinDatabaseIcon').default,
  BitcoinDown01Icon: require('./BitcoinDown01Icon').default,
  BitcoinDown02Icon: require('./BitcoinDown02Icon').default,
  BitcoinEllipseIcon: require('./BitcoinEllipseIcon').default,
  BitcoinEyeIcon: require('./BitcoinEyeIcon').default,
  BitcoinFilterIcon: require('./BitcoinFilterIcon').default,
  BitcoinFlashdiskIcon: require('./BitcoinFlashdiskIcon').default,
  BitcoinGraphIcon: require('./BitcoinGraphIcon').default,
  BitcoinInvoiceIcon: require('./BitcoinInvoiceIcon').default,
  BitcoinKeyIcon: require('./BitcoinKeyIcon').default,
  BitcoinLocationIcon: require('./BitcoinLocationIcon').default,
  BitcoinLockIcon: require('./BitcoinLockIcon').default,
  BitcoinMailIcon: require('./BitcoinMailIcon').default,
  BitcoinMindIcon: require('./BitcoinMindIcon').default,
  BitcoinMoney01Icon: require('./BitcoinMoney01Icon').default,
  BitcoinMoney02Icon: require('./BitcoinMoney02Icon').default,
  BitcoinPieChartIcon: require('./BitcoinPieChartIcon').default,
  BitcoinPiggyBankIcon: require('./BitcoinPiggyBankIcon').default,
  BitcoinPresentationIcon: require('./BitcoinPresentationIcon').default,
  BitcoinReceiptIcon: require('./BitcoinReceiptIcon').default,
  BitcoinReceiveIcon: require('./BitcoinReceiveIcon').default,
  BitcoinRectangleIcon: require('./BitcoinRectangleIcon').default,
  BitcoinSafeIcon: require('./BitcoinSafeIcon').default,
  BitcoinSearchIcon: require('./BitcoinSearchIcon').default,
  BitcoinSendIcon: require('./BitcoinSendIcon').default,
  BitcoinSettingIcon: require('./BitcoinSettingIcon').default,
  BitcoinShieldIcon: require('./BitcoinShieldIcon').default,
  BitcoinShoppingIcon: require('./BitcoinShoppingIcon').default,
  BitcoinSmartphone01Icon: require('./BitcoinSmartphone01Icon').default,
  BitcoinSmartphone02Icon: require('./BitcoinSmartphone02Icon').default,
  BitcoinSquareIcon: require('./BitcoinSquareIcon').default,
  BitcoinStoreIcon: require('./BitcoinStoreIcon').default,
  BitcoinIcon: require('./BitcoinIcon').default,
  BitcoinTagIcon: require('./BitcoinTagIcon').default,
  BitcoinTargetIcon: require('./BitcoinTargetIcon').default,
  BitcoinTransactionIcon: require('./BitcoinTransactionIcon').default,
  BitcoinUp01Icon: require('./BitcoinUp01Icon').default,
  BitcoinUp02Icon: require('./BitcoinUp02Icon').default,
  BitcoinWalletIcon: require('./BitcoinWalletIcon').default,
  BitcoinWithdrawIcon: require('./BitcoinWithdrawIcon').default,
  BlackHole01Icon: require('./BlackHole01Icon').default,
  BlackHoleIcon: require('./BlackHoleIcon').default,
  BlendIcon: require('./BlendIcon').default,
  BlenderIcon: require('./BlenderIcon').default,
  BlindsIcon: require('./BlindsIcon').default,
  BlockGameIcon: require('./BlockGameIcon').default,
  Blockchain01Icon: require('./Blockchain01Icon').default,
  Blockchain02Icon: require('./Blockchain02Icon').default,
  Blockchain03Icon: require('./Blockchain03Icon').default,
  Blockchain04Icon: require('./Blockchain04Icon').default,
  Blockchain05Icon: require('./Blockchain05Icon').default,
  Blockchain06Icon: require('./Blockchain06Icon').default,
  Blockchain07Icon: require('./Blockchain07Icon').default,
  BlockedIcon: require('./BlockedIcon').default,
  BlocksIcon: require('./BlocksIcon').default,
  BloggerIcon: require('./BloggerIcon').default,
  BloodBagIcon: require('./BloodBagIcon').default,
  BloodBottleIcon: require('./BloodBottleIcon').default,
  BloodPressureIcon: require('./BloodPressureIcon').default,
  BloodIcon: require('./BloodIcon').default,
  BloodTypeIcon: require('./BloodTypeIcon').default,
  BlueskyIcon: require('./BlueskyIcon').default,
  BluetoothCircleIcon: require('./BluetoothCircleIcon').default,
  BluetoothConnectedIcon: require('./BluetoothConnectedIcon').default,
  BluetoothNotConnectedIcon: require('./BluetoothNotConnectedIcon').default,
  BluetoothOffIcon: require('./BluetoothOffIcon').default,
  BluetoothSearchIcon: require('./BluetoothSearchIcon').default,
  BluetoothSearchingIcon: require('./BluetoothSearchingIcon').default,
  BluetoothSquareIcon: require('./BluetoothSquareIcon').default,
  BluetoothIcon: require('./BluetoothIcon').default,
  BlurIcon: require('./BlurIcon').default,
  BlushBrush01Icon: require('./BlushBrush01Icon').default,
  BlushBrush02Icon: require('./BlushBrush02Icon').default,
  BoardMathIcon: require('./BoardMathIcon').default,
  BoatIcon: require('./BoatIcon').default,
  BodyArmorIcon: require('./BodyArmorIcon').default,
  BodyPartLegIcon: require('./BodyPartLegIcon').default,
  BodyPartMuscleIcon: require('./BodyPartMuscleIcon').default,
  BodyPartSixPackIcon: require('./BodyPartSixPackIcon').default,
  BodySoapIcon: require('./BodySoapIcon').default,
  BodyWeightIcon: require('./BodyWeightIcon').default,
  BoldIcon: require('./BoldIcon').default,
  BoltIcon: require('./BoltIcon').default,
  BombIcon: require('./BombIcon').default,
  Bone01Icon: require('./Bone01Icon').default,
  Bone02Icon: require('./Bone02Icon').default,
  Book01Icon: require('./Book01Icon').default,
  Book02Icon: require('./Book02Icon').default,
  Book03Icon: require('./Book03Icon').default,
  Book04Icon: require('./Book04Icon').default,
  BookAIcon: require('./BookAIcon').default,
  BookAlertIcon: require('./BookAlertIcon').default,
  BookBookmark01Icon: require('./BookBookmark01Icon').default,
  BookBookmark02Icon: require('./BookBookmark02Icon').default,
  BookCheckIcon: require('./BookCheckIcon').default,
  BookCopyIcon: require('./BookCopyIcon').default,
  BookDashedIcon: require('./BookDashedIcon').default,
  BookDownIcon: require('./BookDownIcon').default,
  BookDownloadIcon: require('./BookDownloadIcon').default,
  BookEditIcon: require('./BookEditIcon').default,
  BookHeadphonesIcon: require('./BookHeadphonesIcon').default,
  BookHeartIcon: require('./BookHeartIcon').default,
  BookImageIcon: require('./BookImageIcon').default,
  BookKeyIcon: require('./BookKeyIcon').default,
  BookLockIcon: require('./BookLockIcon').default,
  BookMarkedIcon: require('./BookMarkedIcon').default,
  BookMinusIcon: require('./BookMinusIcon').default,
  BookOpen01Icon: require('./BookOpen01Icon').default,
  BookOpen02Icon: require('./BookOpen02Icon').default,
  BookOpenCheckIcon: require('./BookOpenCheckIcon').default,
  BookOpenTextIcon: require('./BookOpenTextIcon').default,
  BookPlusIcon: require('./BookPlusIcon').default,
  BookSearchIcon: require('./BookSearchIcon').default,
  BookTextIcon: require('./BookTextIcon').default,
  BookTypeIcon: require('./BookTypeIcon').default,
  BookUpTwoIcon: require('./BookUpTwoIcon').default,
  BookUploadIcon: require('./BookUploadIcon').default,
  BookUserIcon: require('./BookUserIcon').default,
  BookXIcon: require('./BookXIcon').default,
  Bookmark01Icon: require('./Bookmark01Icon').default,
  Bookmark02Icon: require('./Bookmark02Icon').default,
  Bookmark03Icon: require('./Bookmark03Icon').default,
  BookmarkAdd01Icon: require('./BookmarkAdd01Icon').default,
  BookmarkAdd02Icon: require('./BookmarkAdd02Icon').default,
  BookmarkBlock01Icon: require('./BookmarkBlock01Icon').default,
  BookmarkBlock02Icon: require('./BookmarkBlock02Icon').default,
  BookmarkCheck01Icon: require('./BookmarkCheck01Icon').default,
  BookmarkCheck02Icon: require('./BookmarkCheck02Icon').default,
  BookmarkMinus01Icon: require('./BookmarkMinus01Icon').default,
  BookmarkMinus02Icon: require('./BookmarkMinus02Icon').default,
  BookmarkOff01Icon: require('./BookmarkOff01Icon').default,
  BookmarkOff02Icon: require('./BookmarkOff02Icon').default,
  BookmarkPlusIcon: require('./BookmarkPlusIcon').default,
  BookmarkRemove01Icon: require('./BookmarkRemove01Icon').default,
  BookmarkRemove02Icon: require('./BookmarkRemove02Icon').default,
  BookmarkXIcon: require('./BookmarkXIcon').default,
  Books01Icon: require('./Books01Icon').default,
  Books02Icon: require('./Books02Icon').default,
  Bookshelf01Icon: require('./Bookshelf01Icon').default,
  Bookshelf02Icon: require('./Bookshelf02Icon').default,
  Bookshelf03Icon: require('./Bookshelf03Icon').default,
  BoomBoxIcon: require('./BoomBoxIcon').default,
  BootstrapIcon: require('./BootstrapIcon').default,
  BorderAll01Icon: require('./BorderAll01Icon').default,
  BorderAll02Icon: require('./BorderAll02Icon').default,
  BorderBottom01Icon: require('./BorderBottom01Icon').default,
  BorderBottom02Icon: require('./BorderBottom02Icon').default,
  BorderFullIcon: require('./BorderFullIcon').default,
  BorderHorizontalIcon: require('./BorderHorizontalIcon').default,
  BorderInnerIcon: require('./BorderInnerIcon').default,
  BorderLeft01Icon: require('./BorderLeft01Icon').default,
  BorderLeft02Icon: require('./BorderLeft02Icon').default,
  BorderNone01Icon: require('./BorderNone01Icon').default,
  BorderNone02Icon: require('./BorderNone02Icon').default,
  BorderRight01Icon: require('./BorderRight01Icon').default,
  BorderRight02Icon: require('./BorderRight02Icon').default,
  BorderTop01Icon: require('./BorderTop01Icon').default,
  BorderTop02Icon: require('./BorderTop02Icon').default,
  BorderVerticalIcon: require('./BorderVerticalIcon').default,
  BorobudurIcon: require('./BorobudurIcon').default,
  BotMessageSquareIcon: require('./BotMessageSquareIcon').default,
  BotOffIcon: require('./BotOffIcon').default,
  BotIcon: require('./BotIcon').default,
  BounceLeftIcon: require('./BounceLeftIcon').default,
  BounceRightIcon: require('./BounceRightIcon').default,
  BoundingBoxIcon: require('./BoundingBoxIcon').default,
  BowArrowIcon: require('./BowArrowIcon').default,
  BowTieIcon: require('./BowTieIcon').default,
  BowlingBallIcon: require('./BowlingBallIcon').default,
  BowlingPinsIcon: require('./BowlingPinsIcon').default,
  BowlingIcon: require('./BowlingIcon').default,
  BoxIcon: require('./BoxIcon').default,
  BoxerIcon: require('./BoxerIcon').default,
  BoxesIcon: require('./BoxesIcon').default,
  BoxingBagIcon: require('./BoxingBagIcon').default,
  BoxingGlove01Icon: require('./BoxingGlove01Icon').default,
  BoxingGloveIcon: require('./BoxingGloveIcon').default,
  BracesIcon: require('./BracesIcon').default,
  BracketsIcon: require('./BracketsIcon').default,
  Brain01Icon: require('./Brain01Icon').default,
  Brain02Icon: require('./Brain02Icon').default,
  Brain03Icon: require('./Brain03Icon').default,
  BrainCircuitIcon: require('./BrainCircuitIcon').default,
  BrainCogIcon: require('./BrainCogIcon').default,
  BrainIcon: require('./BrainIcon').default,
  BrandfetchIcon: require('./BrandfetchIcon').default,
  Bread01Icon: require('./Bread01Icon').default,
  Bread02Icon: require('./Bread02Icon').default,
  Bread03Icon: require('./Bread03Icon').default,
  Bread04Icon: require('./Bread04Icon').default,
  BreastPumpIcon: require('./BreastPumpIcon').default,
  BrickWallFireIcon: require('./BrickWallFireIcon').default,
  BrickWallShieldIcon: require('./BrickWallShieldIcon').default,
  BrickWallIcon: require('./BrickWallIcon').default,
  BridgeIcon: require('./BridgeIcon').default,
  Briefcase01Icon: require('./Briefcase01Icon').default,
  Briefcase02Icon: require('./Briefcase02Icon').default,
  Briefcase03Icon: require('./Briefcase03Icon').default,
  Briefcase04Icon: require('./Briefcase04Icon').default,
  Briefcase05Icon: require('./Briefcase05Icon').default,
  Briefcase06Icon: require('./Briefcase06Icon').default,
  Briefcase07Icon: require('./Briefcase07Icon').default,
  Briefcase08Icon: require('./Briefcase08Icon').default,
  Briefcase09Icon: require('./Briefcase09Icon').default,
  BriefcaseBusinessIcon: require('./BriefcaseBusinessIcon').default,
  BriefcaseConveyorBeltIcon: require('./BriefcaseConveyorBeltIcon').default,
  BriefcaseDollarIcon: require('./BriefcaseDollarIcon').default,
  BriefcaseMedicalIcon: require('./BriefcaseMedicalIcon').default,
  BringToFrontIcon: require('./BringToFrontIcon').default,
  BroccoliIcon: require('./BroccoliIcon').default,
  BrochureIcon: require('./BrochureIcon').default,
  BrokenBoneIcon: require('./BrokenBoneIcon').default,
  BrowserIcon: require('./BrowserIcon').default,
  BrushCleaningIcon: require('./BrushCleaningIcon').default,
  BrushIcon: require('./BrushIcon').default,
  BubbleChatAddIcon: require('./BubbleChatAddIcon').default,
  BubbleChatBlockedIcon: require('./BubbleChatBlockedIcon').default,
  BubbleChatCancelIcon: require('./BubbleChatCancelIcon').default,
  BubbleChatDelayIcon: require('./BubbleChatDelayIcon').default,
  BubbleChatDoneIcon: require('./BubbleChatDoneIcon').default,
  BubbleChatDownload01Icon: require('./BubbleChatDownload01Icon').default,
  BubbleChatDownload02Icon: require('./BubbleChatDownload02Icon').default,
  BubbleChatEditIcon: require('./BubbleChatEditIcon').default,
  BubbleChatFavouriteIcon: require('./BubbleChatFavouriteIcon').default,
  BubbleChatIncomeIcon: require('./BubbleChatIncomeIcon').default,
  BubbleChatLockIcon: require('./BubbleChatLockIcon').default,
  BubbleChatNotificationIcon: require('./BubbleChatNotificationIcon').default,
  BubbleChatOutcomeIcon: require('./BubbleChatOutcomeIcon').default,
  BubbleChatPreviewIcon: require('./BubbleChatPreviewIcon').default,
  BubbleChatQuestionIcon: require('./BubbleChatQuestionIcon').default,
  BubbleChatSearchIcon: require('./BubbleChatSearchIcon').default,
  BubbleChatSecureIcon: require('./BubbleChatSecureIcon').default,
  BubbleChatSpark01Icon: require('./BubbleChatSpark01Icon').default,
  BubbleChatSparkIcon: require('./BubbleChatSparkIcon').default,
  BubbleChatIcon: require('./BubbleChatIcon').default,
  BubbleChatTemporaryIcon: require('./BubbleChatTemporaryIcon').default,
  BubbleChatTranslateIcon: require('./BubbleChatTranslateIcon').default,
  BubbleChatUnlockIcon: require('./BubbleChatUnlockIcon').default,
  BubbleChatUploadIcon: require('./BubbleChatUploadIcon').default,
  BubbleChatUserIcon: require('./BubbleChatUserIcon').default,
  BubbleTea01Icon: require('./BubbleTea01Icon').default,
  BubbleTea02Icon: require('./BubbleTea02Icon').default,
  BubblesIcon: require('./BubblesIcon').default,
  BucketIcon: require('./BucketIcon').default,
  Bug01Icon: require('./Bug01Icon').default,
  Bug02Icon: require('./Bug02Icon').default,
  Building01Icon: require('./Building01Icon').default,
  Building02Icon: require('./Building02Icon').default,
  Building03Icon: require('./Building03Icon').default,
  Building04Icon: require('./Building04Icon').default,
  Building05Icon: require('./Building05Icon').default,
  Building06Icon: require('./Building06Icon').default,
  BulbChargingIcon: require('./BulbChargingIcon').default,
  BulbIcon: require('./BulbIcon').default,
  BulletIcon: require('./BulletIcon').default,
  BulletproofVestIcon: require('./BulletproofVestIcon').default,
  BurjAlArabIcon: require('./BurjAlArabIcon').default,
  BurningCdIcon: require('./BurningCdIcon').default,
  Bus01Icon: require('./Bus01Icon').default,
  Bus02Icon: require('./Bus02Icon').default,
  Bus03Icon: require('./Bus03Icon').default,
  BusFrontIcon: require('./BusFrontIcon').default,
  CIcon: require('./CIcon').default,
  CProgrammingIcon: require('./CProgrammingIcon').default,
  Cabinet01Icon: require('./Cabinet01Icon').default,
  Cabinet02Icon: require('./Cabinet02Icon').default,
  Cabinet03Icon: require('./Cabinet03Icon').default,
  Cabinet04Icon: require('./Cabinet04Icon').default,
  CableCarIcon: require('./CableCarIcon').default,
  CableIcon: require('./CableIcon').default,
  CactusIcon: require('./CactusIcon').default,
  CaduceusIcon: require('./CaduceusIcon').default,
  CafeIcon: require('./CafeIcon').default,
  CakeSliceIcon: require('./CakeSliceIcon').default,
  CakeIcon: require('./CakeIcon').default,
  CalculateIcon: require('./CalculateIcon').default,
  Calculator01Icon: require('./Calculator01Icon').default,
  CalculatorIcon: require('./CalculatorIcon').default,
  Calendar01Icon: require('./Calendar01Icon').default,
  Calendar02Icon: require('./Calendar02Icon').default,
  Calendar03Icon: require('./Calendar03Icon').default,
  Calendar04Icon: require('./Calendar04Icon').default,
  Calendar05Icon: require('./Calendar05Icon').default,
  CalendarAdd01Icon: require('./CalendarAdd01Icon').default,
  CalendarAdd02Icon: require('./CalendarAdd02Icon').default,
  CalendarAnalysisIcon: require('./CalendarAnalysisIcon').default,
  CalendarArrowDownIcon: require('./CalendarArrowDownIcon').default,
  CalendarArrowUpIcon: require('./CalendarArrowUpIcon').default,
  CalendarBlock01Icon: require('./CalendarBlock01Icon').default,
  CalendarBlock02Icon: require('./CalendarBlock02Icon').default,
  CalendarCheckIn01Icon: require('./CalendarCheckIn01Icon').default,
  CalendarCheckIn02Icon: require('./CalendarCheckIn02Icon').default,
  CalendarCheckOut01Icon: require('./CalendarCheckOut01Icon').default,
  CalendarCheckOut02Icon: require('./CalendarCheckOut02Icon').default,
  CalendarCheckIcon: require('./CalendarCheckIcon').default,
  CalendarClockIcon: require('./CalendarClockIcon').default,
  CalendarCogIcon: require('./CalendarCogIcon').default,
  CalendarDaysIcon: require('./CalendarDaysIcon').default,
  CalendarDownload01Icon: require('./CalendarDownload01Icon').default,
  CalendarDownload02Icon: require('./CalendarDownload02Icon').default,
  CalendarFavorite01Icon: require('./CalendarFavorite01Icon').default,
  CalendarFavorite02Icon: require('./CalendarFavorite02Icon').default,
  CalendarFoldIcon: require('./CalendarFoldIcon').default,
  CalendarHeartIcon: require('./CalendarHeartIcon').default,
  CalendarLock01Icon: require('./CalendarLock01Icon').default,
  CalendarLock02Icon: require('./CalendarLock02Icon').default,
  CalendarLove01Icon: require('./CalendarLove01Icon').default,
  CalendarLove02Icon: require('./CalendarLove02Icon').default,
  CalendarMinus01Icon: require('./CalendarMinus01Icon').default,
  CalendarMinus02Icon: require('./CalendarMinus02Icon').default,
  CalendarMortarboardIcon: require('./CalendarMortarboardIcon').default,
  CalendarOffIcon: require('./CalendarOffIcon').default,
  CalendarPlusIcon: require('./CalendarPlusIcon').default,
  CalendarRangeIcon: require('./CalendarRangeIcon').default,
  CalendarRemove01Icon: require('./CalendarRemove01Icon').default,
  CalendarRemove02Icon: require('./CalendarRemove02Icon').default,
  CalendarSearchIcon: require('./CalendarSearchIcon').default,
  CalendarSetting01Icon: require('./CalendarSetting01Icon').default,
  CalendarSetting02Icon: require('./CalendarSetting02Icon').default,
  CalendarSyncIcon: require('./CalendarSyncIcon').default,
  CalendarUpload01Icon: require('./CalendarUpload01Icon').default,
  CalendarUpload02Icon: require('./CalendarUpload02Icon').default,
  CalendarUserIcon: require('./CalendarUserIcon').default,
  CalendarXIcon: require('./CalendarXIcon').default,
  CalendarsIcon: require('./CalendarsIcon').default,
  Call02Icon: require('./Call02Icon').default,
  CallAdd02Icon: require('./CallAdd02Icon').default,
  CallAddIcon: require('./CallAddIcon').default,
  CallBlocked02Icon: require('./CallBlocked02Icon').default,
  CallBlockedIcon: require('./CallBlockedIcon').default,
  CallDisabled02Icon: require('./CallDisabled02Icon').default,
  CallDisabledIcon: require('./CallDisabledIcon').default,
  CallDone02Icon: require('./CallDone02Icon').default,
  CallDoneIcon: require('./CallDoneIcon').default,
  CallEnd01Icon: require('./CallEnd01Icon').default,
  CallEnd02Icon: require('./CallEnd02Icon').default,
  CallEnd03Icon: require('./CallEnd03Icon').default,
  CallEnd04Icon: require('./CallEnd04Icon').default,
  CallIncoming01Icon: require('./CallIncoming01Icon').default,
  CallIncoming02Icon: require('./CallIncoming02Icon').default,
  CallIncoming03Icon: require('./CallIncoming03Icon').default,
  CallIncoming04Icon: require('./CallIncoming04Icon').default,
  CallInternal02Icon: require('./CallInternal02Icon').default,
  CallInternalIcon: require('./CallInternalIcon').default,
  CallLocked02Icon: require('./CallLocked02Icon').default,
  CallLockedIcon: require('./CallLockedIcon').default,
  CallMinus02Icon: require('./CallMinus02Icon').default,
  CallMinusIcon: require('./CallMinusIcon').default,
  CallMissed01Icon: require('./CallMissed01Icon').default,
  CallMissed02Icon: require('./CallMissed02Icon').default,
  CallMissed03Icon: require('./CallMissed03Icon').default,
  CallMissed04Icon: require('./CallMissed04Icon').default,
  CallOutgoing01Icon: require('./CallOutgoing01Icon').default,
  CallOutgoing02Icon: require('./CallOutgoing02Icon').default,
  CallOutgoing03Icon: require('./CallOutgoing03Icon').default,
  CallOutgoing04Icon: require('./CallOutgoing04Icon').default,
  CallPaused02Icon: require('./CallPaused02Icon').default,
  CallPausedIcon: require('./CallPausedIcon').default,
  CallReceived02Icon: require('./CallReceived02Icon').default,
  CallReceivedIcon: require('./CallReceivedIcon').default,
  CallRinging01Icon: require('./CallRinging01Icon').default,
  CallRinging02Icon: require('./CallRinging02Icon').default,
  CallRinging03Icon: require('./CallRinging03Icon').default,
  CallRinging04Icon: require('./CallRinging04Icon').default,
  CallSpark01Icon: require('./CallSpark01Icon').default,
  CallSpark02Icon: require('./CallSpark02Icon').default,
  CallIcon: require('./CallIcon').default,
  CallUnlocked02Icon: require('./CallUnlocked02Icon').default,
  CallUnlockedIcon: require('./CallUnlockedIcon').default,
  Calling02Icon: require('./Calling02Icon').default,
  CallingIcon: require('./CallingIcon').default,
  CamelIcon: require('./CamelIcon').default,
  Camera01Icon: require('./Camera01Icon').default,
  Camera02Icon: require('./Camera02Icon').default,
  Camera03Icon: require('./Camera03Icon').default,
  CameraAdd01Icon: require('./CameraAdd01Icon').default,
  CameraAdd02Icon: require('./CameraAdd02Icon').default,
  CameraAdd03Icon: require('./CameraAdd03Icon').default,
  CameraAiIcon: require('./CameraAiIcon').default,
  CameraAutomatically01Icon: require('./CameraAutomatically01Icon').default,
  CameraAutomatically02Icon: require('./CameraAutomatically02Icon').default,
  CameraLensIcon: require('./CameraLensIcon').default,
  CameraMicrophone01Icon: require('./CameraMicrophone01Icon').default,
  CameraMicrophone02Icon: require('./CameraMicrophone02Icon').default,
  CameraNightMode01Icon: require('./CameraNightMode01Icon').default,
  CameraNightMode02Icon: require('./CameraNightMode02Icon').default,
  CameraOff01Icon: require('./CameraOff01Icon').default,
  CameraOff02Icon: require('./CameraOff02Icon').default,
  CameraRotated01Icon: require('./CameraRotated01Icon').default,
  CameraRotated02Icon: require('./CameraRotated02Icon').default,
  CameraSmile01Icon: require('./CameraSmile01Icon').default,
  CameraSmile02Icon: require('./CameraSmile02Icon').default,
  CameraTripodIcon: require('./CameraTripodIcon').default,
  CameraVideoIcon: require('./CameraVideoIcon').default,
  CamperIcon: require('./CamperIcon').default,
  CampfireIcon: require('./CampfireIcon').default,
  Cancel01Icon: require('./Cancel01Icon').default,
  Cancel02Icon: require('./Cancel02Icon').default,
  CancelCircleHalfDotIcon: require('./CancelCircleHalfDotIcon').default,
  CancelCircleIcon: require('./CancelCircleIcon').default,
  CancelSquareIcon: require('./CancelSquareIcon').default,
  Candelier01Icon: require('./Candelier01Icon').default,
  Candelier02Icon: require('./Candelier02Icon').default,
  CandyCaneIcon: require('./CandyCaneIcon').default,
  CandyOffIcon: require('./CandyOffIcon').default,
  CandyIcon: require('./CandyIcon').default,
  CannabisOffIcon: require('./CannabisOffIcon').default,
  CannabisIcon: require('./CannabisIcon').default,
  CanvasIcon: require('./CanvasIcon').default,
  CapProjectingIcon: require('./CapProjectingIcon').default,
  CapRoundIcon: require('./CapRoundIcon').default,
  CapStraightIcon: require('./CapStraightIcon').default,
  CapIcon: require('./CapIcon').default,
  CapcutRectangleIcon: require('./CapcutRectangleIcon').default,
  CapcutIcon: require('./CapcutIcon').default,
  CaptionsOffIcon: require('./CaptionsOffIcon').default,
  CaptionsIcon: require('./CaptionsIcon').default,
  Car01Icon: require('./Car01Icon').default,
  Car02Icon: require('./Car02Icon').default,
  Car03Icon: require('./Car03Icon').default,
  Car04Icon: require('./Car04Icon').default,
  Car05Icon: require('./Car05Icon').default,
  CarAlertIcon: require('./CarAlertIcon').default,
  CarFrontIcon: require('./CarFrontIcon').default,
  CarParking01Icon: require('./CarParking01Icon').default,
  CarParking02Icon: require('./CarParking02Icon').default,
  CarSignalIcon: require('./CarSignalIcon').default,
  CarTaxiFrontIcon: require('./CarTaxiFrontIcon').default,
  CarTimeIcon: require('./CarTimeIcon').default,
  CaravanIcon: require('./CaravanIcon').default,
  CardExchange01Icon: require('./CardExchange01Icon').default,
  CardExchange02Icon: require('./CardExchange02Icon').default,
  CardSimIcon: require('./CardSimIcon').default,
  CardiganIcon: require('./CardiganIcon').default,
  Cardiogram01Icon: require('./Cardiogram01Icon').default,
  Cardiogram02Icon: require('./Cardiogram02Icon').default,
  Cards01Icon: require('./Cards01Icon').default,
  Cards02Icon: require('./Cards02Icon').default,
  CargoShipIcon: require('./CargoShipIcon').default,
  CarouselHorizontal02Icon: require('./CarouselHorizontal02Icon').default,
  CarouselHorizontalIcon: require('./CarouselHorizontalIcon').default,
  CarouselVerticalIcon: require('./CarouselVerticalIcon').default,
  CarrotIcon: require('./CarrotIcon').default,
  CaseLowerIcon: require('./CaseLowerIcon').default,
  CaseSensitiveIcon: require('./CaseSensitiveIcon').default,
  CaseUpperIcon: require('./CaseUpperIcon').default,
  Cash01Icon: require('./Cash01Icon').default,
  Cash02Icon: require('./Cash02Icon').default,
  CashbackBitcoinIcon: require('./CashbackBitcoinIcon').default,
  CashbackEuroIcon: require('./CashbackEuroIcon').default,
  CashbackPoundIcon: require('./CashbackPoundIcon').default,
  CashbackIcon: require('./CashbackIcon').default,
  CashbackYenIcon: require('./CashbackYenIcon').default,
  Cashier02Icon: require('./Cashier02Icon').default,
  CashierIcon: require('./CashierIcon').default,
  CassetteTapeIcon: require('./CassetteTapeIcon').default,
  CastIcon: require('./CastIcon').default,
  CastboxIcon: require('./CastboxIcon').default,
  Castle01Icon: require('./Castle01Icon').default,
  Castle02Icon: require('./Castle02Icon').default,
  CastleIcon: require('./CastleIcon').default,
  CatIcon: require('./CatIcon').default,
  CatalogueIcon: require('./CatalogueIcon').default,
  CayanTowerIcon: require('./CayanTowerIcon').default,
  CctvCameraIcon: require('./CctvCameraIcon').default,
  CctvOffIcon: require('./CctvOffIcon').default,
  CctvIcon: require('./CctvIcon').default,
  CdIcon: require('./CdIcon').default,
  CellsIcon: require('./CellsIcon').default,
  CellularNetworkOfflineIcon: require('./CellularNetworkOfflineIcon').default,
  CellularNetworkIcon: require('./CellularNetworkIcon').default,
  CelsiusIcon: require('./CelsiusIcon').default,
  CenterFocusIcon: require('./CenterFocusIcon').default,
  CentralShaheedMinarIcon: require('./CentralShaheedMinarIcon').default,
  CentralizedIcon: require('./CentralizedIcon').default,
  Certificate01Icon: require('./Certificate01Icon').default,
  Certificate02Icon: require('./Certificate02Icon').default,
  Chair01Icon: require('./Chair01Icon').default,
  Chair02Icon: require('./Chair02Icon').default,
  Chair03Icon: require('./Chair03Icon').default,
  Chair04Icon: require('./Chair04Icon').default,
  Chair05Icon: require('./Chair05Icon').default,
  ChairBarberIcon: require('./ChairBarberIcon').default,
  ChampionIcon: require('./ChampionIcon').default,
  ChangeScreenModeIcon: require('./ChangeScreenModeIcon').default,
  CharacterPhoneticIcon: require('./CharacterPhoneticIcon').default,
  CharityIcon: require('./CharityIcon').default,
  Chart01Icon: require('./Chart01Icon').default,
  Chart02Icon: require('./Chart02Icon').default,
  Chart03Icon: require('./Chart03Icon').default,
  ChartAnalysisIcon: require('./ChartAnalysisIcon').default,
  ChartAreaIcon: require('./ChartAreaIcon').default,
  ChartAverageIcon: require('./ChartAverageIcon').default,
  ChartBarBigIcon: require('./ChartBarBigIcon').default,
  ChartBarDecreasingIcon: require('./ChartBarDecreasingIcon').default,
  ChartBarIncreasingIcon: require('./ChartBarIncreasingIcon').default,
  ChartBarLineIcon: require('./ChartBarLineIcon').default,
  ChartBarStackedIcon: require('./ChartBarStackedIcon').default,
  ChartBreakoutCircleIcon: require('./ChartBreakoutCircleIcon').default,
  ChartBreakoutSquareIcon: require('./ChartBreakoutSquareIcon').default,
  ChartBubble01Icon: require('./ChartBubble01Icon').default,
  ChartBubble02Icon: require('./ChartBubble02Icon').default,
  ChartCandleIcon: require('./ChartCandleIcon').default,
  ChartCandlestickIcon: require('./ChartCandlestickIcon').default,
  ChartColumnBigIcon: require('./ChartColumnBigIcon').default,
  ChartColumnDecreasingIcon: require('./ChartColumnDecreasingIcon').default,
  ChartColumnIncreasingIcon: require('./ChartColumnIncreasingIcon').default,
  ChartColumnStackedIcon: require('./ChartColumnStackedIcon').default,
  ChartColumnIcon: require('./ChartColumnIcon').default,
  ChartDecreaseIcon: require('./ChartDecreaseIcon').default,
  ChartDownIcon: require('./ChartDownIcon').default,
  ChartEvaluationIcon: require('./ChartEvaluationIcon').default,
  ChartGanttIcon: require('./ChartGanttIcon').default,
  ChartHighLowIcon: require('./ChartHighLowIcon').default,
  ChartHistogramIcon: require('./ChartHistogramIcon').default,
  ChartIncreaseIcon: require('./ChartIncreaseIcon').default,
  ChartLineData01Icon: require('./ChartLineData01Icon').default,
  ChartLineData02Icon: require('./ChartLineData02Icon').default,
  ChartLineData03Icon: require('./ChartLineData03Icon').default,
  ChartLineIcon: require('./ChartLineIcon').default,
  ChartMaximumIcon: require('./ChartMaximumIcon').default,
  ChartMediumIcon: require('./ChartMediumIcon').default,
  ChartMinimumIcon: require('./ChartMinimumIcon').default,
  ChartNetworkIcon: require('./ChartNetworkIcon').default,
  ChartNoAxesColumnDecreasingIcon: require('./ChartNoAxesColumnDecreasingIcon').default,
  ChartNoAxesColumnIncreasingIcon: require('./ChartNoAxesColumnIncreasingIcon').default,
  ChartNoAxesColumnIcon: require('./ChartNoAxesColumnIcon').default,
  ChartNoAxesCombinedIcon: require('./ChartNoAxesCombinedIcon').default,
  ChartNoAxesGanttIcon: require('./ChartNoAxesGanttIcon').default,
  ChartRadarIcon: require('./ChartRadarIcon').default,
  ChartRelationshipIcon: require('./ChartRelationshipIcon').default,
  ChartRingIcon: require('./ChartRingIcon').default,
  ChartRoseIcon: require('./ChartRoseIcon').default,
  ChartScatterIcon: require('./ChartScatterIcon').default,
  ChartSplineIcon: require('./ChartSplineIcon').default,
  ChartIcon: require('./ChartIcon').default,
  ChartUpIcon: require('./ChartUpIcon').default,
  Chat01Icon: require('./Chat01Icon').default,
  ChatAdd01Icon: require('./ChatAdd01Icon').default,
  ChatAddIcon: require('./ChatAddIcon').default,
  ChatBlocked01Icon: require('./ChatBlocked01Icon').default,
  ChatBlockedIcon: require('./ChatBlockedIcon').default,
  ChatBotIcon: require('./ChatBotIcon').default,
  ChatCancel01Icon: require('./ChatCancel01Icon').default,
  ChatCancelIcon: require('./ChatCancelIcon').default,
  ChatDelay01Icon: require('./ChatDelay01Icon').default,
  ChatDelayIcon: require('./ChatDelayIcon').default,
  ChatDone01Icon: require('./ChatDone01Icon').default,
  ChatDoneIcon: require('./ChatDoneIcon').default,
  ChatDownload01Icon: require('./ChatDownload01Icon').default,
  ChatDownloadIcon: require('./ChatDownloadIcon').default,
  ChatEdit01Icon: require('./ChatEdit01Icon').default,
  ChatEditIcon: require('./ChatEditIcon').default,
  ChatFavourite01Icon: require('./ChatFavourite01Icon').default,
  ChatFavouriteIcon: require('./ChatFavouriteIcon').default,
  ChatFeedback01Icon: require('./ChatFeedback01Icon').default,
  ChatFeedbackIcon: require('./ChatFeedbackIcon').default,
  ChatGptIcon: require('./ChatGptIcon').default,
  ChatIncome01Icon: require('./ChatIncome01Icon').default,
  ChatIncomeIcon: require('./ChatIncomeIcon').default,
  ChatLock01Icon: require('./ChatLock01Icon').default,
  ChatLockIcon: require('./ChatLockIcon').default,
  ChatNotification01Icon: require('./ChatNotification01Icon').default,
  ChatNotificationIcon: require('./ChatNotificationIcon').default,
  ChatOutcome01Icon: require('./ChatOutcome01Icon').default,
  ChatOutcomeIcon: require('./ChatOutcomeIcon').default,
  ChatPreview01Icon: require('./ChatPreview01Icon').default,
  ChatPreviewIcon: require('./ChatPreviewIcon').default,
  ChatQuestion01Icon: require('./ChatQuestion01Icon').default,
  ChatQuestionIcon: require('./ChatQuestionIcon').default,
  ChatSearch01Icon: require('./ChatSearch01Icon').default,
  ChatSearchIcon: require('./ChatSearchIcon').default,
  ChatSecure01Icon: require('./ChatSecure01Icon').default,
  ChatSecureIcon: require('./ChatSecureIcon').default,
  ChatSpark01Icon: require('./ChatSpark01Icon').default,
  ChatSparkIcon: require('./ChatSparkIcon').default,
  ChatIcon: require('./ChatIcon').default,
  ChatTranslate01Icon: require('./ChatTranslate01Icon').default,
  ChatTranslateIcon: require('./ChatTranslateIcon').default,
  ChatUnlock01Icon: require('./ChatUnlock01Icon').default,
  ChatUnlockIcon: require('./ChatUnlockIcon').default,
  ChatUpload01Icon: require('./ChatUpload01Icon').default,
  ChatUploadIcon: require('./ChatUploadIcon').default,
  ChatUser01Icon: require('./ChatUser01Icon').default,
  ChatUserIcon: require('./ChatUserIcon').default,
  Chatting01Icon: require('./Chatting01Icon').default,
  CheckCheckIcon: require('./CheckCheckIcon').default,
  CheckLineIcon: require('./CheckLineIcon').default,
  CheckListIcon: require('./CheckListIcon').default,
  CheckIcon: require('./CheckIcon').default,
  CheckUnread01Icon: require('./CheckUnread01Icon').default,
  CheckUnread02Icon: require('./CheckUnread02Icon').default,
  CheckUnread03Icon: require('./CheckUnread03Icon').default,
  CheckUnread04Icon: require('./CheckUnread04Icon').default,
  CheckmarkBadge01Icon: require('./CheckmarkBadge01Icon').default,
  CheckmarkBadge02Icon: require('./CheckmarkBadge02Icon').default,
  CheckmarkBadge03Icon: require('./CheckmarkBadge03Icon').default,
  CheckmarkBadge04Icon: require('./CheckmarkBadge04Icon').default,
  CheckmarkCircle01Icon: require('./CheckmarkCircle01Icon').default,
  CheckmarkCircle02Icon: require('./CheckmarkCircle02Icon').default,
  CheckmarkCircle03Icon: require('./CheckmarkCircle03Icon').default,
  CheckmarkCircle04Icon: require('./CheckmarkCircle04Icon').default,
  CheckmarkSquare01Icon: require('./CheckmarkSquare01Icon').default,
  CheckmarkSquare02Icon: require('./CheckmarkSquare02Icon').default,
  CheckmarkSquare03Icon: require('./CheckmarkSquare03Icon').default,
  CheckmarkSquare04Icon: require('./CheckmarkSquare04Icon').default,
  CheeseCake01Icon: require('./CheeseCake01Icon').default,
  CheeseCake02Icon: require('./CheeseCake02Icon').default,
  CheeseIcon: require('./CheeseIcon').default,
  ChefHatIcon: require('./ChefHatIcon').default,
  ChefIcon: require('./ChefIcon').default,
  Chemistry01Icon: require('./Chemistry01Icon').default,
  Chemistry02Icon: require('./Chemistry02Icon').default,
  Chemistry03Icon: require('./Chemistry03Icon').default,
  CherryIcon: require('./CherryIcon').default,
  Chess01Icon: require('./Chess01Icon').default,
  Chess02Icon: require('./Chess02Icon').default,
  ChessBishopIcon: require('./ChessBishopIcon').default,
  ChessKingIcon: require('./ChessKingIcon').default,
  ChessKnightIcon: require('./ChessKnightIcon').default,
  ChessPawnIcon: require('./ChessPawnIcon').default,
  ChessQueenIcon: require('./ChessQueenIcon').default,
  ChessRookIcon: require('./ChessRookIcon').default,
  ChevronDoubleCloseIcon: require('./ChevronDoubleCloseIcon').default,
  ChevronDownIcon: require('./ChevronDownIcon').default,
  ChevronFirstIcon: require('./ChevronFirstIcon').default,
  ChevronLastIcon: require('./ChevronLastIcon').default,
  ChevronLeftIcon: require('./ChevronLeftIcon').default,
  ChevronRightIcon: require('./ChevronRightIcon').default,
  ChevronUpIcon: require('./ChevronUpIcon').default,
  ChevronsDownIcon: require('./ChevronsDownIcon').default,
  ChevronsDownUpIcon: require('./ChevronsDownUpIcon').default,
  ChevronsLeftRightEllipsisIcon: require('./ChevronsLeftRightEllipsisIcon').default,
  ChevronsLeftRightIcon: require('./ChevronsLeftRightIcon').default,
  ChevronsLeftIcon: require('./ChevronsLeftIcon').default,
  ChevronsRightLeftIcon: require('./ChevronsRightLeftIcon').default,
  ChevronsRightIcon: require('./ChevronsRightIcon').default,
  ChevronsUpIcon: require('./ChevronsUpIcon').default,
  ChickenThighsIcon: require('./ChickenThighsIcon').default,
  ChildIcon: require('./ChildIcon').default,
  ChimneyIcon: require('./ChimneyIcon').default,
  ChinaTempleIcon: require('./ChinaTempleIcon').default,
  Chip02Icon: require('./Chip02Icon').default,
  ChipIcon: require('./ChipIcon').default,
  ChocolateIcon: require('./ChocolateIcon').default,
  ChopsticksIcon: require('./ChopsticksIcon').default,
  ChromeIcon: require('./ChromeIcon').default,
  ChryslerIcon: require('./ChryslerIcon').default,
  ChurchIcon: require('./ChurchIcon').default,
  CigaretteOffIcon: require('./CigaretteOffIcon').default,
  CigaretteIcon: require('./CigaretteIcon').default,
  CinnamonRollIcon: require('./CinnamonRollIcon').default,
  CircleArrowDataTransferDiagonalIcon: require('./CircleArrowDataTransferDiagonalIcon').default,
  CircleArrowDataTransferHorizontalIcon: require('./CircleArrowDataTransferHorizontalIcon').default,
  CircleArrowDataTransferVerticalIcon: require('./CircleArrowDataTransferVerticalIcon').default,
  CircleArrowDiagonal01Icon: require('./CircleArrowDiagonal01Icon').default,
  CircleArrowDiagonal02Icon: require('./CircleArrowDiagonal02Icon').default,
  CircleArrowDown01Icon: require('./CircleArrowDown01Icon').default,
  CircleArrowDown02Icon: require('./CircleArrowDown02Icon').default,
  CircleArrowDown03Icon: require('./CircleArrowDown03Icon').default,
  CircleArrowDownDoubleIcon: require('./CircleArrowDownDoubleIcon').default,
  CircleArrowDownLeftIcon: require('./CircleArrowDownLeftIcon').default,
  CircleArrowDownRightIcon: require('./CircleArrowDownRightIcon').default,
  CircleArrowExpand01Icon: require('./CircleArrowExpand01Icon').default,
  CircleArrowExpand02Icon: require('./CircleArrowExpand02Icon').default,
  CircleArrowHorizontalIcon: require('./CircleArrowHorizontalIcon').default,
  CircleArrowLeft01Icon: require('./CircleArrowLeft01Icon').default,
  CircleArrowLeft02Icon: require('./CircleArrowLeft02Icon').default,
  CircleArrowLeft03Icon: require('./CircleArrowLeft03Icon').default,
  CircleArrowLeftDoubleIcon: require('./CircleArrowLeftDoubleIcon').default,
  CircleArrowLeftRightIcon: require('./CircleArrowLeftRightIcon').default,
  CircleArrowMoveDownLeftIcon: require('./CircleArrowMoveDownLeftIcon').default,
  CircleArrowMoveDownRightIcon: require('./CircleArrowMoveDownRightIcon').default,
  CircleArrowMoveLeftDownIcon: require('./CircleArrowMoveLeftDownIcon').default,
  CircleArrowMoveRightDownIcon: require('./CircleArrowMoveRightDownIcon').default,
  CircleArrowMoveUpLeftIcon: require('./CircleArrowMoveUpLeftIcon').default,
  CircleArrowMoveUpRightIcon: require('./CircleArrowMoveUpRightIcon').default,
  CircleArrowOutDownLeftIcon: require('./CircleArrowOutDownLeftIcon').default,
  CircleArrowOutDownRightIcon: require('./CircleArrowOutDownRightIcon').default,
  CircleArrowOutUpLeftIcon: require('./CircleArrowOutUpLeftIcon').default,
  CircleArrowOutUpRightIcon: require('./CircleArrowOutUpRightIcon').default,
  CircleArrowReload01Icon: require('./CircleArrowReload01Icon').default,
  CircleArrowReload02Icon: require('./CircleArrowReload02Icon').default,
  CircleArrowRight01Icon: require('./CircleArrowRight01Icon').default,
  CircleArrowRight02Icon: require('./CircleArrowRight02Icon').default,
  CircleArrowRight03Icon: require('./CircleArrowRight03Icon').default,
  CircleArrowRightDoubleIcon: require('./CircleArrowRightDoubleIcon').default,
  CircleArrowShrink01Icon: require('./CircleArrowShrink01Icon').default,
  CircleArrowShrink02Icon: require('./CircleArrowShrink02Icon').default,
  CircleArrowUp01Icon: require('./CircleArrowUp01Icon').default,
  CircleArrowUp02Icon: require('./CircleArrowUp02Icon').default,
  CircleArrowUp03Icon: require('./CircleArrowUp03Icon').default,
  CircleArrowUpDoubleIcon: require('./CircleArrowUpDoubleIcon').default,
  CircleArrowUpDownIcon: require('./CircleArrowUpDownIcon').default,
  CircleArrowUpLeftIcon: require('./CircleArrowUpLeftIcon').default,
  CircleArrowUpRight02Icon: require('./CircleArrowUpRight02Icon').default,
  CircleArrowUpRightIcon: require('./CircleArrowUpRightIcon').default,
  CircleArrowVerticalIcon: require('./CircleArrowVerticalIcon').default,
  CircleCheckBigIcon: require('./CircleCheckBigIcon').default,
  CircleCheckIcon: require('./CircleCheckIcon').default,
  CircleChevronDownIcon: require('./CircleChevronDownIcon').default,
  CircleChevronLeftIcon: require('./CircleChevronLeftIcon').default,
  CircleChevronRightIcon: require('./CircleChevronRightIcon').default,
  CircleChevronUpIcon: require('./CircleChevronUpIcon').default,
  CircleDashedIcon: require('./CircleDashedIcon').default,
  CircleDollarSignIcon: require('./CircleDollarSignIcon').default,
  CircleDotDashedIcon: require('./CircleDotDashedIcon').default,
  CircleDotIcon: require('./CircleDotIcon').default,
  CircleEllipsisIcon: require('./CircleEllipsisIcon').default,
  CircleFadingArrowUpIcon: require('./CircleFadingArrowUpIcon').default,
  CircleFadingPlusIcon: require('./CircleFadingPlusIcon').default,
  CircleGaugeIcon: require('./CircleGaugeIcon').default,
  CircleLock01Icon: require('./CircleLock01Icon').default,
  CircleLock02Icon: require('./CircleLock02Icon').default,
  CircleLockAdd01Icon: require('./CircleLockAdd01Icon').default,
  CircleLockAdd02Icon: require('./CircleLockAdd02Icon').default,
  CircleLockCheck01Icon: require('./CircleLockCheck01Icon').default,
  CircleLockCheck02Icon: require('./CircleLockCheck02Icon').default,
  CircleLockMinus01Icon: require('./CircleLockMinus01Icon').default,
  CircleLockMinus02Icon: require('./CircleLockMinus02Icon').default,
  CircleLockRemove01Icon: require('./CircleLockRemove01Icon').default,
  CircleLockRemove02Icon: require('./CircleLockRemove02Icon').default,
  CircleMinusIcon: require('./CircleMinusIcon').default,
  CircleOffIcon: require('./CircleOffIcon').default,
  CircleParkingOffIcon: require('./CircleParkingOffIcon').default,
  CircleParkingIcon: require('./CircleParkingIcon').default,
  CirclePasswordIcon: require('./CirclePasswordIcon').default,
  CirclePileIcon: require('./CirclePileIcon').default,
  CirclePlusIcon: require('./CirclePlusIcon').default,
  CirclePoundSterlingIcon: require('./CirclePoundSterlingIcon').default,
  CirclePowerIcon: require('./CirclePowerIcon').default,
  CircleQuestionMarkIcon: require('./CircleQuestionMarkIcon').default,
  CircleSlashTwoIcon: require('./CircleSlashTwoIcon').default,
  CircleSmallIcon: require('./CircleSmallIcon').default,
  CircleIcon: require('./CircleIcon').default,
  CircleUnlock01Icon: require('./CircleUnlock01Icon').default,
  CircleUnlock02Icon: require('./CircleUnlock02Icon').default,
  CircleXIcon: require('./CircleXIcon').default,
  CircuitBoardIcon: require('./CircuitBoardIcon').default,
  CitrusIcon: require('./CitrusIcon').default,
  City01Icon: require('./City01Icon').default,
  City02Icon: require('./City02Icon').default,
  City03Icon: require('./City03Icon').default,
  ClapperboardIcon: require('./ClapperboardIcon').default,
  Clapping01Icon: require('./Clapping01Icon').default,
  Clapping02Icon: require('./Clapping02Icon').default,
  ClaudeIcon: require('./ClaudeIcon').default,
  CleanIcon: require('./CleanIcon').default,
  CleaningBucketIcon: require('./CleaningBucketIcon').default,
  ClinicIcon: require('./ClinicIcon').default,
  ClipIcon: require('./ClipIcon').default,
  ClipartsIcon: require('./ClipartsIcon').default,
  ClipboardCheckIcon: require('./ClipboardCheckIcon').default,
  ClipboardClockIcon: require('./ClipboardClockIcon').default,
  ClipboardCopyIcon: require('./ClipboardCopyIcon').default,
  ClipboardListIcon: require('./ClipboardListIcon').default,
  ClipboardMinusIcon: require('./ClipboardMinusIcon').default,
  ClipboardPasteIcon: require('./ClipboardPasteIcon').default,
  ClipboardPenLineIcon: require('./ClipboardPenLineIcon').default,
  ClipboardPenIcon: require('./ClipboardPenIcon').default,
  ClipboardPlusIcon: require('./ClipboardPlusIcon').default,
  ClipboardIcon: require('./ClipboardIcon').default,
  ClipboardTypeIcon: require('./ClipboardTypeIcon').default,
  ClipboardXIcon: require('./ClipboardXIcon').default,
  Clock01Icon: require('./Clock01Icon').default,
  Clock02Icon: require('./Clock02Icon').default,
  Clock03Icon: require('./Clock03Icon').default,
  Clock04Icon: require('./Clock04Icon').default,
  Clock05Icon: require('./Clock05Icon').default,
  ClockAddIcon: require('./ClockAddIcon').default,
  ClockAlertIcon: require('./ClockAlertIcon').default,
  ClockArrowDownIcon: require('./ClockArrowDownIcon').default,
  ClockArrowUpIcon: require('./ClockArrowUpIcon').default,
  ClockCheckIcon: require('./ClockCheckIcon').default,
  ClockFadingIcon: require('./ClockFadingIcon').default,
  ClockPlusIcon: require('./ClockPlusIcon').default,
  ClosedCaptionAltIcon: require('./ClosedCaptionAltIcon').default,
  ClosedCaptionIcon: require('./ClosedCaptionIcon').default,
  ClothesIcon: require('./ClothesIcon').default,
  CloudAlertIcon: require('./CloudAlertIcon').default,
  CloudAngledRainIcon: require('./CloudAngledRainIcon').default,
  CloudAngledRainZapIcon: require('./CloudAngledRainZapIcon').default,
  CloudAngledZapIcon: require('./CloudAngledZapIcon').default,
  CloudBackupIcon: require('./CloudBackupIcon').default,
  CloudBigRainIcon: require('./CloudBigRainIcon').default,
  CloudCheckIcon: require('./CloudCheckIcon').default,
  CloudCogIcon: require('./CloudCogIcon').default,
  CloudDownloadIcon: require('./CloudDownloadIcon').default,
  CloudDrizzleIcon: require('./CloudDrizzleIcon').default,
  CloudFastWindIcon: require('./CloudFastWindIcon').default,
  CloudFogIcon: require('./CloudFogIcon').default,
  CloudHailIcon: require('./CloudHailIcon').default,
  CloudHailstoneIcon: require('./CloudHailstoneIcon').default,
  CloudLightningIcon: require('./CloudLightningIcon').default,
  CloudLittleRainIcon: require('./CloudLittleRainIcon').default,
  CloudLittleSnowIcon: require('./CloudLittleSnowIcon').default,
  CloudLoadingIcon: require('./CloudLoadingIcon').default,
  CloudMidRainIcon: require('./CloudMidRainIcon').default,
  CloudMidSnowIcon: require('./CloudMidSnowIcon').default,
  CloudMoonRainIcon: require('./CloudMoonRainIcon').default,
  CloudOffIcon: require('./CloudOffIcon').default,
  CloudRainIcon: require('./CloudRainIcon').default,
  CloudRainWindIcon: require('./CloudRainWindIcon').default,
  CloudSavingDone01Icon: require('./CloudSavingDone01Icon').default,
  CloudSavingDone02Icon: require('./CloudSavingDone02Icon').default,
  CloudServerIcon: require('./CloudServerIcon').default,
  CloudSlowWindIcon: require('./CloudSlowWindIcon').default,
  CloudSnowIcon: require('./CloudSnowIcon').default,
  CloudIcon: require('./CloudIcon').default,
  CloudSunRainIcon: require('./CloudSunRainIcon').default,
  CloudSyncIcon: require('./CloudSyncIcon').default,
  CloudUploadIcon: require('./CloudUploadIcon').default,
  CloudyIcon: require('./CloudyIcon').default,
  CloverIcon: require('./CloverIcon').default,
  ClubIcon: require('./ClubIcon').default,
  Clubs01Icon: require('./Clubs01Icon').default,
  Clubs02Icon: require('./Clubs02Icon').default,
  CoPresentIcon: require('./CoPresentIcon').default,
  CodeCircleIcon: require('./CodeCircleIcon').default,
  CodeFolderIcon: require('./CodeFolderIcon').default,
  CodeSimpleIcon: require('./CodeSimpleIcon').default,
  CodeSquareIcon: require('./CodeSquareIcon').default,
  CodeIcon: require('./CodeIcon').default,
  CodeXmlIcon: require('./CodeXmlIcon').default,
  CodepenIcon: require('./CodepenIcon').default,
  CodesandboxIcon: require('./CodesandboxIcon').default,
  Coffee01Icon: require('./Coffee01Icon').default,
  Coffee02Icon: require('./Coffee02Icon').default,
  Coffee03Icon: require('./Coffee03Icon').default,
  Coffee04Icon: require('./Coffee04Icon').default,
  CoffeeBeansIcon: require('./CoffeeBeansIcon').default,
  CogIcon: require('./CogIcon').default,
  CoinbaseIcon: require('./CoinbaseIcon').default,
  Coins01Icon: require('./Coins01Icon').default,
  Coins02Icon: require('./Coins02Icon').default,
  CoinsBitcoinIcon: require('./CoinsBitcoinIcon').default,
  CoinsDollarIcon: require('./CoinsDollarIcon').default,
  CoinsEuroIcon: require('./CoinsEuroIcon').default,
  CoinsPoundIcon: require('./CoinsPoundIcon').default,
  CoinsSwapIcon: require('./CoinsSwapIcon').default,
  CoinsYenIcon: require('./CoinsYenIcon').default,
  CollapseIcon: require('./CollapseIcon').default,
  CollectionsBookmarkIcon: require('./CollectionsBookmarkIcon').default,
  ColorPickerIcon: require('./ColorPickerIcon').default,
  ColorsIcon: require('./ColorsIcon').default,
  ColosseumIcon: require('./ColosseumIcon').default,
  ColumnDeleteIcon: require('./ColumnDeleteIcon').default,
  ColumnInsertIcon: require('./ColumnInsertIcon').default,
  ColumnsThreeCogIcon: require('./ColumnsThreeCogIcon').default,
  CombineIcon: require('./CombineIcon').default,
  Comet01Icon: require('./Comet01Icon').default,
  Comet02Icon: require('./Comet02Icon').default,
  ComingSoon01Icon: require('./ComingSoon01Icon').default,
  ComingSoon02Icon: require('./ComingSoon02Icon').default,
  CommandLineIcon: require('./CommandLineIcon').default,
  CommandIcon: require('./CommandIcon').default,
  CommentAdd03Icon: require('./CommentAdd03Icon').default,
  CommentBlock03Icon: require('./CommentBlock03Icon').default,
  CommentRemove03Icon: require('./CommentRemove03Icon').default,
  Comment01Icon: require('./Comment01Icon').default,
  Comment02Icon: require('./Comment02Icon').default,
  Comment03Icon: require('./Comment03Icon').default,
  CommentAdd01Icon: require('./CommentAdd01Icon').default,
  CommentAdd02Icon: require('./CommentAdd02Icon').default,
  CommentBlock01Icon: require('./CommentBlock01Icon').default,
  CommentBlock02Icon: require('./CommentBlock02Icon').default,
  CommentRemove01Icon: require('./CommentRemove01Icon').default,
  CommentRemove02Icon: require('./CommentRemove02Icon').default,
  Compass01Icon: require('./Compass01Icon').default,
  CompassIcon: require('./CompassIcon').default,
  ComplaintIcon: require('./ComplaintIcon').default,
  ComponentIcon: require('./ComponentIcon').default,
  ComputerActivityIcon: require('./ComputerActivityIcon').default,
  ComputerAddIcon: require('./ComputerAddIcon').default,
  ComputerArrowDownIcon: require('./ComputerArrowDownIcon').default,
  ComputerArrowUpIcon: require('./ComputerArrowUpIcon').default,
  ComputerChartDownIcon: require('./ComputerChartDownIcon').default,
  ComputerChartUpIcon: require('./ComputerChartUpIcon').default,
  ComputerCheckIcon: require('./ComputerCheckIcon').default,
  ComputerCloudIcon: require('./ComputerCloudIcon').default,
  ComputerDesk01Icon: require('./ComputerDesk01Icon').default,
  ComputerDesk02Icon: require('./ComputerDesk02Icon').default,
  ComputerDesk03Icon: require('./ComputerDesk03Icon').default,
  ComputerDollarIcon: require('./ComputerDollarIcon').default,
  ComputerEthernetIcon: require('./ComputerEthernetIcon').default,
  ComputerPhoneSyncIcon: require('./ComputerPhoneSyncIcon').default,
  ComputerProgramming01Icon: require('./ComputerProgramming01Icon').default,
  ComputerProgramming02Icon: require('./ComputerProgramming02Icon').default,
  ComputerProtectionIcon: require('./ComputerProtectionIcon').default,
  ComputerRemoveIcon: require('./ComputerRemoveIcon').default,
  ComputerScreenShareIcon: require('./ComputerScreenShareIcon').default,
  ComputerSettingsIcon: require('./ComputerSettingsIcon').default,
  ComputerIcon: require('./ComputerIcon').default,
  ComputerTerminal01Icon: require('./ComputerTerminal01Icon').default,
  ComputerTerminal02Icon: require('./ComputerTerminal02Icon').default,
  ComputerUserIcon: require('./ComputerUserIcon').default,
  ComputerVideoCallIcon: require('./ComputerVideoCallIcon').default,
  ComputerVideoIcon: require('./ComputerVideoIcon').default,
  ConciergeBellIcon: require('./ConciergeBellIcon').default,
  Cone01Icon: require('./Cone01Icon').default,
  Cone02Icon: require('./Cone02Icon').default,
  ConferenceIcon: require('./ConferenceIcon').default,
  Configuration01Icon: require('./Configuration01Icon').default,
  Configuration02Icon: require('./Configuration02Icon').default,
  ConfusedIcon: require('./ConfusedIcon').default,
  CongruentToCircleIcon: require('./CongruentToCircleIcon').default,
  CongruentToSquareIcon: require('./CongruentToSquareIcon').default,
  CongruentToIcon: require('./CongruentToIcon').default,
  ConnectIcon: require('./ConnectIcon').default,
  ConsoleIcon: require('./ConsoleIcon').default,
  ConstellationIcon: require('./ConstellationIcon').default,
  ConstructionIcon: require('./ConstructionIcon').default,
  Contact01Icon: require('./Contact01Icon').default,
  Contact02Icon: require('./Contact02Icon').default,
  ContactBookIcon: require('./ContactBookIcon').default,
  ContactRoundIcon: require('./ContactRoundIcon').default,
  ContactIcon: require('./ContactIcon').default,
  ContainerIcon: require('./ContainerIcon').default,
  ContainerTruck01Icon: require('./ContainerTruck01Icon').default,
  ContainerTruck02Icon: require('./ContainerTruck02Icon').default,
  ContainerTruckIcon: require('./ContainerTruckIcon').default,
  ContentWritingIcon: require('./ContentWritingIcon').default,
  ContractsIcon: require('./ContractsIcon').default,
  ContrastIcon: require('./ContrastIcon').default,
  ConversationIcon: require('./ConversationIcon').default,
  CookBookIcon: require('./CookBookIcon').default,
  CookieIcon: require('./CookieIcon').default,
  CookingPotIcon: require('./CookingPotIcon').default,
  Coordinate01Icon: require('./Coordinate01Icon').default,
  Coordinate02Icon: require('./Coordinate02Icon').default,
  CopilotIcon: require('./CopilotIcon').default,
  Copy01Icon: require('./Copy01Icon').default,
  Copy02Icon: require('./Copy02Icon').default,
  CopyCheckIcon: require('./CopyCheckIcon').default,
  CopyLinkIcon: require('./CopyLinkIcon').default,
  CopyMinusIcon: require('./CopyMinusIcon').default,
  CopyPlusIcon: require('./CopyPlusIcon').default,
  CopySlashIcon: require('./CopySlashIcon').default,
  CopyIcon: require('./CopyIcon').default,
  CopyXIcon: require('./CopyXIcon').default,
  CopyleftIcon: require('./CopyleftIcon').default,
  CopyrightIcon: require('./CopyrightIcon').default,
  CornIcon: require('./CornIcon').default,
  CornerDownLeftIcon: require('./CornerDownLeftIcon').default,
  CornerDownRightIcon: require('./CornerDownRightIcon').default,
  CornerLeftDownIcon: require('./CornerLeftDownIcon').default,
  CornerLeftUpIcon: require('./CornerLeftUpIcon').default,
  CornerRightDownIcon: require('./CornerRightDownIcon').default,
  CornerRightUpIcon: require('./CornerRightUpIcon').default,
  CornerUpLeftIcon: require('./CornerUpLeftIcon').default,
  CornerUpRightIcon: require('./CornerUpRightIcon').default,
  CorporateIcon: require('./CorporateIcon').default,
  CosIcon: require('./CosIcon').default,
  Cosine01Icon: require('./Cosine01Icon').default,
  Cosine02Icon: require('./Cosine02Icon').default,
  CottageIcon: require('./CottageIcon').default,
  CottonCandyIcon: require('./CottonCandyIcon').default,
  Coupon01Icon: require('./Coupon01Icon').default,
  Coupon02Icon: require('./Coupon02Icon').default,
  Coupon03Icon: require('./Coupon03Icon').default,
  CouponPercentIcon: require('./CouponPercentIcon').default,
  CourseIcon: require('./CourseIcon').default,
  CourtHouseIcon: require('./CourtHouseIcon').default,
  CourtLawIcon: require('./CourtLawIcon').default,
  CovariateIcon: require('./CovariateIcon').default,
  CovidInfoIcon: require('./CovidInfoIcon').default,
  CowboyHatIcon: require('./CowboyHatIcon').default,
  CppIcon: require('./CppIcon').default,
  CpuChargeIcon: require('./CpuChargeIcon').default,
  CpuSettingsIcon: require('./CpuSettingsIcon').default,
  CpuIcon: require('./CpuIcon').default,
  CrabIcon: require('./CrabIcon').default,
  CraneIcon: require('./CraneIcon').default,
  CrazyIcon: require('./CrazyIcon').default,
  CreativeCommonsIcon: require('./CreativeCommonsIcon').default,
  CreativeMarketIcon: require('./CreativeMarketIcon').default,
  CreditCardAcceptIcon: require('./CreditCardAcceptIcon').default,
  CreditCardAddIcon: require('./CreditCardAddIcon').default,
  CreditCardChangeIcon: require('./CreditCardChangeIcon').default,
  CreditCardDefrostIcon: require('./CreditCardDefrostIcon').default,
  CreditCardFreezeIcon: require('./CreditCardFreezeIcon').default,
  CreditCardNotAcceptIcon: require('./CreditCardNotAcceptIcon').default,
  CreditCardNotFoundIcon: require('./CreditCardNotFoundIcon').default,
  CreditCardPosIcon: require('./CreditCardPosIcon').default,
  CreditCardIcon: require('./CreditCardIcon').default,
  CreditCardValidationIcon: require('./CreditCardValidationIcon').default,
  CricketBatIcon: require('./CricketBatIcon').default,
  CricketHelmetIcon: require('./CricketHelmetIcon').default,
  CroissantIcon: require('./CroissantIcon').default,
  CropIcon: require('./CropIcon').default,
  CrossIcon: require('./CrossIcon').default,
  CrosshairIcon: require('./CrosshairIcon').default,
  CrowdfundingIcon: require('./CrowdfundingIcon').default,
  Crown02Icon: require('./Crown02Icon').default,
  Crown03Icon: require('./Crown03Icon').default,
  CrownMinusIcon: require('./CrownMinusIcon').default,
  CrownPlusIcon: require('./CrownPlusIcon').default,
  CrownIcon: require('./CrownIcon').default,
  CryingIcon: require('./CryingIcon').default,
  CssThreeIcon: require('./CssThreeIcon').default,
  CssFile01Icon: require('./CssFile01Icon').default,
  CssFile02Icon: require('./CssFile02Icon').default,
  Csv01Icon: require('./Csv01Icon').default,
  Csv02Icon: require('./Csv02Icon').default,
  CubeIcon: require('./CubeIcon').default,
  CupSodaIcon: require('./CupSodaIcon').default,
  Cupcake01Icon: require('./Cupcake01Icon').default,
  Cupcake02Icon: require('./Cupcake02Icon').default,
  Cupcake03Icon: require('./Cupcake03Icon').default,
  CurlingIcon: require('./CurlingIcon').default,
  CurrencyIcon: require('./CurrencyIcon').default,
  Cursor01Icon: require('./Cursor01Icon').default,
  Cursor02Icon: require('./Cursor02Icon').default,
  CursorAddSelection01Icon: require('./CursorAddSelection01Icon').default,
  CursorAddSelection02Icon: require('./CursorAddSelection02Icon').default,
  CursorCircleSelection01Icon: require('./CursorCircleSelection01Icon').default,
  CursorCircleSelection02Icon: require('./CursorCircleSelection02Icon').default,
  CursorDisabled01Icon: require('./CursorDisabled01Icon').default,
  CursorDisabled02Icon: require('./CursorDisabled02Icon').default,
  CursorEdit01Icon: require('./CursorEdit01Icon').default,
  CursorEdit02Icon: require('./CursorEdit02Icon').default,
  CursorHold01Icon: require('./CursorHold01Icon').default,
  CursorHold02Icon: require('./CursorHold02Icon').default,
  CursorInWindowIcon: require('./CursorInWindowIcon').default,
  CursorInfo01Icon: require('./CursorInfo01Icon').default,
  CursorInfo02Icon: require('./CursorInfo02Icon').default,
  CursorLoading01Icon: require('./CursorLoading01Icon').default,
  CursorLoading02Icon: require('./CursorLoading02Icon').default,
  CursorMagicSelection01Icon: require('./CursorMagicSelection01Icon').default,
  CursorMagicSelection02Icon: require('./CursorMagicSelection02Icon').default,
  CursorMagicSelection03Icon: require('./CursorMagicSelection03Icon').default,
  CursorMagicSelection04Icon: require('./CursorMagicSelection04Icon').default,
  CursorMove01Icon: require('./CursorMove01Icon').default,
  CursorMove02Icon: require('./CursorMove02Icon').default,
  CursorPointer01Icon: require('./CursorPointer01Icon').default,
  CursorPointer02Icon: require('./CursorPointer02Icon').default,
  CursorProgress01Icon: require('./CursorProgress01Icon').default,
  CursorProgress02Icon: require('./CursorProgress02Icon').default,
  CursorProgress03Icon: require('./CursorProgress03Icon').default,
  CursorProgress04Icon: require('./CursorProgress04Icon').default,
  CursorRectangleSelection01Icon: require('./CursorRectangleSelection01Icon').default,
  CursorRectangleSelection02Icon: require('./CursorRectangleSelection02Icon').default,
  CursorRemoveSelection01Icon: require('./CursorRemoveSelection01Icon').default,
  CursorRemoveSelection02Icon: require('./CursorRemoveSelection02Icon').default,
  CursorTextIcon: require('./CursorTextIcon').default,
  CurtainsIcon: require('./CurtainsIcon').default,
  CurvyLeftDirectionIcon: require('./CurvyLeftDirectionIcon').default,
  CurvyLeftRightDirectionIcon: require('./CurvyLeftRightDirectionIcon').default,
  CurvyRightDirectionIcon: require('./CurvyRightDirectionIcon').default,
  CurvyUpDownDirectionIcon: require('./CurvyUpDownDirectionIcon').default,
  CustomFieldIcon: require('./CustomFieldIcon').default,
  CustomerService01Icon: require('./CustomerService01Icon').default,
  CustomerService02Icon: require('./CustomerService02Icon').default,
  CustomerServiceIcon: require('./CustomerServiceIcon').default,
  CustomerSupportIcon: require('./CustomerSupportIcon').default,
  CustomizeIcon: require('./CustomizeIcon').default,
  Cylinder01Icon: require('./Cylinder01Icon').default,
  Cylinder02Icon: require('./Cylinder02Icon').default,
  Cylinder03Icon: require('./Cylinder03Icon').default,
  Cylinder04Icon: require('./Cylinder04Icon').default,
  DamIcon: require('./DamIcon').default,
  DangerIcon: require('./DangerIcon').default,
  DarkModeIcon: require('./DarkModeIcon').default,
  DartIcon: require('./DartIcon').default,
  DashboardBrowsingIcon: require('./DashboardBrowsingIcon').default,
  DashboardCircleAddIcon: require('./DashboardCircleAddIcon').default,
  DashboardCircleEditIcon: require('./DashboardCircleEditIcon').default,
  DashboardCircleRemoveIcon: require('./DashboardCircleRemoveIcon').default,
  DashboardCircleSettingsIcon: require('./DashboardCircleSettingsIcon').default,
  DashboardCircleIcon: require('./DashboardCircleIcon').default,
  DashboardSpeed01Icon: require('./DashboardSpeed01Icon').default,
  DashboardSpeed02Icon: require('./DashboardSpeed02Icon').default,
  DashboardSquare01Icon: require('./DashboardSquare01Icon').default,
  DashboardSquare02Icon: require('./DashboardSquare02Icon').default,
  DashboardSquare03Icon: require('./DashboardSquare03Icon').default,
  DashboardSquareAddIcon: require('./DashboardSquareAddIcon').default,
  DashboardSquareEditIcon: require('./DashboardSquareEditIcon').default,
  DashboardSquareRemoveIcon: require('./DashboardSquareRemoveIcon').default,
  DashboardSquareSettingIcon: require('./DashboardSquareSettingIcon').default,
  DashedLine01Icon: require('./DashedLine01Icon').default,
  DashedLine02Icon: require('./DashedLine02Icon').default,
  DashedLineCircleIcon: require('./DashedLineCircleIcon').default,
  DataRecoveryIcon: require('./DataRecoveryIcon').default,
  Database01Icon: require('./Database01Icon').default,
  Database02Icon: require('./Database02Icon').default,
  DatabaseAddIcon: require('./DatabaseAddIcon').default,
  DatabaseBackupIcon: require('./DatabaseBackupIcon').default,
  DatabaseExpandIcon: require('./DatabaseExpandIcon').default,
  DatabaseExportIcon: require('./DatabaseExportIcon').default,
  DatabaseImportIcon: require('./DatabaseImportIcon').default,
  DatabaseLightningIcon: require('./DatabaseLightningIcon').default,
  DatabaseLockedIcon: require('./DatabaseLockedIcon').default,
  DatabaseRestoreIcon: require('./DatabaseRestoreIcon').default,
  DatabaseSearchIcon: require('./DatabaseSearchIcon').default,
  DatabaseSettingIcon: require('./DatabaseSettingIcon').default,
  DatabaseIcon: require('./DatabaseIcon').default,
  DatabaseSync01Icon: require('./DatabaseSync01Icon').default,
  DatabaseSyncIcon: require('./DatabaseSyncIcon').default,
  DatabaseZapIcon: require('./DatabaseZapIcon').default,
  DateTimeIcon: require('./DateTimeIcon').default,
  DatesIcon: require('./DatesIcon').default,
  DatevIcon: require('./DatevIcon').default,
  DeadIcon: require('./DeadIcon').default,
  DeepseekIcon: require('./DeepseekIcon').default,
  Delete01Icon: require('./Delete01Icon').default,
  Delete02Icon: require('./Delete02Icon').default,
  Delete03Icon: require('./Delete03Icon').default,
  Delete04Icon: require('./Delete04Icon').default,
  DeleteColumnIcon: require('./DeleteColumnIcon').default,
  DeletePutBackIcon: require('./DeletePutBackIcon').default,
  DeleteRowIcon: require('./DeleteRowIcon').default,
  DeleteThrowIcon: require('./DeleteThrowIcon').default,
  DeliveredSentIcon: require('./DeliveredSentIcon').default,
  DeliveryBox01Icon: require('./DeliveryBox01Icon').default,
  DeliveryBox02Icon: require('./DeliveryBox02Icon').default,
  DeliveryDelay01Icon: require('./DeliveryDelay01Icon').default,
  DeliveryDelay02Icon: require('./DeliveryDelay02Icon').default,
  DeliveryReturn01Icon: require('./DeliveryReturn01Icon').default,
  DeliveryReturn02Icon: require('./DeliveryReturn02Icon').default,
  DeliverySecure01Icon: require('./DeliverySecure01Icon').default,
  DeliverySecure02Icon: require('./DeliverySecure02Icon').default,
  DeliverySent01Icon: require('./DeliverySent01Icon').default,
  DeliverySent02Icon: require('./DeliverySent02Icon').default,
  DeliveryTracking01Icon: require('./DeliveryTracking01Icon').default,
  DeliveryTracking02Icon: require('./DeliveryTracking02Icon').default,
  DeliveryTruck01Icon: require('./DeliveryTruck01Icon').default,
  DeliveryTruck02Icon: require('./DeliveryTruck02Icon').default,
  DeliveryView01Icon: require('./DeliveryView01Icon').default,
  DeliveryView02Icon: require('./DeliveryView02Icon').default,
  DentalBracesIcon: require('./DentalBracesIcon').default,
  DentalBrokenToothIcon: require('./DentalBrokenToothIcon').default,
  DentalCareIcon: require('./DentalCareIcon').default,
  DentalToothIcon: require('./DentalToothIcon').default,
  DepartementIcon: require('./DepartementIcon').default,
  DesertIcon: require('./DesertIcon').default,
  Desk01Icon: require('./Desk01Icon').default,
  Desk02Icon: require('./Desk02Icon').default,
  DeskIcon: require('./DeskIcon').default,
  DessertIcon: require('./DessertIcon').default,
  DetergentIcon: require('./DetergentIcon').default,
  DeveloperIcon: require('./DeveloperIcon').default,
  DeviantartIcon: require('./DeviantartIcon').default,
  DeviceAccessIcon: require('./DeviceAccessIcon').default,
  DiagonalScrollPoint01Icon: require('./DiagonalScrollPoint01Icon').default,
  DiagonalScrollPoint02Icon: require('./DiagonalScrollPoint02Icon').default,
  DialpadCircle01Icon: require('./DialpadCircle01Icon').default,
  DialpadCircle02Icon: require('./DialpadCircle02Icon').default,
  DialpadSquare01Icon: require('./DialpadSquare01Icon').default,
  DialpadSquare02Icon: require('./DialpadSquare02Icon').default,
  DiameterIcon: require('./DiameterIcon').default,
  Diamond01Icon: require('./Diamond01Icon').default,
  Diamond02Icon: require('./Diamond02Icon').default,
  DiamondMinusIcon: require('./DiamondMinusIcon').default,
  DiamondPercentIcon: require('./DiamondPercentIcon').default,
  DiamondPlusIcon: require('./DiamondPlusIcon').default,
  DiamondIcon: require('./DiamondIcon').default,
  DiaperIcon: require('./DiaperIcon').default,
  DiceFaces01Icon: require('./DiceFaces01Icon').default,
  DiceFaces02Icon: require('./DiceFaces02Icon').default,
  DiceFaces03Icon: require('./DiceFaces03Icon').default,
  DiceFaces04Icon: require('./DiceFaces04Icon').default,
  DiceFaces05Icon: require('./DiceFaces05Icon').default,
  DiceFaces06Icon: require('./DiceFaces06Icon').default,
  DiceIcon: require('./DiceIcon').default,
  DicesIcon: require('./DicesIcon').default,
  DigestionIcon: require('./DigestionIcon').default,
  DiggIcon: require('./DiggIcon').default,
  DigitalClockIcon: require('./DigitalClockIcon').default,
  DimSum01Icon: require('./DimSum01Icon').default,
  DimSum02Icon: require('./DimSum02Icon').default,
  DiningTableIcon: require('./DiningTableIcon').default,
  DiplomaIcon: require('./DiplomaIcon').default,
  DirectionLeft01Icon: require('./DirectionLeft01Icon').default,
  DirectionLeft02Icon: require('./DirectionLeft02Icon').default,
  DirectionRight01Icon: require('./DirectionRight01Icon').default,
  DirectionRight02Icon: require('./DirectionRight02Icon').default,
  Directions01Icon: require('./Directions01Icon').default,
  Directions02Icon: require('./Directions02Icon').default,
  DirhamIcon: require('./DirhamIcon').default,
  Disability01Icon: require('./Disability01Icon').default,
  Disability02Icon: require('./Disability02Icon').default,
  DiscTwoIcon: require('./DiscTwoIcon').default,
  DiscThreeIcon: require('./DiscThreeIcon').default,
  DiscAlbumIcon: require('./DiscAlbumIcon').default,
  DiscIcon: require('./DiscIcon').default,
  DiscordIcon: require('./DiscordIcon').default,
  Discount01Icon: require('./Discount01Icon').default,
  DiscountIcon: require('./DiscountIcon').default,
  DiscountTag01Icon: require('./DiscountTag01Icon').default,
  DiscountTag02Icon: require('./DiscountTag02Icon').default,
  DiscoverCircleIcon: require('./DiscoverCircleIcon').default,
  DiscoverSquareIcon: require('./DiscoverSquareIcon').default,
  Dish01Icon: require('./Dish01Icon').default,
  Dish02Icon: require('./Dish02Icon').default,
  DishWasherIcon: require('./DishWasherIcon').default,
  DispleasedIcon: require('./DispleasedIcon').default,
  DistributeHorizontalCenterIcon: require('./DistributeHorizontalCenterIcon').default,
  DistributeHorizontalLeftIcon: require('./DistributeHorizontalLeftIcon').default,
  DistributeHorizontalRightIcon: require('./DistributeHorizontalRightIcon').default,
  DistributeVerticalBottomIcon: require('./DistributeVerticalBottomIcon').default,
  DistributeVerticalCenterIcon: require('./DistributeVerticalCenterIcon').default,
  DistributeVerticalTopIcon: require('./DistributeVerticalTopIcon').default,
  DistributionIcon: require('./DistributionIcon').default,
  DivideSignCircleIcon: require('./DivideSignCircleIcon').default,
  DivideSignSquareIcon: require('./DivideSignSquareIcon').default,
  DivideSignIcon: require('./DivideSignIcon').default,
  Dna01Icon: require('./Dna01Icon').default,
  DnaOffIcon: require('./DnaOffIcon').default,
  DnaIcon: require('./DnaIcon').default,
  DoNotTouch01Icon: require('./DoNotTouch01Icon').default,
  DoNotTouch02Icon: require('./DoNotTouch02Icon').default,
  Doc01Icon: require('./Doc01Icon').default,
  Doc02Icon: require('./Doc02Icon').default,
  DockIcon: require('./DockIcon').default,
  Doctor01Icon: require('./Doctor01Icon').default,
  Doctor02Icon: require('./Doctor02Icon').default,
  Doctor03Icon: require('./Doctor03Icon').default,
  DocumentAttachmentIcon: require('./DocumentAttachmentIcon').default,
  DocumentCodeIcon: require('./DocumentCodeIcon').default,
  DocumentValidationIcon: require('./DocumentValidationIcon').default,
  Dollar01Icon: require('./Dollar01Icon').default,
  Dollar02Icon: require('./Dollar02Icon').default,
  DollarCircleIcon: require('./DollarCircleIcon').default,
  DollarReceive01Icon: require('./DollarReceive01Icon').default,
  DollarReceive02Icon: require('./DollarReceive02Icon').default,
  DollarSend01Icon: require('./DollarSend01Icon').default,
  DollarSend02Icon: require('./DollarSend02Icon').default,
  DollarSignIcon: require('./DollarSignIcon').default,
  DollarSquareIcon: require('./DollarSquareIcon').default,
  DomeIcon: require('./DomeIcon').default,
  DominoIcon: require('./DominoIcon').default,
  DonutIcon: require('./DonutIcon').default,
  Door01Icon: require('./Door01Icon').default,
  Door02Icon: require('./Door02Icon').default,
  DoorClosedLockedIcon: require('./DoorClosedLockedIcon').default,
  DoorClosedIcon: require('./DoorClosedIcon').default,
  DoorLockIcon: require('./DoorLockIcon').default,
  DoorOpenIcon: require('./DoorOpenIcon').default,
  DoorIcon: require('./DoorIcon').default,
  DotIcon: require('./DotIcon').default,
  DoughnutIcon: require('./DoughnutIcon').default,
  Download01Icon: require('./Download01Icon').default,
  Download02Icon: require('./Download02Icon').default,
  Download03Icon: require('./Download03Icon').default,
  Download04Icon: require('./Download04Icon').default,
  Download05Icon: require('./Download05Icon').default,
  Download06Icon: require('./Download06Icon').default,
  DownloadCircle01Icon: require('./DownloadCircle01Icon').default,
  DownloadCircle02Icon: require('./DownloadCircle02Icon').default,
  DownloadSquare01Icon: require('./DownloadSquare01Icon').default,
  DownloadSquare02Icon: require('./DownloadSquare02Icon').default,
  DraftingCompassIcon: require('./DraftingCompassIcon').default,
  Drag01Icon: require('./Drag01Icon').default,
  Drag02Icon: require('./Drag02Icon').default,
  Drag03Icon: require('./Drag03Icon').default,
  Drag04Icon: require('./Drag04Icon').default,
  DragDropHorizontalIcon: require('./DragDropHorizontalIcon').default,
  DragDropIcon: require('./DragDropIcon').default,
  DragDropVerticalIcon: require('./DragDropVerticalIcon').default,
  DragLeft01Icon: require('./DragLeft01Icon').default,
  DragLeft02Icon: require('./DragLeft02Icon').default,
  DragLeft03Icon: require('./DragLeft03Icon').default,
  DragLeft04Icon: require('./DragLeft04Icon').default,
  DragRight01Icon: require('./DragRight01Icon').default,
  DragRight02Icon: require('./DragRight02Icon').default,
  DragRight03Icon: require('./DragRight03Icon').default,
  DragRight04Icon: require('./DragRight04Icon').default,
  DramaIcon: require('./DramaIcon').default,
  DrawingCompassIcon: require('./DrawingCompassIcon').default,
  DrawingModeIcon: require('./DrawingModeIcon').default,
  Dress01Icon: require('./Dress01Icon').default,
  Dress02Icon: require('./Dress02Icon').default,
  Dress03Icon: require('./Dress03Icon').default,
  Dress04Icon: require('./Dress04Icon').default,
  Dress05Icon: require('./Dress05Icon').default,
  Dress06Icon: require('./Dress06Icon').default,
  Dress07Icon: require('./Dress07Icon').default,
  DressingTable01Icon: require('./DressingTable01Icon').default,
  DressingTable02Icon: require('./DressingTable02Icon').default,
  DressingTable03Icon: require('./DressingTable03Icon').default,
  DribbbleIcon: require('./DribbbleIcon').default,
  DrillIcon: require('./DrillIcon').default,
  DrinkIcon: require('./DrinkIcon').default,
  DriveIcon: require('./DriveIcon').default,
  DroneIcon: require('./DroneIcon').default,
  DroolingIcon: require('./DroolingIcon').default,
  DropboxIcon: require('./DropboxIcon').default,
  DropdownFieldTypeIcon: require('./DropdownFieldTypeIcon').default,
  DropletOffIcon: require('./DropletOffIcon').default,
  DropletIcon: require('./DropletIcon').default,
  DropletsIcon: require('./DropletsIcon').default,
  DropperIcon: require('./DropperIcon').default,
  DrumIcon: require('./DrumIcon').default,
  DrumstickIcon: require('./DrumstickIcon').default,
  Ds3ToolIcon: require('./Ds3ToolIcon').default,
  DuaIcon: require('./DuaIcon').default,
  Dumbbell01Icon: require('./Dumbbell01Icon').default,
  Dumbbell02Icon: require('./Dumbbell02Icon').default,
  Dumbbell03Icon: require('./Dumbbell03Icon').default,
  DuplexIcon: require('./DuplexIcon').default,
  EarOffIcon: require('./EarOffIcon').default,
  EarRings01Icon: require('./EarRings01Icon').default,
  EarRings02Icon: require('./EarRings02Icon').default,
  EarRings03Icon: require('./EarRings03Icon').default,
  EarIcon: require('./EarIcon').default,
  EarthLockIcon: require('./EarthLockIcon').default,
  EarthIcon: require('./EarthIcon').default,
  EaseCurveControlPointsIcon: require('./EaseCurveControlPointsIcon').default,
  EaseInControlPointIcon: require('./EaseInControlPointIcon').default,
  EaseInOutIcon: require('./EaseInOutIcon').default,
  EaseInIcon: require('./EaseInIcon').default,
  EaseOutControlPointIcon: require('./EaseOutControlPointIcon').default,
  EaseOutIcon: require('./EaseOutIcon').default,
  EclipseIcon: require('./EclipseIcon').default,
  EcoEnergyIcon: require('./EcoEnergyIcon').default,
  EcoLab01Icon: require('./EcoLab01Icon').default,
  EcoLab02Icon: require('./EcoLab02Icon').default,
  EcoLabIcon: require('./EcoLabIcon').default,
  EcoPowerIcon: require('./EcoPowerIcon').default,
  EdgeStyleIcon: require('./EdgeStyleIcon').default,
  Edit01Icon: require('./Edit01Icon').default,
  Edit02Icon: require('./Edit02Icon').default,
  Edit03Icon: require('./Edit03Icon').default,
  Edit04Icon: require('./Edit04Icon').default,
  EditOff03Icon: require('./EditOff03Icon').default,
  EditOff04Icon: require('./EditOff04Icon').default,
  EditOffIcon: require('./EditOffIcon').default,
  EditRoadIcon: require('./EditRoadIcon').default,
  EditTableIcon: require('./EditTableIcon').default,
  EditUser02Icon: require('./EditUser02Icon').default,
  EggFriedIcon: require('./EggFriedIcon').default,
  EggOffIcon: require('./EggOffIcon').default,
  EggIcon: require('./EggIcon').default,
  EggsIcon: require('./EggsIcon').default,
  EidMubarakIcon: require('./EidMubarakIcon').default,
  EiffelTowerIcon: require('./EiffelTowerIcon').default,
  EightCircleIcon: require('./EightCircleIcon').default,
  EightSquareIcon: require('./EightSquareIcon').default,
  ElearningExchangeIcon: require('./ElearningExchangeIcon').default,
  ElectricHome01Icon: require('./ElectricHome01Icon').default,
  ElectricHome02Icon: require('./ElectricHome02Icon').default,
  ElectricPlugsIcon: require('./ElectricPlugsIcon').default,
  ElectricTower01Icon: require('./ElectricTower01Icon').default,
  ElectricTower02Icon: require('./ElectricTower02Icon').default,
  ElectricWireIcon: require('./ElectricWireIcon').default,
  ElectricityStackIcon: require('./ElectricityStackIcon').default,
  EllipseSelectionIcon: require('./EllipseSelectionIcon').default,
  EllipseIcon: require('./EllipseIcon').default,
  EllipsisIcon: require('./EllipsisIcon').default,
  EllipsisVerticalIcon: require('./EllipsisVerticalIcon').default,
  EncryptIcon: require('./EncryptIcon').default,
  EnergyEllipseIcon: require('./EnergyEllipseIcon').default,
  EnergyRectangleIcon: require('./EnergyRectangleIcon').default,
  EnergyIcon: require('./EnergyIcon').default,
  EngineSlashIcon: require('./EngineSlashIcon').default,
  EngineIcon: require('./EngineIcon').default,
  EnteringGeoFenceIcon: require('./EnteringGeoFenceIcon').default,
  EntranceStairsIcon: require('./EntranceStairsIcon').default,
  EnvatoIcon: require('./EnvatoIcon').default,
  EqualSignCircleIcon: require('./EqualSignCircleIcon').default,
  EqualSignSquareIcon: require('./EqualSignSquareIcon').default,
  EqualSignIcon: require('./EqualSignIcon').default,
  EquipmentBenchPressIcon: require('./EquipmentBenchPressIcon').default,
  EquipmentChestPressIcon: require('./EquipmentChestPressIcon').default,
  EquipmentGym01Icon: require('./EquipmentGym01Icon').default,
  EquipmentGym02Icon: require('./EquipmentGym02Icon').default,
  EquipmentGym03Icon: require('./EquipmentGym03Icon').default,
  EquipmentWeightliftingIcon: require('./EquipmentWeightliftingIcon').default,
  Eraser01Icon: require('./Eraser01Icon').default,
  EraserAddIcon: require('./EraserAddIcon').default,
  EraserAutoIcon: require('./EraserAutoIcon').default,
  EraserIcon: require('./EraserIcon').default,
  Estimate01Icon: require('./Estimate01Icon').default,
  Estimate02Icon: require('./Estimate02Icon').default,
  EthereumEllipseIcon: require('./EthereumEllipseIcon').default,
  EthereumRectangleIcon: require('./EthereumRectangleIcon').default,
  EthereumIcon: require('./EthereumIcon').default,
  EthernetPortIcon: require('./EthernetPortIcon').default,
  EuroCircleIcon: require('./EuroCircleIcon').default,
  EuroReceiveIcon: require('./EuroReceiveIcon').default,
  EuroSendIcon: require('./EuroSendIcon').default,
  EuroSquareIcon: require('./EuroSquareIcon').default,
  EuroIcon: require('./EuroIcon').default,
  EvChargerIcon: require('./EvChargerIcon').default,
  EvChargingIcon: require('./EvChargingIcon').default,
  EvilIcon: require('./EvilIcon').default,
  Exchange01Icon: require('./Exchange01Icon').default,
  Exchange02Icon: require('./Exchange02Icon').default,
  Exchange03Icon: require('./Exchange03Icon').default,
  ExchangeBitcoinIcon: require('./ExchangeBitcoinIcon').default,
  ExchangeDollarIcon: require('./ExchangeDollarIcon').default,
  ExclamationMarkBigSlashIcon: require('./ExclamationMarkBigSlashIcon').default,
  ExclamationMarkBigIcon: require('./ExclamationMarkBigIcon').default,
  ExclamationMarkSlashIcon: require('./ExclamationMarkSlashIcon').default,
  ExclamationMarkIcon: require('./ExclamationMarkIcon').default,
  ExpandParagraphIcon: require('./ExpandParagraphIcon').default,
  ExpandIcon: require('./ExpandIcon').default,
  ExpanderIcon: require('./ExpanderIcon').default,
  ExternalDriveIcon: require('./ExternalDriveIcon').default,
  ExternalLinkIcon: require('./ExternalLinkIcon').default,
  EyeClosedIcon: require('./EyeClosedIcon').default,
  EyeOffIcon: require('./EyeOffIcon').default,
  EyeIcon: require('./EyeIcon').default,
  FaceIdIcon: require('./FaceIdIcon').default,
  Facebook01Icon: require('./Facebook01Icon').default,
  Facebook02Icon: require('./Facebook02Icon').default,
  Factory01Icon: require('./Factory01Icon').default,
  Factory02Icon: require('./Factory02Icon').default,
  FactoryIcon: require('./FactoryIcon').default,
  FahrenheitIcon: require('./FahrenheitIcon').default,
  FallingStarIcon: require('./FallingStarIcon').default,
  Fan01Icon: require('./Fan01Icon').default,
  Fan02Icon: require('./Fan02Icon').default,
  FastForwardIcon: require('./FastForwardIcon').default,
  FastWindIcon: require('./FastWindIcon').default,
  FavouriteCircleIcon: require('./FavouriteCircleIcon').default,
  FavouriteSquareIcon: require('./FavouriteSquareIcon').default,
  FavouriteIcon: require('./FavouriteIcon').default,
  FeatherIcon: require('./FeatherIcon').default,
  Female02Icon: require('./Female02Icon').default,
  FemaleSymbolIcon: require('./FemaleSymbolIcon').default,
  FenceIcon: require('./FenceIcon').default,
  FencingMaskIcon: require('./FencingMaskIcon').default,
  FencingIcon: require('./FencingIcon').default,
  FerrisWheelIcon: require('./FerrisWheelIcon').default,
  FerryBoatIcon: require('./FerryBoatIcon').default,
  FigmaIcon: require('./FigmaIcon').default,
  File01Icon: require('./File01Icon').default,
  File02Icon: require('./File02Icon').default,
  FileAddIcon: require('./FileAddIcon').default,
  FileArchiveIcon: require('./FileArchiveIcon').default,
  FileAttachmentIcon: require('./FileAttachmentIcon').default,
  FileAudioIcon: require('./FileAudioIcon').default,
  FileAxisThreeDIcon: require('./FileAxisThreeDIcon').default,
  FileBadgeIcon: require('./FileBadgeIcon').default,
  FileBitcoinIcon: require('./FileBitcoinIcon').default,
  FileBlockIcon: require('./FileBlockIcon').default,
  FileBookmarkIcon: require('./FileBookmarkIcon').default,
  FileBoxIcon: require('./FileBoxIcon').default,
  FileBracesCornerIcon: require('./FileBracesCornerIcon').default,
  FileBracesIcon: require('./FileBracesIcon').default,
  FileChartColumnIncreasingIcon: require('./FileChartColumnIncreasingIcon').default,
  FileChartColumnIcon: require('./FileChartColumnIcon').default,
  FileChartLineIcon: require('./FileChartLineIcon').default,
  FileChartPieIcon: require('./FileChartPieIcon').default,
  FileCheckCornerIcon: require('./FileCheckCornerIcon').default,
  FileCheckIcon: require('./FileCheckIcon').default,
  FileClockIcon: require('./FileClockIcon').default,
  FileCloudIcon: require('./FileCloudIcon').default,
  FileCodeCornerIcon: require('./FileCodeCornerIcon').default,
  FileCodeIcon: require('./FileCodeIcon').default,
  FileCogIcon: require('./FileCogIcon').default,
  FileCorruptIcon: require('./FileCorruptIcon').default,
  FileDatabaseIcon: require('./FileDatabaseIcon').default,
  FileDiffIcon: require('./FileDiffIcon').default,
  FileDigitIcon: require('./FileDigitIcon').default,
  FileDollarIcon: require('./FileDollarIcon').default,
  FileDownIcon: require('./FileDownIcon').default,
  FileDownloadIcon: require('./FileDownloadIcon').default,
  FileEditIcon: require('./FileEditIcon').default,
  FileEmpty01Icon: require('./FileEmpty01Icon').default,
  FileEmpty02Icon: require('./FileEmpty02Icon').default,
  FileEuroIcon: require('./FileEuroIcon').default,
  FileExclamationPointIcon: require('./FileExclamationPointIcon').default,
  FileExportIcon: require('./FileExportIcon').default,
  FileFavouriteIcon: require('./FileFavouriteIcon').default,
  FileHeadphoneIcon: require('./FileHeadphoneIcon').default,
  FileHeartIcon: require('./FileHeartIcon').default,
  FileImageIcon: require('./FileImageIcon').default,
  FileImportIcon: require('./FileImportIcon').default,
  FileInputIcon: require('./FileInputIcon').default,
  FileKeyIcon: require('./FileKeyIcon').default,
  FileLinkIcon: require('./FileLinkIcon').default,
  FileLockIcon: require('./FileLockIcon').default,
  FileLockedIcon: require('./FileLockedIcon').default,
  FileManagementIcon: require('./FileManagementIcon').default,
  FileMinusIcon: require('./FileMinusIcon').default,
  FileMusicIcon: require('./FileMusicIcon').default,
  FileNotFoundIcon: require('./FileNotFoundIcon').default,
  FilePasteIcon: require('./FilePasteIcon').default,
  FilePenIcon: require('./FilePenIcon').default,
  FilePinIcon: require('./FilePinIcon').default,
  FilePlayIcon: require('./FilePlayIcon').default,
  FilePlusIcon: require('./FilePlusIcon').default,
  FilePoundIcon: require('./FilePoundIcon').default,
  FileQuestionMarkIcon: require('./FileQuestionMarkIcon').default,
  FileRemoveIcon: require('./FileRemoveIcon').default,
  FileScanIcon: require('./FileScanIcon').default,
  FileScriptIcon: require('./FileScriptIcon').default,
  FileSearchIcon: require('./FileSearchIcon').default,
  FileSecurityIcon: require('./FileSecurityIcon').default,
  FileShredderIcon: require('./FileShredderIcon').default,
  FileSignalIcon: require('./FileSignalIcon').default,
  FileSlidersIcon: require('./FileSlidersIcon').default,
  FileSpreadsheetIcon: require('./FileSpreadsheetIcon').default,
  FileStackIcon: require('./FileStackIcon').default,
  FileStarIcon: require('./FileStarIcon').default,
  FileSyncIcon: require('./FileSyncIcon').default,
  FileTerminalIcon: require('./FileTerminalIcon').default,
  FileTypeIcon: require('./FileTypeIcon').default,
  FileUnknownIcon: require('./FileUnknownIcon').default,
  FileUnlockedIcon: require('./FileUnlockedIcon').default,
  FileUpIcon: require('./FileUpIcon').default,
  FileUploadIcon: require('./FileUploadIcon').default,
  FileUserIcon: require('./FileUserIcon').default,
  FileValidationIcon: require('./FileValidationIcon').default,
  FileVerifiedIcon: require('./FileVerifiedIcon').default,
  FileVideoCameraIcon: require('./FileVideoCameraIcon').default,
  FileVideoIcon: require('./FileVideoIcon').default,
  FileViewIcon: require('./FileViewIcon').default,
  FileVolumeIcon: require('./FileVolumeIcon').default,
  FileXCornerIcon: require('./FileXCornerIcon').default,
  FileXIcon: require('./FileXIcon').default,
  FileYenIcon: require('./FileYenIcon').default,
  FileZipIcon: require('./FileZipIcon').default,
  Files01Icon: require('./Files01Icon').default,
  Files02Icon: require('./Files02Icon').default,
  Film01Icon: require('./Film01Icon').default,
  Film02Icon: require('./Film02Icon').default,
  FilmRoll01Icon: require('./FilmRoll01Icon').default,
  FilmRoll02Icon: require('./FilmRoll02Icon').default,
  FilterAddIcon: require('./FilterAddIcon').default,
  FilterEditIcon: require('./FilterEditIcon').default,
  FilterHorizontalIcon: require('./FilterHorizontalIcon').default,
  FilterMailCircleIcon: require('./FilterMailCircleIcon').default,
  FilterMailEditIcon: require('./FilterMailEditIcon').default,
  FilterMailRemoveIcon: require('./FilterMailRemoveIcon').default,
  FilterMailSquareIcon: require('./FilterMailSquareIcon').default,
  FilterMailIcon: require('./FilterMailIcon').default,
  FilterRemoveIcon: require('./FilterRemoveIcon').default,
  FilterResetIcon: require('./FilterResetIcon').default,
  FilterIcon: require('./FilterIcon').default,
  FilterVerticalIcon: require('./FilterVerticalIcon').default,
  FingerAccessIcon: require('./FingerAccessIcon').default,
  FingerPrintAddIcon: require('./FingerPrintAddIcon').default,
  FingerPrintCheckIcon: require('./FingerPrintCheckIcon').default,
  FingerPrintMinusIcon: require('./FingerPrintMinusIcon').default,
  FingerPrintRemoveIcon: require('./FingerPrintRemoveIcon').default,
  FingerPrintScanIcon: require('./FingerPrintScanIcon').default,
  FingerPrintIcon: require('./FingerPrintIcon').default,
  FingerprintPatternIcon: require('./FingerprintPatternIcon').default,
  FinsIcon: require('./FinsIcon').default,
  Fire02Icon: require('./Fire02Icon').default,
  Fire03Icon: require('./Fire03Icon').default,
  FireExtinguisherIcon: require('./FireExtinguisherIcon').default,
  FirePitIcon: require('./FirePitIcon').default,
  FireSecurityIcon: require('./FireSecurityIcon').default,
  FireIcon: require('./FireIcon').default,
  FirewallIcon: require('./FirewallIcon').default,
  FireworksIcon: require('./FireworksIcon').default,
  FirstAidKitIcon: require('./FirstAidKitIcon').default,
  FishFoodIcon: require('./FishFoodIcon').default,
  FishOffIcon: require('./FishOffIcon').default,
  FishIcon: require('./FishIcon').default,
  FishSymbolIcon: require('./FishSymbolIcon').default,
  FishingHookIcon: require('./FishingHookIcon').default,
  FishingRodIcon: require('./FishingRodIcon').default,
  FitToScreenIcon: require('./FitToScreenIcon').default,
  FiveCircleIcon: require('./FiveCircleIcon').default,
  FiveSquareIcon: require('./FiveSquareIcon').default,
  FiverrIcon: require('./FiverrIcon').default,
  Flag01Icon: require('./Flag01Icon').default,
  Flag02Icon: require('./Flag02Icon').default,
  Flag03Icon: require('./Flag03Icon').default,
  FlagOffIcon: require('./FlagOffIcon').default,
  FlagTriangleLeftIcon: require('./FlagTriangleLeftIcon').default,
  FlagTriangleRightIcon: require('./FlagTriangleRightIcon').default,
  FlameKindlingIcon: require('./FlameKindlingIcon').default,
  FlameIcon: require('./FlameIcon').default,
  FlashOffIcon: require('./FlashOffIcon').default,
  FlashIcon: require('./FlashIcon').default,
  FlashlightOffIcon: require('./FlashlightOffIcon').default,
  FlashlightIcon: require('./FlashlightIcon').default,
  FlaskConicalOffIcon: require('./FlaskConicalOffIcon').default,
  FlaskConicalIcon: require('./FlaskConicalIcon').default,
  FlaskRoundIcon: require('./FlaskRoundIcon').default,
  FlaticonIcon: require('./FlaticonIcon').default,
  FlickrIcon: require('./FlickrIcon').default,
  FlimSlateIcon: require('./FlimSlateIcon').default,
  FlipBottomIcon: require('./FlipBottomIcon').default,
  FlipHorizontalIcon: require('./FlipHorizontalIcon').default,
  FlipLeftIcon: require('./FlipLeftIcon').default,
  FlipPhoneIcon: require('./FlipPhoneIcon').default,
  FlipRightIcon: require('./FlipRightIcon').default,
  FlipTopIcon: require('./FlipTopIcon').default,
  FlipVerticalIcon: require('./FlipVerticalIcon').default,
  FloorPlanIcon: require('./FloorPlanIcon').default,
  FloppyDiskIcon: require('./FloppyDiskIcon').default,
  FlowCircleIcon: require('./FlowCircleIcon').default,
  FlowConnectionIcon: require('./FlowConnectionIcon').default,
  FlowSquareIcon: require('./FlowSquareIcon').default,
  FlowIcon: require('./FlowIcon').default,
  Flowchart01Icon: require('./Flowchart01Icon').default,
  Flowchart02Icon: require('./Flowchart02Icon').default,
  FlowerPotIcon: require('./FlowerPotIcon').default,
  FlowerIcon: require('./FlowerIcon').default,
  FlushedIcon: require('./FlushedIcon').default,
  FlyingHumanIcon: require('./FlyingHumanIcon').default,
  FocusPointIcon: require('./FocusPointIcon').default,
  FocusIcon: require('./FocusIcon').default,
  FoldHorizontalIcon: require('./FoldHorizontalIcon').default,
  FoldVerticalIcon: require('./FoldVerticalIcon').default,
  Folder01Icon: require('./Folder01Icon').default,
  Folder02Icon: require('./Folder02Icon').default,
  Folder03Icon: require('./Folder03Icon').default,
  FolderAddIcon: require('./FolderAddIcon').default,
  FolderArchiveIcon: require('./FolderArchiveIcon').default,
  FolderAttachmentIcon: require('./FolderAttachmentIcon').default,
  FolderAudioIcon: require('./FolderAudioIcon').default,
  FolderBlockIcon: require('./FolderBlockIcon').default,
  FolderCheckIcon: require('./FolderCheckIcon').default,
  FolderClockIcon: require('./FolderClockIcon').default,
  FolderCloudIcon: require('./FolderCloudIcon').default,
  FolderCodeIcon: require('./FolderCodeIcon').default,
  FolderCogIcon: require('./FolderCogIcon').default,
  FolderDetailsReferenceIcon: require('./FolderDetailsReferenceIcon').default,
  FolderDetailsIcon: require('./FolderDetailsIcon').default,
  FolderDotIcon: require('./FolderDotIcon').default,
  FolderDownloadIcon: require('./FolderDownloadIcon').default,
  FolderEditIcon: require('./FolderEditIcon').default,
  FolderExportIcon: require('./FolderExportIcon').default,
  FolderFavouriteIcon: require('./FolderFavouriteIcon').default,
  FolderFileStorageIcon: require('./FolderFileStorageIcon').default,
  FolderGitTwoIcon: require('./FolderGitTwoIcon').default,
  FolderGitIcon: require('./FolderGitIcon').default,
  FolderHeartIcon: require('./FolderHeartIcon').default,
  FolderImportIcon: require('./FolderImportIcon').default,
  FolderInputIcon: require('./FolderInputIcon').default,
  FolderKanbanIcon: require('./FolderKanbanIcon').default,
  FolderKeyIcon: require('./FolderKeyIcon').default,
  FolderLibraryIcon: require('./FolderLibraryIcon').default,
  FolderLinksIcon: require('./FolderLinksIcon').default,
  FolderLockedIcon: require('./FolderLockedIcon').default,
  FolderManagementIcon: require('./FolderManagementIcon').default,
  FolderMinusIcon: require('./FolderMinusIcon').default,
  FolderMusicIcon: require('./FolderMusicIcon').default,
  FolderOffIcon: require('./FolderOffIcon').default,
  FolderOpenIcon: require('./FolderOpenIcon').default,
  FolderOutputIcon: require('./FolderOutputIcon').default,
  FolderPenIcon: require('./FolderPenIcon').default,
  FolderPinIcon: require('./FolderPinIcon').default,
  FolderRemoveIcon: require('./FolderRemoveIcon').default,
  FolderRootIcon: require('./FolderRootIcon').default,
  FolderSearchTwoIcon: require('./FolderSearchTwoIcon').default,
  FolderSearchIcon: require('./FolderSearchIcon').default,
  FolderSecurityIcon: require('./FolderSecurityIcon').default,
  FolderShared01Icon: require('./FolderShared01Icon').default,
  FolderShared02Icon: require('./FolderShared02Icon').default,
  FolderShared03Icon: require('./FolderShared03Icon').default,
  FolderSymlinkIcon: require('./FolderSymlinkIcon').default,
  FolderSyncIcon: require('./FolderSyncIcon').default,
  FolderTransferIcon: require('./FolderTransferIcon').default,
  FolderTreeIcon: require('./FolderTreeIcon').default,
  FolderUnknownIcon: require('./FolderUnknownIcon').default,
  FolderUnlockedIcon: require('./FolderUnlockedIcon').default,
  FolderUploadIcon: require('./FolderUploadIcon').default,
  FolderVideoIcon: require('./FolderVideoIcon').default,
  FolderViewIcon: require('./FolderViewIcon').default,
  FolderZipIcon: require('./FolderZipIcon').default,
  FoldersIcon: require('./FoldersIcon').default,
  FootballPitchIcon: require('./FootballPitchIcon').default,
  FootballIcon: require('./FootballIcon').default,
  FootprintsIcon: require('./FootprintsIcon').default,
  ForgotPasswordIcon: require('./ForgotPasswordIcon').default,
  ForkIcon: require('./ForkIcon').default,
  ForkliftIcon: require('./ForkliftIcon').default,
  FormIcon: require('./FormIcon').default,
  ForrstIcon: require('./ForrstIcon').default,
  FortressIcon: require('./FortressIcon').default,
  Forward01Icon: require('./Forward01Icon').default,
  Forward02Icon: require('./Forward02Icon').default,
  FourCircleIcon: require('./FourCircleIcon').default,
  FourFinger02Icon: require('./FourFinger02Icon').default,
  FourFinger03Icon: require('./FourFinger03Icon').default,
  FourSquareIcon: require('./FourSquareIcon').default,
  FrameIcon: require('./FrameIcon').default,
  FramerIcon: require('./FramerIcon').default,
  FrameworksIcon: require('./FrameworksIcon').default,
  FrenchFries01Icon: require('./FrenchFries01Icon').default,
  FrenchFries02Icon: require('./FrenchFries02Icon').default,
  FridgeIcon: require('./FridgeIcon').default,
  FrisbeeIcon: require('./FrisbeeIcon').default,
  FrownIcon: require('./FrownIcon').default,
  FryIcon: require('./FryIcon').default,
  Fuel01Icon: require('./Fuel01Icon').default,
  Fuel02Icon: require('./Fuel02Icon').default,
  FuelStationIcon: require('./FuelStationIcon').default,
  FuelIcon: require('./FuelIcon').default,
  FullScreenIcon: require('./FullScreenIcon').default,
  FullSignalIcon: require('./FullSignalIcon').default,
  FunctionCircleIcon: require('./FunctionCircleIcon').default,
  FunctionOfXIcon: require('./FunctionOfXIcon').default,
  FunctionSquareIcon: require('./FunctionSquareIcon').default,
  FunctionIcon: require('./FunctionIcon').default,
  FunnelPlusIcon: require('./FunnelPlusIcon').default,
  FunnelIcon: require('./FunnelIcon').default,
  FunnelXIcon: require('./FunnelXIcon').default,
  GalaxyIcon: require('./GalaxyIcon').default,
  GalleryHorizontalEndIcon: require('./GalleryHorizontalEndIcon').default,
  GalleryHorizontalIcon: require('./GalleryHorizontalIcon').default,
  GalleryThumbnailsIcon: require('./GalleryThumbnailsIcon').default,
  GalleryVerticalEndIcon: require('./GalleryVerticalEndIcon').default,
  GalleryVerticalIcon: require('./GalleryVerticalIcon').default,
  GameController01Icon: require('./GameController01Icon').default,
  GameController02Icon: require('./GameController02Icon').default,
  GameController03Icon: require('./GameController03Icon').default,
  GameIcon: require('./GameIcon').default,
  GameboyIcon: require('./GameboyIcon').default,
  GamepadDirectionalIcon: require('./GamepadDirectionalIcon').default,
  GamepadIcon: require('./GamepadIcon').default,
  GarageIcon: require('./GarageIcon').default,
  GarbageTruckIcon: require('./GarbageTruckIcon').default,
  GarlandsIcon: require('./GarlandsIcon').default,
  GasPipeIcon: require('./GasPipeIcon').default,
  GasStoveIcon: require('./GasStoveIcon').default,
  GaugeIcon: require('./GaugeIcon').default,
  GavelIcon: require('./GavelIcon').default,
  GearsIcon: require('./GearsIcon').default,
  GemIcon: require('./GemIcon').default,
  GeologyCrustIcon: require('./GeologyCrustIcon').default,
  GeometricShapes01Icon: require('./GeometricShapes01Icon').default,
  GeometricShapes02Icon: require('./GeometricShapes02Icon').default,
  GeorgianLariIcon: require('./GeorgianLariIcon').default,
  GhostIcon: require('./GhostIcon').default,
  GibbousMoonIcon: require('./GibbousMoonIcon').default,
  Gif01Icon: require('./Gif01Icon').default,
  Gif02Icon: require('./Gif02Icon').default,
  GiftCard02Icon: require('./GiftCard02Icon').default,
  GiftCardIcon: require('./GiftCardIcon').default,
  GiftIcon: require('./GiftIcon').default,
  GitBranchMinusIcon: require('./GitBranchMinusIcon').default,
  GitBranchPlusIcon: require('./GitBranchPlusIcon').default,
  GitBranchIcon: require('./GitBranchIcon').default,
  GitCommitHorizontalIcon: require('./GitCommitHorizontalIcon').default,
  GitCommitIcon: require('./GitCommitIcon').default,
  GitCommitVerticalIcon: require('./GitCommitVerticalIcon').default,
  GitCompareArrowsIcon: require('./GitCompareArrowsIcon').default,
  GitCompareIcon: require('./GitCompareIcon').default,
  GitForkIcon: require('./GitForkIcon').default,
  GitGraphIcon: require('./GitGraphIcon').default,
  GitMergeConflictIcon: require('./GitMergeConflictIcon').default,
  GitMergeIcon: require('./GitMergeIcon').default,
  GitPullRequestArrowIcon: require('./GitPullRequestArrowIcon').default,
  GitPullRequestClosedIcon: require('./GitPullRequestClosedIcon').default,
  GitPullRequestCreateArrowIcon: require('./GitPullRequestCreateArrowIcon').default,
  GitPullRequestCreateIcon: require('./GitPullRequestCreateIcon').default,
  GitPullRequestDraftIcon: require('./GitPullRequestDraftIcon').default,
  GitPullRequestIcon: require('./GitPullRequestIcon').default,
  GitbookIcon: require('./GitbookIcon').default,
  Github01Icon: require('./Github01Icon').default,
  GithubIcon: require('./GithubIcon').default,
  GitlabIcon: require('./GitlabIcon').default,
  GiveBloodIcon: require('./GiveBloodIcon').default,
  GivePillIcon: require('./GivePillIcon').default,
  GlassWaterIcon: require('./GlassWaterIcon').default,
  GlassesIcon: require('./GlassesIcon').default,
  GlobalEditingIcon: require('./GlobalEditingIcon').default,
  GlobalEducationIcon: require('./GlobalEducationIcon').default,
  GlobalRefreshIcon: require('./GlobalRefreshIcon').default,
  GlobalSearchIcon: require('./GlobalSearchIcon').default,
  GlobalIcon: require('./GlobalIcon').default,
  Globe02Icon: require('./Globe02Icon').default,
  GlobeLockIcon: require('./GlobeLockIcon').default,
  GlobeOffIcon: require('./GlobeOffIcon').default,
  GlobeIcon: require('./GlobeIcon').default,
  GlobeXIcon: require('./GlobeXIcon').default,
  GloveIcon: require('./GloveIcon').default,
  GnomeIcon: require('./GnomeIcon').default,
  GoBackward10SecIcon: require('./GoBackward10SecIcon').default,
  GoBackward15SecIcon: require('./GoBackward15SecIcon').default,
  GoBackward30SecIcon: require('./GoBackward30SecIcon').default,
  GoBackwardFiveSecIcon: require('./GoBackwardFiveSecIcon').default,
  GoBackward60SecIcon: require('./GoBackward60SecIcon').default,
  GoForward10SecIcon: require('./GoForward10SecIcon').default,
  GoForward15SecIcon: require('./GoForward15SecIcon').default,
  GoForward30SecIcon: require('./GoForward30SecIcon').default,
  GoForwardFiveSecIcon: require('./GoForwardFiveSecIcon').default,
  GoForward60SecIcon: require('./GoForward60SecIcon').default,
  GoalIcon: require('./GoalIcon').default,
  GoldBuyIcon: require('./GoldBuyIcon').default,
  GoldIngotsIcon: require('./GoldIngotsIcon').default,
  GoldSellIcon: require('./GoldSellIcon').default,
  GoldIcon: require('./GoldIcon').default,
  GolfBallIcon: require('./GolfBallIcon').default,
  GolfBatIcon: require('./GolfBatIcon').default,
  GolfCartIcon: require('./GolfCartIcon').default,
  GolfHoleIcon: require('./GolfHoleIcon').default,
  GoogleDocIcon: require('./GoogleDocIcon').default,
  GoogleDriveIcon: require('./GoogleDriveIcon').default,
  GoogleGeminiIcon: require('./GoogleGeminiIcon').default,
  GoogleHomeIcon: require('./GoogleHomeIcon').default,
  GoogleLensIcon: require('./GoogleLensIcon').default,
  GoogleMapsIcon: require('./GoogleMapsIcon').default,
  GooglePhotosIcon: require('./GooglePhotosIcon').default,
  GoogleSheetIcon: require('./GoogleSheetIcon').default,
  GoogleIcon: require('./GoogleIcon').default,
  Gps01Icon: require('./Gps01Icon').default,
  Gps02Icon: require('./Gps02Icon').default,
  GpsDisconnectedIcon: require('./GpsDisconnectedIcon').default,
  GpsOff01Icon: require('./GpsOff01Icon').default,
  GpsOff02Icon: require('./GpsOff02Icon').default,
  GpsSignal01Icon: require('./GpsSignal01Icon').default,
  GpsSignal02Icon: require('./GpsSignal02Icon').default,
  GpuIcon: require('./GpuIcon').default,
  GraduateFemaleIcon: require('./GraduateFemaleIcon').default,
  GraduateMaleIcon: require('./GraduateMaleIcon').default,
  GraduationCapIcon: require('./GraduationCapIcon').default,
  GraduationScrollIcon: require('./GraduationScrollIcon').default,
  GrapeIcon: require('./GrapeIcon').default,
  GrapesIcon: require('./GrapesIcon').default,
  GraphicCardIcon: require('./GraphicCardIcon').default,
  GravityIcon: require('./GravityIcon').default,
  GreaterThanCircleIcon: require('./GreaterThanCircleIcon').default,
  GreaterThanSquareIcon: require('./GreaterThanSquareIcon').default,
  GreaterThanIcon: require('./GreaterThanIcon').default,
  GreekHelmetIcon: require('./GreekHelmetIcon').default,
  GreenHouseIcon: require('./GreenHouseIcon').default,
  Grid02Icon: require('./Grid02Icon').default,
  GridOffIcon: require('./GridOffIcon').default,
  GridIcon: require('./GridIcon').default,
  GridTableIcon: require('./GridTableIcon').default,
  GridViewIcon: require('./GridViewIcon').default,
  Grid2X2CheckIcon: require('./Grid2X2CheckIcon').default,
  Grid2X2PlusIcon: require('./Grid2X2PlusIcon').default,
  Grid2X2Icon: require('./Grid2X2Icon').default,
  Grid2X2XIcon: require('./Grid2X2XIcon').default,
  Grid3X2Icon: require('./Grid3X2Icon').default,
  Grid3X3Icon: require('./Grid3X3Icon').default,
  GrimacingIcon: require('./GrimacingIcon').default,
  GrinningIcon: require('./GrinningIcon').default,
  GripHorizontalIcon: require('./GripHorizontalIcon').default,
  GripIcon: require('./GripIcon').default,
  GripVerticalIcon: require('./GripVerticalIcon').default,
  Grok02Icon: require('./Grok02Icon').default,
  GrokIcon: require('./GrokIcon').default,
  Group01Icon: require('./Group01Icon').default,
  GroupItemsIcon: require('./GroupItemsIcon').default,
  GroupLayersIcon: require('./GroupLayersIcon').default,
  GroupIcon: require('./GroupIcon').default,
  GrowwIcon: require('./GrowwIcon').default,
  GuestHouseIcon: require('./GuestHouseIcon').default,
  GuitarIcon: require('./GuitarIcon').default,
  GunIcon: require('./GunIcon').default,
  GymnasticRingsIcon: require('./GymnasticRingsIcon').default,
  GymnasticIcon: require('./GymnasticIcon').default,
  HackerrankIcon: require('./HackerrankIcon').default,
  HairClipsIcon: require('./HairClipsIcon').default,
  HairDryerIcon: require('./HairDryerIcon').default,
  HajiIcon: require('./HajiIcon').default,
  HalalLabIcon: require('./HalalLabIcon').default,
  HalalIcon: require('./HalalIcon').default,
  HamIcon: require('./HamIcon').default,
  Hamburger01Icon: require('./Hamburger01Icon').default,
  Hamburger02Icon: require('./Hamburger02Icon').default,
  HammerIcon: require('./HammerIcon').default,
  HandBag01Icon: require('./HandBag01Icon').default,
  HandBag02Icon: require('./HandBag02Icon').default,
  HandBeaterIcon: require('./HandBeaterIcon').default,
  HandCoinsIcon: require('./HandCoinsIcon').default,
  HandFistIcon: require('./HandFistIcon').default,
  HandGrabIcon: require('./HandGrabIcon').default,
  HandGripIcon: require('./HandGripIcon').default,
  HandHeartIcon: require('./HandHeartIcon').default,
  HandHelpingIcon: require('./HandHelpingIcon').default,
  HandMetalIcon: require('./HandMetalIcon').default,
  HandPlatterIcon: require('./HandPlatterIcon').default,
  HandPointingDown01Icon: require('./HandPointingDown01Icon').default,
  HandPointingDown02Icon: require('./HandPointingDown02Icon').default,
  HandPointingDown03Icon: require('./HandPointingDown03Icon').default,
  HandPointingDown04Icon: require('./HandPointingDown04Icon').default,
  HandPointingLeft01Icon: require('./HandPointingLeft01Icon').default,
  HandPointingLeft02Icon: require('./HandPointingLeft02Icon').default,
  HandPointingLeft03Icon: require('./HandPointingLeft03Icon').default,
  HandPointingLeft04Icon: require('./HandPointingLeft04Icon').default,
  HandPointingRight01Icon: require('./HandPointingRight01Icon').default,
  HandPointingRight02Icon: require('./HandPointingRight02Icon').default,
  HandPointingRight03Icon: require('./HandPointingRight03Icon').default,
  HandPointingRight04Icon: require('./HandPointingRight04Icon').default,
  HandPrayerIcon: require('./HandPrayerIcon').default,
  HandSanitizerIcon: require('./HandSanitizerIcon').default,
  HandIcon: require('./HandIcon').default,
  HandbagIcon: require('./HandbagIcon').default,
  HandcuffsIcon: require('./HandcuffsIcon').default,
  HandsClappingIcon: require('./HandsClappingIcon').default,
  HandshakeIcon: require('./HandshakeIcon').default,
  HangerIcon: require('./HangerIcon').default,
  HangingClockIcon: require('./HangingClockIcon').default,
  HangoutIcon: require('./HangoutIcon').default,
  Happy01Icon: require('./Happy01Icon').default,
  HappyIcon: require('./HappyIcon').default,
  HardDriveDownloadIcon: require('./HardDriveDownloadIcon').default,
  HardDriveIcon: require('./HardDriveIcon').default,
  HardDriveUploadIcon: require('./HardDriveUploadIcon').default,
  HardHatIcon: require('./HardHatIcon').default,
  HashIcon: require('./HashIcon').default,
  HashtagIcon: require('./HashtagIcon').default,
  HatGlassesIcon: require('./HatGlassesIcon').default,
  HatIcon: require('./HatIcon').default,
  HazeIcon: require('./HazeIcon').default,
  HdIcon: require('./HdIcon').default,
  HddIcon: require('./HddIcon').default,
  HdmiPortIcon: require('./HdmiPortIcon').default,
  Hdr01Icon: require('./Hdr01Icon').default,
  Hdr02Icon: require('./Hdr02Icon').default,
  Heading01Icon: require('./Heading01Icon').default,
  Heading02Icon: require('./Heading02Icon').default,
  Heading03Icon: require('./Heading03Icon').default,
  Heading04Icon: require('./Heading04Icon').default,
  Heading05Icon: require('./Heading05Icon').default,
  Heading06Icon: require('./Heading06Icon').default,
  HeadingIcon: require('./HeadingIcon').default,
  HeadphoneMuteIcon: require('./HeadphoneMuteIcon').default,
  HeadphoneOffIcon: require('./HeadphoneOffIcon').default,
  HeadphonesIcon: require('./HeadphonesIcon').default,
  HeadsetConnectedIcon: require('./HeadsetConnectedIcon').default,
  HeadsetOffIcon: require('./HeadsetOffIcon').default,
  HeadsetIcon: require('./HeadsetIcon').default,
  HealtcareIcon: require('./HealtcareIcon').default,
  HealthIcon: require('./HealthIcon').default,
  HeartAddIcon: require('./HeartAddIcon').default,
  HeartCheckIcon: require('./HeartCheckIcon').default,
  HeartCrackIcon: require('./HeartCrackIcon').default,
  HeartHandshakeIcon: require('./HeartHandshakeIcon').default,
  HeartMinusIcon: require('./HeartMinusIcon').default,
  HeartOffIcon: require('./HeartOffIcon').default,
  HeartPlusIcon: require('./HeartPlusIcon').default,
  HeartPulseIcon: require('./HeartPulseIcon').default,
  HeartRemoveIcon: require('./HeartRemoveIcon').default,
  HeartIcon: require('./HeartIcon').default,
  HeartbreakIcon: require('./HeartbreakIcon').default,
  HeaterIcon: require('./HeaterIcon').default,
  HelicopterIcon: require('./HelicopterIcon').default,
  HelpCircleIcon: require('./HelpCircleIcon').default,
  HelpSquareIcon: require('./HelpSquareIcon').default,
  Hexagon01Icon: require('./Hexagon01Icon').default,
  HexagonIcon: require('./HexagonIcon').default,
  HierarchyCircle01Icon: require('./HierarchyCircle01Icon').default,
  HierarchyCircle02Icon: require('./HierarchyCircle02Icon').default,
  HierarchyCircle03Icon: require('./HierarchyCircle03Icon').default,
  HierarchyFilesIcon: require('./HierarchyFilesIcon').default,
  HierarchySquare01Icon: require('./HierarchySquare01Icon').default,
  HierarchySquare02Icon: require('./HierarchySquare02Icon').default,
  HierarchySquare03Icon: require('./HierarchySquare03Icon').default,
  HierarchySquare04Icon: require('./HierarchySquare04Icon').default,
  HierarchySquare05Icon: require('./HierarchySquare05Icon').default,
  HierarchySquare06Icon: require('./HierarchySquare06Icon').default,
  HierarchySquare07Icon: require('./HierarchySquare07Icon').default,
  HierarchySquare08Icon: require('./HierarchySquare08Icon').default,
  HierarchySquare10Icon: require('./HierarchySquare10Icon').default,
  HierarchyIcon: require('./HierarchyIcon').default,
  HighHeels01Icon: require('./HighHeels01Icon').default,
  HighHeels02Icon: require('./HighHeels02Icon').default,
  HighlighterIcon: require('./HighlighterIcon').default,
  HijabIcon: require('./HijabIcon').default,
  HistoryIcon: require('./HistoryIcon').default,
  HockeyIcon: require('./HockeyIcon').default,
  Hold01Icon: require('./Hold01Icon').default,
  Hold02Icon: require('./Hold02Icon').default,
  Hold03Icon: require('./Hold03Icon').default,
  Hold04Icon: require('./Hold04Icon').default,
  Hold05Icon: require('./Hold05Icon').default,
  HoldLocked01Icon: require('./HoldLocked01Icon').default,
  HoldLocked02Icon: require('./HoldLocked02Icon').default,
  HoldPhoneIcon: require('./HoldPhoneIcon').default,
  HologramIcon: require('./HologramIcon').default,
  Home01Icon: require('./Home01Icon').default,
  Home02Icon: require('./Home02Icon').default,
  Home03Icon: require('./Home03Icon').default,
  Home04Icon: require('./Home04Icon').default,
  Home05Icon: require('./Home05Icon').default,
  Home06Icon: require('./Home06Icon').default,
  Home07Icon: require('./Home07Icon').default,
  Home08Icon: require('./Home08Icon').default,
  Home09Icon: require('./Home09Icon').default,
  Home10Icon: require('./Home10Icon').default,
  Home11Icon: require('./Home11Icon').default,
  Home12Icon: require('./Home12Icon').default,
  Home13Icon: require('./Home13Icon').default,
  HomeWifiIcon: require('./HomeWifiIcon').default,
  Honey01Icon: require('./Honey01Icon').default,
  Honey02Icon: require('./Honey02Icon').default,
  HonorIcon: require('./HonorIcon').default,
  HonourStarIcon: require('./HonourStarIcon').default,
  HoodieIcon: require('./HoodieIcon').default,
  HopOffIcon: require('./HopOffIcon').default,
  HopIcon: require('./HopIcon').default,
  HorizonalScrollPointIcon: require('./HorizonalScrollPointIcon').default,
  HorizontalResizeIcon: require('./HorizontalResizeIcon').default,
  HorseHeadIcon: require('./HorseHeadIcon').default,
  HorseSaddleIcon: require('./HorseSaddleIcon').default,
  HorseIcon: require('./HorseIcon').default,
  Hospital01Icon: require('./Hospital01Icon').default,
  Hospital02Icon: require('./Hospital02Icon').default,
  HospitalBed01Icon: require('./HospitalBed01Icon').default,
  HospitalBed02Icon: require('./HospitalBed02Icon').default,
  HospitalLocationIcon: require('./HospitalLocationIcon').default,
  HotAirBalloonIcon: require('./HotAirBalloonIcon').default,
  HotPriceIcon: require('./HotPriceIcon').default,
  HotTubeIcon: require('./HotTubeIcon').default,
  HotdogIcon: require('./HotdogIcon').default,
  Hotel01Icon: require('./Hotel01Icon').default,
  Hotel02Icon: require('./Hotel02Icon').default,
  HotelBellIcon: require('./HotelBellIcon').default,
  HotspotOfflineIcon: require('./HotspotOfflineIcon').default,
  HotspotIcon: require('./HotspotIcon').default,
  HourglassOffIcon: require('./HourglassOffIcon').default,
  HourglassIcon: require('./HourglassIcon').default,
  House01Icon: require('./House01Icon').default,
  House02Icon: require('./House02Icon').default,
  House03Icon: require('./House03Icon').default,
  House04Icon: require('./House04Icon').default,
  House05Icon: require('./House05Icon').default,
  HouseHeartIcon: require('./HouseHeartIcon').default,
  HousePlugIcon: require('./HousePlugIcon').default,
  HousePlusIcon: require('./HousePlusIcon').default,
  HouseSolarPanelIcon: require('./HouseSolarPanelIcon').default,
  HouseWifiIcon: require('./HouseWifiIcon').default,
  HtmlFiveIcon: require('./HtmlFiveIcon').default,
  HtmlFile01Icon: require('./HtmlFile01Icon').default,
  HtmlFile02Icon: require('./HtmlFile02Icon').default,
  HugeiconsIcon: require('./HugeiconsIcon').default,
  HumidityIcon: require('./HumidityIcon').default,
  HutIcon: require('./HutIcon').default,
  HydroPowerIcon: require('./HydroPowerIcon').default,
  HyperboleIcon: require('./HyperboleIcon').default,
  IceCream01Icon: require('./IceCream01Icon').default,
  IceCream02Icon: require('./IceCream02Icon').default,
  IceCream03Icon: require('./IceCream03Icon').default,
  IceCream04Icon: require('./IceCream04Icon').default,
  IceCubesIcon: require('./IceCubesIcon').default,
  IceHockeyIcon: require('./IceHockeyIcon').default,
  IceSkatingIcon: require('./IceSkatingIcon').default,
  IcoIcon: require('./IcoIcon').default,
  IconjarIcon: require('./IconjarIcon').default,
  IdCardLanyardIcon: require('./IdCardLanyardIcon').default,
  IdNotVerifiedIcon: require('./IdNotVerifiedIcon').default,
  IdIcon: require('./IdIcon').default,
  IdVerifiedIcon: require('./IdVerifiedIcon').default,
  Idea01Icon: require('./Idea01Icon').default,
  IdeaIcon: require('./IdeaIcon').default,
  IdentificationIcon: require('./IdentificationIcon').default,
  IdentityCardIcon: require('./IdentityCardIcon').default,
  Image01Icon: require('./Image01Icon').default,
  Image02Icon: require('./Image02Icon').default,
  Image03Icon: require('./Image03Icon').default,
  ImageActualSizeIcon: require('./ImageActualSizeIcon').default,
  ImageAdd01Icon: require('./ImageAdd01Icon').default,
  ImageAdd02Icon: require('./ImageAdd02Icon').default,
  ImageCompositionOvalIcon: require('./ImageCompositionOvalIcon').default,
  ImageCompositionIcon: require('./ImageCompositionIcon').default,
  ImageCounterClockwiseIcon: require('./ImageCounterClockwiseIcon').default,
  ImageCropIcon: require('./ImageCropIcon').default,
  ImageDelete01Icon: require('./ImageDelete01Icon').default,
  ImageDelete02Icon: require('./ImageDelete02Icon').default,
  ImageDone01Icon: require('./ImageDone01Icon').default,
  ImageDone02Icon: require('./ImageDone02Icon').default,
  ImageDownload02Icon: require('./ImageDownload02Icon').default,
  ImageDownloadIcon: require('./ImageDownloadIcon').default,
  ImageFlipHorizontalIcon: require('./ImageFlipHorizontalIcon').default,
  ImageFlipVerticalIcon: require('./ImageFlipVerticalIcon').default,
  ImageNotFound01Icon: require('./ImageNotFound01Icon').default,
  ImageNotFound02Icon: require('./ImageNotFound02Icon').default,
  ImagePlayIcon: require('./ImagePlayIcon').default,
  ImageRemove01Icon: require('./ImageRemove01Icon').default,
  ImageRemove02Icon: require('./ImageRemove02Icon').default,
  ImageRotationClockwiseIcon: require('./ImageRotationClockwiseIcon').default,
  ImageUpload01Icon: require('./ImageUpload01Icon').default,
  ImageUploadIcon: require('./ImageUploadIcon').default,
  ImoIcon: require('./ImoIcon').default,
  ImportantBookIcon: require('./ImportantBookIcon').default,
  InLoveIcon: require('./InLoveIcon').default,
  InboxCheckIcon: require('./InboxCheckIcon').default,
  InboxDownloadIcon: require('./InboxDownloadIcon').default,
  InboxIcon: require('./InboxIcon').default,
  InboxUnreadIcon: require('./InboxUnreadIcon').default,
  InboxUploadIcon: require('./InboxUploadIcon').default,
  IncognitoIcon: require('./IncognitoIcon').default,
  IndiaGateIcon: require('./IndiaGateIcon').default,
  Inequality01Icon: require('./Inequality01Icon').default,
  Inequality02Icon: require('./Inequality02Icon').default,
  InequalityCircle01Icon: require('./InequalityCircle01Icon').default,
  InequalityCircle02Icon: require('./InequalityCircle02Icon').default,
  InequalitySquare01Icon: require('./InequalitySquare01Icon').default,
  InequalitySquare02Icon: require('./InequalitySquare02Icon').default,
  InfantIcon: require('./InfantIcon').default,
  Infinity01Icon: require('./Infinity01Icon').default,
  Infinity02Icon: require('./Infinity02Icon').default,
  InfinityCircleIcon: require('./InfinityCircleIcon').default,
  InfinitySquareIcon: require('./InfinitySquareIcon').default,
  InformationCircleIcon: require('./InformationCircleIcon').default,
  InformationDiamondIcon: require('./InformationDiamondIcon').default,
  InformationSquareIcon: require('./InformationSquareIcon').default,
  InjectionIcon: require('./InjectionIcon').default,
  InputCursorTextIcon: require('./InputCursorTextIcon').default,
  InputLongTextIcon: require('./InputLongTextIcon').default,
  InputNumericIcon: require('./InputNumericIcon').default,
  InputShortTextIcon: require('./InputShortTextIcon').default,
  InputTextIcon: require('./InputTextIcon').default,
  InsertBottomImageIcon: require('./InsertBottomImageIcon').default,
  InsertCenterImageIcon: require('./InsertCenterImageIcon').default,
  InsertColumnLeftIcon: require('./InsertColumnLeftIcon').default,
  InsertColumnRightIcon: require('./InsertColumnRightIcon').default,
  InsertColumnIcon: require('./InsertColumnIcon').default,
  InsertPiIcon: require('./InsertPiIcon').default,
  InsertRowDownIcon: require('./InsertRowDownIcon').default,
  InsertRowIcon: require('./InsertRowIcon').default,
  InsertRowUpIcon: require('./InsertRowUpIcon').default,
  InsertTopImageIcon: require('./InsertTopImageIcon').default,
  InspectCodeIcon: require('./InspectCodeIcon').default,
  InstagramIcon: require('./InstagramIcon').default,
  InstallingUpdates01Icon: require('./InstallingUpdates01Icon').default,
  InstallingUpdates02Icon: require('./InstallingUpdates02Icon').default,
  InternetAntenna01Icon: require('./InternetAntenna01Icon').default,
  InternetAntenna02Icon: require('./InternetAntenna02Icon').default,
  InternetAntenna03Icon: require('./InternetAntenna03Icon').default,
  InternetAntenna04Icon: require('./InternetAntenna04Icon').default,
  InternetIcon: require('./InternetIcon').default,
  InvestigationIcon: require('./InvestigationIcon').default,
  Invoice01Icon: require('./Invoice01Icon').default,
  Invoice02Icon: require('./Invoice02Icon').default,
  Invoice03Icon: require('./Invoice03Icon').default,
  Invoice04Icon: require('./Invoice04Icon').default,
  InvoiceIcon: require('./InvoiceIcon').default,
  IpodIcon: require('./IpodIcon').default,
  IrisScanIcon: require('./IrisScanIcon').default,
  IslandIcon: require('./IslandIcon').default,
  IterationCcwIcon: require('./IterationCcwIcon').default,
  IterationCwIcon: require('./IterationCwIcon').default,
  JarIcon: require('./JarIcon').default,
  JavaScriptIcon: require('./JavaScriptIcon').default,
  JavaIcon: require('./JavaIcon').default,
  JobLinkIcon: require('./JobLinkIcon').default,
  JobSearchIcon: require('./JobSearchIcon').default,
  JobShareIcon: require('./JobShareIcon').default,
  JoggerPantsIcon: require('./JoggerPantsIcon').default,
  JoinBevelIcon: require('./JoinBevelIcon').default,
  JoinRoundIcon: require('./JoinRoundIcon').default,
  JoinStraightIcon: require('./JoinStraightIcon').default,
  JokerIcon: require('./JokerIcon').default,
  Joystick01Icon: require('./Joystick01Icon').default,
  Joystick02Icon: require('./Joystick02Icon').default,
  Joystick03Icon: require('./Joystick03Icon').default,
  Joystick04Icon: require('./Joystick04Icon').default,
  Joystick05Icon: require('./Joystick05Icon').default,
  Jpg01Icon: require('./Jpg01Icon').default,
  Jpg02Icon: require('./Jpg02Icon').default,
  Jsx01Icon: require('./Jsx01Icon').default,
  Jsx02Icon: require('./Jsx02Icon').default,
  Jsx03Icon: require('./Jsx03Icon').default,
  JudgeIcon: require('./JudgeIcon').default,
  JumpersIcon: require('./JumpersIcon').default,
  JupiterIcon: require('./JupiterIcon').default,
  JusticeScale01Icon: require('./JusticeScale01Icon').default,
  JusticeScale02Icon: require('./JusticeScale02Icon').default,
  Kaaba01Icon: require('./Kaaba01Icon').default,
  Kaaba02Icon: require('./Kaaba02Icon').default,
  KanbanIcon: require('./KanbanIcon').default,
  KayakIcon: require('./KayakIcon').default,
  KeffiyehIcon: require('./KeffiyehIcon').default,
  Kettle01Icon: require('./Kettle01Icon').default,
  KettleIcon: require('./KettleIcon').default,
  KettlebellIcon: require('./KettlebellIcon').default,
  KetupatIcon: require('./KetupatIcon').default,
  Key01Icon: require('./Key01Icon').default,
  Key02Icon: require('./Key02Icon').default,
  KeyGeneratorFobIcon: require('./KeyGeneratorFobIcon').default,
  KeyboardIcon: require('./KeyboardIcon').default,
  KeyframeAddIcon: require('./KeyframeAddIcon').default,
  KeyframeAlignCenterIcon: require('./KeyframeAlignCenterIcon').default,
  KeyframeAlignHorizontalIcon: require('./KeyframeAlignHorizontalIcon').default,
  KeyframeAlignVerticalIcon: require('./KeyframeAlignVerticalIcon').default,
  KeyframeBottomIcon: require('./KeyframeBottomIcon').default,
  KeyframeLeftIcon: require('./KeyframeLeftIcon').default,
  KeyframeRemoveIcon: require('./KeyframeRemoveIcon').default,
  KeyframeRightIcon: require('./KeyframeRightIcon').default,
  KeyframeIcon: require('./KeyframeIcon').default,
  KeyframeTopIcon: require('./KeyframeTopIcon').default,
  KeyframesDoubleAddIcon: require('./KeyframesDoubleAddIcon').default,
  KeyframesDoubleRemoveIcon: require('./KeyframesDoubleRemoveIcon').default,
  KeyframesDoubleIcon: require('./KeyframesDoubleIcon').default,
  KeyframesMultipleAddIcon: require('./KeyframesMultipleAddIcon').default,
  KeyframesMultipleRemoveIcon: require('./KeyframesMultipleRemoveIcon').default,
  KeyframesMultipleIcon: require('./KeyframesMultipleIcon').default,
  Kickstarter01Icon: require('./Kickstarter01Icon').default,
  Kickstarter02Icon: require('./Kickstarter02Icon').default,
  KidIcon: require('./KidIcon').default,
  KidneysIcon: require('./KidneysIcon').default,
  KimiAiIcon: require('./KimiAiIcon').default,
  KissingIcon: require('./KissingIcon').default,
  KitchenUtensilsIcon: require('./KitchenUtensilsIcon').default,
  KiteIcon: require('./KiteIcon').default,
  KlarnaIcon: require('./KlarnaIcon').default,
  Knife01Icon: require('./Knife01Icon').default,
  Knife02Icon: require('./Knife02Icon').default,
  KnifeBreadIcon: require('./KnifeBreadIcon').default,
  KnightShieldIcon: require('./KnightShieldIcon').default,
  KnivesIcon: require('./KnivesIcon').default,
  Knowledge01Icon: require('./Knowledge01Icon').default,
  Knowledge02Icon: require('./Knowledge02Icon').default,
  KoFiIcon: require('./KoFiIcon').default,
  Kurta01Icon: require('./Kurta01Icon').default,
  KurtaIcon: require('./KurtaIcon').default,
  LabelImportantIcon: require('./LabelImportantIcon').default,
  LabelIcon: require('./LabelIcon').default,
  LaborIcon: require('./LaborIcon').default,
  LabsIcon: require('./LabsIcon').default,
  LakeIcon: require('./LakeIcon').default,
  Lamp01Icon: require('./Lamp01Icon').default,
  Lamp02Icon: require('./Lamp02Icon').default,
  Lamp03Icon: require('./Lamp03Icon').default,
  Lamp04Icon: require('./Lamp04Icon').default,
  Lamp05Icon: require('./Lamp05Icon').default,
  LampIcon: require('./LampIcon').default,
  LampWallDownIcon: require('./LampWallDownIcon').default,
  LampWallUpIcon: require('./LampWallUpIcon').default,
  LandPlotIcon: require('./LandPlotIcon').default,
  LandmarkIcon: require('./LandmarkIcon').default,
  LanguageCircleIcon: require('./LanguageCircleIcon').default,
  LanguageSkillIcon: require('./LanguageSkillIcon').default,
  LanguageSquareIcon: require('./LanguageSquareIcon').default,
  LanternIcon: require('./LanternIcon').default,
  LaptopAddIcon: require('./LaptopAddIcon').default,
  LaptopChargingIcon: require('./LaptopChargingIcon').default,
  LaptopCheckIcon: require('./LaptopCheckIcon').default,
  LaptopCloudIcon: require('./LaptopCloudIcon').default,
  LaptopIssueIcon: require('./LaptopIssueIcon').default,
  LaptopPerformanceIcon: require('./LaptopPerformanceIcon').default,
  LaptopPhoneSyncIcon: require('./LaptopPhoneSyncIcon').default,
  LaptopProgrammingIcon: require('./LaptopProgrammingIcon').default,
  LaptopRemoveIcon: require('./LaptopRemoveIcon').default,
  LaptopSettingsIcon: require('./LaptopSettingsIcon').default,
  LaptopIcon: require('./LaptopIcon').default,
  LaptopVideoIcon: require('./LaptopVideoIcon').default,
  LassoSelectIcon: require('./LassoSelectIcon').default,
  LassoTool01Icon: require('./LassoTool01Icon').default,
  LassoTool02Icon: require('./LassoTool02Icon').default,
  LastFmIcon: require('./LastFmIcon').default,
  LatitudeIcon: require('./LatitudeIcon').default,
  LaughingIcon: require('./LaughingIcon').default,
  LaurelWreath01Icon: require('./LaurelWreath01Icon').default,
  LaurelWreath02Icon: require('./LaurelWreath02Icon').default,
  LaurelWreathFirst01Icon: require('./LaurelWreathFirst01Icon').default,
  LaurelWreathFirst02Icon: require('./LaurelWreathFirst02Icon').default,
  LaurelWreathLeft01Icon: require('./LaurelWreathLeft01Icon').default,
  LaurelWreathLeft02Icon: require('./LaurelWreathLeft02Icon').default,
  LaurelWreathLeft03Icon: require('./LaurelWreathLeft03Icon').default,
  LaurelWreathRight01Icon: require('./LaurelWreathRight01Icon').default,
  LaurelWreathRight02Icon: require('./LaurelWreathRight02Icon').default,
  LaurelWreathRight03Icon: require('./LaurelWreathRight03Icon').default,
  LayerAddIcon: require('./LayerAddIcon').default,
  LayerBringForwardIcon: require('./LayerBringForwardIcon').default,
  LayerBringToFrontIcon: require('./LayerBringToFrontIcon').default,
  LayerMask01Icon: require('./LayerMask01Icon').default,
  LayerMask02Icon: require('./LayerMask02Icon').default,
  LayerSendBackwardIcon: require('./LayerSendBackwardIcon').default,
  LayerSendToBackIcon: require('./LayerSendToBackIcon').default,
  LayerIcon: require('./LayerIcon').default,
  Layers01Icon: require('./Layers01Icon').default,
  Layers02Icon: require('./Layers02Icon').default,
  LayersLogoIcon: require('./LayersLogoIcon').default,
  Layout01Icon: require('./Layout01Icon').default,
  Layout02Icon: require('./Layout02Icon').default,
  Layout03Icon: require('./Layout03Icon').default,
  Layout04Icon: require('./Layout04Icon').default,
  Layout05Icon: require('./Layout05Icon').default,
  Layout06Icon: require('./Layout06Icon').default,
  Layout07Icon: require('./Layout07Icon').default,
  LayoutTwoColumnIcon: require('./LayoutTwoColumnIcon').default,
  LayoutTwoRowIcon: require('./LayoutTwoRowIcon').default,
  LayoutThreeColumnIcon: require('./LayoutThreeColumnIcon').default,
  LayoutThreeRowIcon: require('./LayoutThreeRowIcon').default,
  LayoutAlignBottomIcon: require('./LayoutAlignBottomIcon').default,
  LayoutAlignLeftIcon: require('./LayoutAlignLeftIcon').default,
  LayoutAlignRightIcon: require('./LayoutAlignRightIcon').default,
  LayoutAlignTopIcon: require('./LayoutAlignTopIcon').default,
  LayoutBottomIcon: require('./LayoutBottomIcon').default,
  LayoutGridIcon: require('./LayoutGridIcon').default,
  LayoutLeftIcon: require('./LayoutLeftIcon').default,
  LayoutRightIcon: require('./LayoutRightIcon').default,
  LayoutTable01Icon: require('./LayoutTable01Icon').default,
  LayoutTable02Icon: require('./LayoutTable02Icon').default,
  LayoutTopIcon: require('./LayoutTopIcon').default,
  Leaf01Icon: require('./Leaf01Icon').default,
  Leaf02Icon: require('./Leaf02Icon').default,
  Leaf03Icon: require('./Leaf03Icon').default,
  Leaf04Icon: require('./Leaf04Icon').default,
  LeafyGreenIcon: require('./LeafyGreenIcon').default,
  LeavingGeoFenceIcon: require('./LeavingGeoFenceIcon').default,
  LeetcodeIcon: require('./LeetcodeIcon').default,
  LeftAngleIcon: require('./LeftAngleIcon').default,
  LeftToRightBlockQuoteIcon: require('./LeftToRightBlockQuoteIcon').default,
  LeftToRightListBulletIcon: require('./LeftToRightListBulletIcon').default,
  LeftToRightListDashIcon: require('./LeftToRightListDashIcon').default,
  LeftToRightListNumberIcon: require('./LeftToRightListNumberIcon').default,
  LeftToRightListStar01Icon: require('./LeftToRightListStar01Icon').default,
  LeftToRightListStarIcon: require('./LeftToRightListStarIcon').default,
  LeftToRightListTriangleIcon: require('./LeftToRightListTriangleIcon').default,
  LeftTriangleIcon: require('./LeftTriangleIcon').default,
  Legal01Icon: require('./Legal01Icon').default,
  Legal02Icon: require('./Legal02Icon').default,
  LegalDocument01Icon: require('./LegalDocument01Icon').default,
  LegalDocument02Icon: require('./LegalDocument02Icon').default,
  LegalHammerIcon: require('./LegalHammerIcon').default,
  LessThanCircleIcon: require('./LessThanCircleIcon').default,
  LessThanSquareIcon: require('./LessThanSquareIcon').default,
  LessThanIcon: require('./LessThanIcon').default,
  LetterSpacingIcon: require('./LetterSpacingIcon').default,
  LibrariesIcon: require('./LibrariesIcon').default,
  LibraryIcon: require('./LibraryIcon').default,
  LicenseDraftIcon: require('./LicenseDraftIcon').default,
  LicenseMaintenanceIcon: require('./LicenseMaintenanceIcon').default,
  LicenseNoIcon: require('./LicenseNoIcon').default,
  LicensePinIcon: require('./LicensePinIcon').default,
  LicenseIcon: require('./LicenseIcon').default,
  LicenseThirdPartyIcon: require('./LicenseThirdPartyIcon').default,
  LifebuoyIcon: require('./LifebuoyIcon').default,
  LiftTruckIcon: require('./LiftTruckIcon').default,
  LigatureIcon: require('./LigatureIcon').default,
  LightbulbOffIcon: require('./LightbulbOffIcon').default,
  LighthouseIcon: require('./LighthouseIcon').default,
  LimitOrderIcon: require('./LimitOrderIcon').default,
  LimitationIcon: require('./LimitationIcon').default,
  LineIcon: require('./LineIcon').default,
  LinerIcon: require('./LinerIcon').default,
  Link01Icon: require('./Link01Icon').default,
  Link02Icon: require('./Link02Icon').default,
  Link03Icon: require('./Link03Icon').default,
  Link04Icon: require('./Link04Icon').default,
  Link05Icon: require('./Link05Icon').default,
  Link06Icon: require('./Link06Icon').default,
  LinkBackwardIcon: require('./LinkBackwardIcon').default,
  LinkCircle02Icon: require('./LinkCircle02Icon').default,
  LinkCircleIcon: require('./LinkCircleIcon').default,
  LinkForwardIcon: require('./LinkForwardIcon').default,
  LinkSquare01Icon: require('./LinkSquare01Icon').default,
  LinkSquare02Icon: require('./LinkSquare02Icon').default,
  Linkedin01Icon: require('./Linkedin01Icon').default,
  Linkedin02Icon: require('./Linkedin02Icon').default,
  ListChevronsDownUpIcon: require('./ListChevronsDownUpIcon').default,
  ListFilterPlusIcon: require('./ListFilterPlusIcon').default,
  ListIndentDecreaseIcon: require('./ListIndentDecreaseIcon').default,
  ListIndentIncreaseIcon: require('./ListIndentIncreaseIcon').default,
  ListMusicIcon: require('./ListMusicIcon').default,
  ListPlusIcon: require('./ListPlusIcon').default,
  ListRestartIcon: require('./ListRestartIcon').default,
  ListSettingIcon: require('./ListSettingIcon').default,
  ListStartIcon: require('./ListStartIcon').default,
  ListTreeIcon: require('./ListTreeIcon').default,
  ListVideoIcon: require('./ListVideoIcon').default,
  ListViewIcon: require('./ListViewIcon').default,
  ListXIcon: require('./ListXIcon').default,
  LitecoinIcon: require('./LitecoinIcon').default,
  LiveStreaming01Icon: require('./LiveStreaming01Icon').default,
  LiveStreaming02Icon: require('./LiveStreaming02Icon').default,
  LiveStreaming03Icon: require('./LiveStreaming03Icon').default,
  LiverIcon: require('./LiverIcon').default,
  LoaderPinwheelIcon: require('./LoaderPinwheelIcon').default,
  Loading01Icon: require('./Loading01Icon').default,
  Loading02Icon: require('./Loading02Icon').default,
  Loading03Icon: require('./Loading03Icon').default,
  Loading04Icon: require('./Loading04Icon').default,
  Location01Icon: require('./Location01Icon').default,
  Location02Icon: require('./Location02Icon').default,
  Location03Icon: require('./Location03Icon').default,
  Location04Icon: require('./Location04Icon').default,
  Location05Icon: require('./Location05Icon').default,
  Location06Icon: require('./Location06Icon').default,
  Location07Icon: require('./Location07Icon').default,
  Location08Icon: require('./Location08Icon').default,
  Location09Icon: require('./Location09Icon').default,
  Location10Icon: require('./Location10Icon').default,
  LocationAdd01Icon: require('./LocationAdd01Icon').default,
  LocationAdd02Icon: require('./LocationAdd02Icon').default,
  LocationCheck01Icon: require('./LocationCheck01Icon').default,
  LocationCheck02Icon: require('./LocationCheck02Icon').default,
  LocationFavourite01Icon: require('./LocationFavourite01Icon').default,
  LocationFavourite02Icon: require('./LocationFavourite02Icon').default,
  LocationOffline01Icon: require('./LocationOffline01Icon').default,
  LocationOffline02Icon: require('./LocationOffline02Icon').default,
  LocationOffline03Icon: require('./LocationOffline03Icon').default,
  LocationOffline04Icon: require('./LocationOffline04Icon').default,
  LocationRemove01Icon: require('./LocationRemove01Icon').default,
  LocationRemove02Icon: require('./LocationRemove02Icon').default,
  LocationShare01Icon: require('./LocationShare01Icon').default,
  LocationShare02Icon: require('./LocationShare02Icon').default,
  LocationStar01Icon: require('./LocationStar01Icon').default,
  LocationStar02Icon: require('./LocationStar02Icon').default,
  LocationUpdate01Icon: require('./LocationUpdate01Icon').default,
  LocationUpdate02Icon: require('./LocationUpdate02Icon').default,
  LocationUser01Icon: require('./LocationUser01Icon').default,
  LocationUser02Icon: require('./LocationUser02Icon').default,
  LocationUser03Icon: require('./LocationUser03Icon').default,
  LocationUser04Icon: require('./LocationUser04Icon').default,
  LockComputerIcon: require('./LockComputerIcon').default,
  LockKeyIcon: require('./LockKeyIcon').default,
  LockPasswordIcon: require('./LockPasswordIcon').default,
  LockIcon: require('./LockIcon').default,
  LockSync01Icon: require('./LockSync01Icon').default,
  LockSync02Icon: require('./LockSync02Icon').default,
  LockedIcon: require('./LockedIcon').default,
  Locker01Icon: require('./Locker01Icon').default,
  LockerIcon: require('./LockerIcon').default,
  Login01Icon: require('./Login01Icon').default,
  Login02Icon: require('./Login02Icon').default,
  Login03Icon: require('./Login03Icon').default,
  LoginCircle01Icon: require('./LoginCircle01Icon').default,
  LoginCircle02Icon: require('./LoginCircle02Icon').default,
  LoginMethodIcon: require('./LoginMethodIcon').default,
  LoginSquare01Icon: require('./LoginSquare01Icon').default,
  LoginSquare02Icon: require('./LoginSquare02Icon').default,
  Logout01Icon: require('./Logout01Icon').default,
  Logout02Icon: require('./Logout02Icon').default,
  Logout03Icon: require('./Logout03Icon').default,
  Logout04Icon: require('./Logout04Icon').default,
  Logout05Icon: require('./Logout05Icon').default,
  LogoutCircle01Icon: require('./LogoutCircle01Icon').default,
  LogoutCircle02Icon: require('./LogoutCircle02Icon').default,
  LogoutSquare01Icon: require('./LogoutSquare01Icon').default,
  LogoutSquare02Icon: require('./LogoutSquare02Icon').default,
  LollipopIcon: require('./LollipopIcon').default,
  LongSleeveShirtIcon: require('./LongSleeveShirtIcon').default,
  LongitudeIcon: require('./LongitudeIcon').default,
  LookBottomIcon: require('./LookBottomIcon').default,
  LookLeftIcon: require('./LookLeftIcon').default,
  LookRightIcon: require('./LookRightIcon').default,
  LookTopIcon: require('./LookTopIcon').default,
  LoomIcon: require('./LoomIcon').default,
  LottiefilesIcon: require('./LottiefilesIcon').default,
  LoveKoreanFingerIcon: require('./LoveKoreanFingerIcon').default,
  LowSignalIcon: require('./LowSignalIcon').default,
  LoyaltyCardIcon: require('./LoyaltyCardIcon').default,
  Luggage01Icon: require('./Luggage01Icon').default,
  Luggage02Icon: require('./Luggage02Icon').default,
  LungsIcon: require('./LungsIcon').default,
  MachineRobotIcon: require('./MachineRobotIcon').default,
  MagicWand01Icon: require('./MagicWand01Icon').default,
  MagicWand02Icon: require('./MagicWand02Icon').default,
  MagicWand03Icon: require('./MagicWand03Icon').default,
  MagicWand04Icon: require('./MagicWand04Icon').default,
  MagicWand05Icon: require('./MagicWand05Icon').default,
  Magnet01Icon: require('./Magnet01Icon').default,
  Magnet02Icon: require('./Magnet02Icon').default,
  MagnetIcon: require('./MagnetIcon').default,
  Mail01Icon: require('./Mail01Icon').default,
  Mail02Icon: require('./Mail02Icon').default,
  MailAccount01Icon: require('./MailAccount01Icon').default,
  MailAccount02Icon: require('./MailAccount02Icon').default,
  MailAdd01Icon: require('./MailAdd01Icon').default,
  MailAdd02Icon: require('./MailAdd02Icon').default,
  MailAtSign01Icon: require('./MailAtSign01Icon').default,
  MailAtSign02Icon: require('./MailAtSign02Icon').default,
  MailBlock01Icon: require('./MailBlock01Icon').default,
  MailBlock02Icon: require('./MailBlock02Icon').default,
  MailDownload01Icon: require('./MailDownload01Icon').default,
  MailDownload02Icon: require('./MailDownload02Icon').default,
  MailEdit01Icon: require('./MailEdit01Icon').default,
  MailEdit02Icon: require('./MailEdit02Icon').default,
  MailLock01Icon: require('./MailLock01Icon').default,
  MailLock02Icon: require('./MailLock02Icon').default,
  MailLove01Icon: require('./MailLove01Icon').default,
  MailLove02Icon: require('./MailLove02Icon').default,
  MailMinus01Icon: require('./MailMinus01Icon').default,
  MailMinus02Icon: require('./MailMinus02Icon').default,
  MailOpen01Icon: require('./MailOpen01Icon').default,
  MailOpen02Icon: require('./MailOpen02Icon').default,
  MailOpenLoveIcon: require('./MailOpenLoveIcon').default,
  MailOpenIcon: require('./MailOpenIcon').default,
  MailQuestionMarkIcon: require('./MailQuestionMarkIcon').default,
  MailReceive01Icon: require('./MailReceive01Icon').default,
  MailReceive02Icon: require('./MailReceive02Icon').default,
  MailRemove01Icon: require('./MailRemove01Icon').default,
  MailRemove02Icon: require('./MailRemove02Icon').default,
  MailReply01Icon: require('./MailReply01Icon').default,
  MailReply02Icon: require('./MailReply02Icon').default,
  MailReplyAll01Icon: require('./MailReplyAll01Icon').default,
  MailReplyAll02Icon: require('./MailReplyAll02Icon').default,
  MailSearch01Icon: require('./MailSearch01Icon').default,
  MailSearch02Icon: require('./MailSearch02Icon').default,
  MailSecure01Icon: require('./MailSecure01Icon').default,
  MailSecure02Icon: require('./MailSecure02Icon').default,
  MailSend01Icon: require('./MailSend01Icon').default,
  MailSend02Icon: require('./MailSend02Icon').default,
  MailSetting01Icon: require('./MailSetting01Icon').default,
  MailSetting02Icon: require('./MailSetting02Icon').default,
  MailUnlock01Icon: require('./MailUnlock01Icon').default,
  MailUnlock02Icon: require('./MailUnlock02Icon').default,
  MailUpload01Icon: require('./MailUpload01Icon').default,
  MailUpload02Icon: require('./MailUpload02Icon').default,
  MailValidation01Icon: require('./MailValidation01Icon').default,
  MailValidation02Icon: require('./MailValidation02Icon').default,
  MailVoice01Icon: require('./MailVoice01Icon').default,
  MailVoice02Icon: require('./MailVoice02Icon').default,
  MailWarningIcon: require('./MailWarningIcon').default,
  Mailbox01Icon: require('./Mailbox01Icon').default,
  MailboxIcon: require('./MailboxIcon').default,
  MailsIcon: require('./MailsIcon').default,
  Male02Icon: require('./Male02Icon').default,
  MaleSymbolIcon: require('./MaleSymbolIcon').default,
  ManIcon: require('./ManIcon').default,
  ManWomanIcon: require('./ManWomanIcon').default,
  ManagerIcon: require('./ManagerIcon').default,
  MapPinCheckIcon: require('./MapPinCheckIcon').default,
  MapPinHouseIcon: require('./MapPinHouseIcon').default,
  MapPinMinusIcon: require('./MapPinMinusIcon').default,
  MapPinPenIcon: require('./MapPinPenIcon').default,
  MapPinPlusIcon: require('./MapPinPlusIcon').default,
  MapPinIcon: require('./MapPinIcon').default,
  MapPinXInsideIcon: require('./MapPinXInsideIcon').default,
  MapPinXIcon: require('./MapPinXIcon').default,
  MapPinpoint01Icon: require('./MapPinpoint01Icon').default,
  MapPinpoint02Icon: require('./MapPinpoint02Icon').default,
  MapingIcon: require('./MapingIcon').default,
  MapsCircle01Icon: require('./MapsCircle01Icon').default,
  MapsCircle02Icon: require('./MapsCircle02Icon').default,
  MapsEditingIcon: require('./MapsEditingIcon').default,
  MapsGlobal01Icon: require('./MapsGlobal01Icon').default,
  MapsGlobal02Icon: require('./MapsGlobal02Icon').default,
  MapsLocation01Icon: require('./MapsLocation01Icon').default,
  MapsLocation02Icon: require('./MapsLocation02Icon').default,
  MapsOffIcon: require('./MapsOffIcon').default,
  MapsRefreshIcon: require('./MapsRefreshIcon').default,
  MapsSearchIcon: require('./MapsSearchIcon').default,
  MapsSquare01Icon: require('./MapsSquare01Icon').default,
  MapsSquare02Icon: require('./MapsSquare02Icon').default,
  MapsIcon: require('./MapsIcon').default,
  MarketAnalysisIcon: require('./MarketAnalysisIcon').default,
  MarketOrderIcon: require('./MarketOrderIcon').default,
  MarketingIcon: require('./MarketingIcon').default,
  MaskLoveIcon: require('./MaskLoveIcon').default,
  MaskIcon: require('./MaskIcon').default,
  MaskTheater01Icon: require('./MaskTheater01Icon').default,
  MaskTheater02Icon: require('./MaskTheater02Icon').default,
  MasterCardIcon: require('./MasterCardIcon').default,
  MastodonIcon: require('./MastodonIcon').default,
  MatchesIcon: require('./MatchesIcon').default,
  MaterialAndTextureIcon: require('./MaterialAndTextureIcon').default,
  MathIcon: require('./MathIcon').default,
  MatrixIcon: require('./MatrixIcon').default,
  Maximize01Icon: require('./Maximize01Icon').default,
  Maximize02Icon: require('./Maximize02Icon').default,
  Maximize03Icon: require('./Maximize03Icon').default,
  Maximize04Icon: require('./Maximize04Icon').default,
  MaximizeScreenIcon: require('./MaximizeScreenIcon').default,
  MayanPyramidIcon: require('./MayanPyramidIcon').default,
  MazeIcon: require('./MazeIcon').default,
  McpServerIcon: require('./McpServerIcon').default,
  MealScanIcon: require('./MealScanIcon').default,
  Medal01Icon: require('./Medal01Icon').default,
  Medal02Icon: require('./Medal02Icon').default,
  Medal03Icon: require('./Medal03Icon').default,
  Medal04Icon: require('./Medal04Icon').default,
  Medal05Icon: require('./Medal05Icon').default,
  Medal06Icon: require('./Medal06Icon').default,
  Medal07Icon: require('./Medal07Icon').default,
  MedalFirstPlaceIcon: require('./MedalFirstPlaceIcon').default,
  MedalSecondPlaceIcon: require('./MedalSecondPlaceIcon').default,
  MedalThirdPlaceIcon: require('./MedalThirdPlaceIcon').default,
  MedicalFileIcon: require('./MedicalFileIcon').default,
  MedicalMaskIcon: require('./MedicalMaskIcon').default,
  Medicine01Icon: require('./Medicine01Icon').default,
  Medicine02Icon: require('./Medicine02Icon').default,
  MedicineBottle01Icon: require('./MedicineBottle01Icon').default,
  MedicineBottle02Icon: require('./MedicineBottle02Icon').default,
  MedicineSyrupIcon: require('./MedicineSyrupIcon').default,
  MediumSignalIcon: require('./MediumSignalIcon').default,
  MediumSquareIcon: require('./MediumSquareIcon').default,
  MediumIcon: require('./MediumIcon').default,
  MeetingRoomIcon: require('./MeetingRoomIcon').default,
  Megaphone01Icon: require('./Megaphone01Icon').default,
  Megaphone02Icon: require('./Megaphone02Icon').default,
  Megaphone03Icon: require('./Megaphone03Icon').default,
  MehIcon: require('./MehIcon').default,
  MemoryStickIcon: require('./MemoryStickIcon').default,
  MentorIcon: require('./MentorIcon').default,
  MentoringIcon: require('./MentoringIcon').default,
  Menu01Icon: require('./Menu01Icon').default,
  Menu02Icon: require('./Menu02Icon').default,
  Menu03Icon: require('./Menu03Icon').default,
  Menu04Icon: require('./Menu04Icon').default,
  Menu05Icon: require('./Menu05Icon').default,
  Menu06Icon: require('./Menu06Icon').default,
  Menu07Icon: require('./Menu07Icon').default,
  Menu08Icon: require('./Menu08Icon').default,
  Menu09Icon: require('./Menu09Icon').default,
  Menu10Icon: require('./Menu10Icon').default,
  Menu11Icon: require('./Menu11Icon').default,
  MenuCircleIcon: require('./MenuCircleIcon').default,
  MenuCollapseIcon: require('./MenuCollapseIcon').default,
  MenuRestaurantIcon: require('./MenuRestaurantIcon').default,
  MenuSquareIcon: require('./MenuSquareIcon').default,
  MenuTwoLineIcon: require('./MenuTwoLineIcon').default,
  Message01Icon: require('./Message01Icon').default,
  Message02Icon: require('./Message02Icon').default,
  MessageAdd01Icon: require('./MessageAdd01Icon').default,
  MessageAdd02Icon: require('./MessageAdd02Icon').default,
  MessageBlockedIcon: require('./MessageBlockedIcon').default,
  MessageCancel01Icon: require('./MessageCancel01Icon').default,
  MessageCancel02Icon: require('./MessageCancel02Icon').default,
  MessageCircleCodeIcon: require('./MessageCircleCodeIcon').default,
  MessageCircleReplyIcon: require('./MessageCircleReplyIcon').default,
  MessageDelay01Icon: require('./MessageDelay01Icon').default,
  MessageDelay02Icon: require('./MessageDelay02Icon').default,
  MessageDone01Icon: require('./MessageDone01Icon').default,
  MessageDone02Icon: require('./MessageDone02Icon').default,
  MessageDownload01Icon: require('./MessageDownload01Icon').default,
  MessageDownload02Icon: require('./MessageDownload02Icon').default,
  MessageEdit01Icon: require('./MessageEdit01Icon').default,
  MessageEdit02Icon: require('./MessageEdit02Icon').default,
  MessageFavourite01Icon: require('./MessageFavourite01Icon').default,
  MessageFavourite02Icon: require('./MessageFavourite02Icon').default,
  MessageIncoming01Icon: require('./MessageIncoming01Icon').default,
  MessageIncoming02Icon: require('./MessageIncoming02Icon').default,
  MessageLock01Icon: require('./MessageLock01Icon').default,
  MessageLock02Icon: require('./MessageLock02Icon').default,
  MessageMultiple01Icon: require('./MessageMultiple01Icon').default,
  MessageMultiple02Icon: require('./MessageMultiple02Icon').default,
  MessageNotification01Icon: require('./MessageNotification01Icon').default,
  MessageNotification02Icon: require('./MessageNotification02Icon').default,
  MessageOutgoing01Icon: require('./MessageOutgoing01Icon').default,
  MessageOutgoing02Icon: require('./MessageOutgoing02Icon').default,
  MessagePreview01Icon: require('./MessagePreview01Icon').default,
  MessagePreview02Icon: require('./MessagePreview02Icon').default,
  MessageProgrammingIcon: require('./MessageProgrammingIcon').default,
  MessageQuestionIcon: require('./MessageQuestionIcon').default,
  MessageSearch01Icon: require('./MessageSearch01Icon').default,
  MessageSearch02Icon: require('./MessageSearch02Icon').default,
  MessageSecure01Icon: require('./MessageSecure01Icon').default,
  MessageSecure02Icon: require('./MessageSecure02Icon').default,
  MessageSquareCodeIcon: require('./MessageSquareCodeIcon').default,
  MessageSquareDashedIcon: require('./MessageSquareDashedIcon').default,
  MessageSquareDiffIcon: require('./MessageSquareDiffIcon').default,
  MessageSquareShareIcon: require('./MessageSquareShareIcon').default,
  MessageTranslateIcon: require('./MessageTranslateIcon').default,
  MessageUnlock01Icon: require('./MessageUnlock01Icon').default,
  MessageUnlock02Icon: require('./MessageUnlock02Icon').default,
  MessageUpload01Icon: require('./MessageUpload01Icon').default,
  MessageUpload02Icon: require('./MessageUpload02Icon').default,
  MessageUser01Icon: require('./MessageUser01Icon').default,
  MessageUser02Icon: require('./MessageUser02Icon').default,
  MessengerIcon: require('./MessengerIcon').default,
  MetaIcon: require('./MetaIcon').default,
  MetroIcon: require('./MetroIcon').default,
  Mic01Icon: require('./Mic01Icon').default,
  Mic02Icon: require('./Mic02Icon').default,
  MicOff01Icon: require('./MicOff01Icon').default,
  MicOff02Icon: require('./MicOff02Icon').default,
  MicrochipIcon: require('./MicrochipIcon').default,
  MicroscopeIcon: require('./MicroscopeIcon').default,
  MicrosoftAdminIcon: require('./MicrosoftAdminIcon').default,
  MicrosoftIcon: require('./MicrosoftIcon').default,
  MicrowaveIcon: require('./MicrowaveIcon').default,
  MilkBottleIcon: require('./MilkBottleIcon').default,
  MilkCartonIcon: require('./MilkCartonIcon').default,
  MilkCoconutIcon: require('./MilkCoconutIcon').default,
  MilkOatIcon: require('./MilkOatIcon').default,
  Minimize01Icon: require('./Minimize01Icon').default,
  Minimize02Icon: require('./Minimize02Icon').default,
  Minimize03Icon: require('./Minimize03Icon').default,
  Minimize04Icon: require('./Minimize04Icon').default,
  MinimizeScreenIcon: require('./MinimizeScreenIcon').default,
  Mining01Icon: require('./Mining01Icon').default,
  Mining02Icon: require('./Mining02Icon').default,
  Mining03Icon: require('./Mining03Icon').default,
  MinusPlus01Icon: require('./MinusPlus01Icon').default,
  MinusPlus02Icon: require('./MinusPlus02Icon').default,
  MinusPlusCircle01Icon: require('./MinusPlusCircle01Icon').default,
  MinusPlusCircle02Icon: require('./MinusPlusCircle02Icon').default,
  MinusPlusSquare01Icon: require('./MinusPlusSquare01Icon').default,
  MinusPlusSquare02Icon: require('./MinusPlusSquare02Icon').default,
  MinusSignCircleIcon: require('./MinusSignCircleIcon').default,
  MinusSignSquareIcon: require('./MinusSignSquareIcon').default,
  MinusSignIcon: require('./MinusSignIcon').default,
  MirrorIcon: require('./MirrorIcon').default,
  MirroringScreenIcon: require('./MirroringScreenIcon').default,
  MistralIcon: require('./MistralIcon').default,
  MixerIcon: require('./MixerIcon').default,
  MobileNavigator01Icon: require('./MobileNavigator01Icon').default,
  MobileNavigator02Icon: require('./MobileNavigator02Icon').default,
  MobileProgramming01Icon: require('./MobileProgramming01Icon').default,
  MobileProgramming02Icon: require('./MobileProgramming02Icon').default,
  MobileProtectionIcon: require('./MobileProtectionIcon').default,
  MobileSecurityIcon: require('./MobileSecurityIcon').default,
  MochiIcon: require('./MochiIcon').default,
  ModernTvFourKIcon: require('./ModernTvFourKIcon').default,
  ModernTvIssueIcon: require('./ModernTvIssueIcon').default,
  ModernTvIcon: require('./ModernTvIcon').default,
  MoleculesIcon: require('./MoleculesIcon').default,
  MollieIcon: require('./MollieIcon').default,
  MonasIcon: require('./MonasIcon').default,
  Money01Icon: require('./Money01Icon').default,
  Money02Icon: require('./Money02Icon').default,
  Money03Icon: require('./Money03Icon').default,
  Money04Icon: require('./Money04Icon').default,
  MoneyAdd01Icon: require('./MoneyAdd01Icon').default,
  MoneyAdd02Icon: require('./MoneyAdd02Icon').default,
  MoneyBag01Icon: require('./MoneyBag01Icon').default,
  MoneyBag02Icon: require('./MoneyBag02Icon').default,
  MoneyExchange01Icon: require('./MoneyExchange01Icon').default,
  MoneyExchange02Icon: require('./MoneyExchange02Icon').default,
  MoneyExchange03Icon: require('./MoneyExchange03Icon').default,
  MoneyLockIcon: require('./MoneyLockIcon').default,
  MoneyNotFound01Icon: require('./MoneyNotFound01Icon').default,
  MoneyNotFound02Icon: require('./MoneyNotFound02Icon').default,
  MoneyNotFound03Icon: require('./MoneyNotFound03Icon').default,
  MoneyNotFound04Icon: require('./MoneyNotFound04Icon').default,
  MoneyReceive01Icon: require('./MoneyReceive01Icon').default,
  MoneyReceive02Icon: require('./MoneyReceive02Icon').default,
  MoneyReceiveCircleIcon: require('./MoneyReceiveCircleIcon').default,
  MoneyReceiveFlow01Icon: require('./MoneyReceiveFlow01Icon').default,
  MoneyReceiveFlow02Icon: require('./MoneyReceiveFlow02Icon').default,
  MoneyReceiveSquareIcon: require('./MoneyReceiveSquareIcon').default,
  MoneyRemove01Icon: require('./MoneyRemove01Icon').default,
  MoneyRemove02Icon: require('./MoneyRemove02Icon').default,
  MoneySafeIcon: require('./MoneySafeIcon').default,
  MoneySavingJarIcon: require('./MoneySavingJarIcon').default,
  MoneySecurityIcon: require('./MoneySecurityIcon').default,
  MoneySend01Icon: require('./MoneySend01Icon').default,
  MoneySend02Icon: require('./MoneySend02Icon').default,
  MoneySendCircleIcon: require('./MoneySendCircleIcon').default,
  MoneySendFlow01Icon: require('./MoneySendFlow01Icon').default,
  MoneySendFlow02Icon: require('./MoneySendFlow02Icon').default,
  MoneySendSquareIcon: require('./MoneySendSquareIcon').default,
  MonitorDotIcon: require('./MonitorDotIcon').default,
  MonitorPauseIcon: require('./MonitorPauseIcon').default,
  MonitorSpeakerIcon: require('./MonitorSpeakerIcon').default,
  MonitorStopIcon: require('./MonitorStopIcon').default,
  Monocle01Icon: require('./Monocle01Icon').default,
  MonocleIcon: require('./MonocleIcon').default,
  MonsterIcon: require('./MonsterIcon').default,
  Moon01Icon: require('./Moon01Icon').default,
  Moon02Icon: require('./Moon02Icon').default,
  MoonAngledRainZapIcon: require('./MoonAngledRainZapIcon').default,
  MoonCloudAngledRainIcon: require('./MoonCloudAngledRainIcon').default,
  MoonCloudAngledZapIcon: require('./MoonCloudAngledZapIcon').default,
  MoonCloudBigRainIcon: require('./MoonCloudBigRainIcon').default,
  MoonCloudFastWindIcon: require('./MoonCloudFastWindIcon').default,
  MoonCloudHailstoneIcon: require('./MoonCloudHailstoneIcon').default,
  MoonCloudLittleRainIcon: require('./MoonCloudLittleRainIcon').default,
  MoonCloudLittleSnowIcon: require('./MoonCloudLittleSnowIcon').default,
  MoonCloudMidRainIcon: require('./MoonCloudMidRainIcon').default,
  MoonCloudMidSnowIcon: require('./MoonCloudMidSnowIcon').default,
  MoonCloudSlowWindIcon: require('./MoonCloudSlowWindIcon').default,
  MoonCloudSnowIcon: require('./MoonCloudSnowIcon').default,
  MoonCloudIcon: require('./MoonCloudIcon').default,
  MoonEclipseIcon: require('./MoonEclipseIcon').default,
  MoonFastWindIcon: require('./MoonFastWindIcon').default,
  MoonLandingIcon: require('./MoonLandingIcon').default,
  MoonSlowWindIcon: require('./MoonSlowWindIcon').default,
  MoonIcon: require('./MoonIcon').default,
  MoonsetIcon: require('./MoonsetIcon').default,
  More01Icon: require('./More01Icon').default,
  More02Icon: require('./More02Icon').default,
  More03Icon: require('./More03Icon').default,
  MoreHorizontalCircle01Icon: require('./MoreHorizontalCircle01Icon').default,
  MoreHorizontalCircle02Icon: require('./MoreHorizontalCircle02Icon').default,
  MoreHorizontalSquare01Icon: require('./MoreHorizontalSquare01Icon').default,
  MoreHorizontalSquare02Icon: require('./MoreHorizontalSquare02Icon').default,
  MoreHorizontalIcon: require('./MoreHorizontalIcon').default,
  MoreOrLessCircleIcon: require('./MoreOrLessCircleIcon').default,
  MoreOrLessSquareIcon: require('./MoreOrLessSquareIcon').default,
  MoreOrLessIcon: require('./MoreOrLessIcon').default,
  MoreIcon: require('./MoreIcon').default,
  MoreVerticalCircle01Icon: require('./MoreVerticalCircle01Icon').default,
  MoreVerticalCircle02Icon: require('./MoreVerticalCircle02Icon').default,
  MoreVerticalSquare01Icon: require('./MoreVerticalSquare01Icon').default,
  MoreVerticalSquare02Icon: require('./MoreVerticalSquare02Icon').default,
  MoreVerticalIcon: require('./MoreVerticalIcon').default,
  MortarIcon: require('./MortarIcon').default,
  Mortarboard01Icon: require('./Mortarboard01Icon').default,
  Mortarboard02Icon: require('./Mortarboard02Icon').default,
  Mosque01Icon: require('./Mosque01Icon').default,
  Mosque02Icon: require('./Mosque02Icon').default,
  Mosque03Icon: require('./Mosque03Icon').default,
  Mosque04Icon: require('./Mosque04Icon').default,
  Mosque05Icon: require('./Mosque05Icon').default,
  MosqueLocationIcon: require('./MosqueLocationIcon').default,
  Motion01Icon: require('./Motion01Icon').default,
  Motion02Icon: require('./Motion02Icon').default,
  Motorbike01Icon: require('./Motorbike01Icon').default,
  Motorbike02Icon: require('./Motorbike02Icon').default,
  MountainIcon: require('./MountainIcon').default,
  Mouse01Icon: require('./Mouse01Icon').default,
  Mouse02Icon: require('./Mouse02Icon').default,
  Mouse03Icon: require('./Mouse03Icon').default,
  Mouse04Icon: require('./Mouse04Icon').default,
  Mouse05Icon: require('./Mouse05Icon').default,
  Mouse06Icon: require('./Mouse06Icon').default,
  Mouse07Icon: require('./Mouse07Icon').default,
  Mouse08Icon: require('./Mouse08Icon').default,
  Mouse09Icon: require('./Mouse09Icon').default,
  Mouse10Icon: require('./Mouse10Icon').default,
  Mouse11Icon: require('./Mouse11Icon').default,
  Mouse12Icon: require('./Mouse12Icon').default,
  Mouse13Icon: require('./Mouse13Icon').default,
  Mouse14Icon: require('./Mouse14Icon').default,
  Mouse15Icon: require('./Mouse15Icon').default,
  Mouse16Icon: require('./Mouse16Icon').default,
  Mouse17Icon: require('./Mouse17Icon').default,
  Mouse18Icon: require('./Mouse18Icon').default,
  Mouse19Icon: require('./Mouse19Icon').default,
  Mouse20Icon: require('./Mouse20Icon').default,
  Mouse21Icon: require('./Mouse21Icon').default,
  Mouse22Icon: require('./Mouse22Icon').default,
  Mouse23Icon: require('./Mouse23Icon').default,
  MouseLeftClick01Icon: require('./MouseLeftClick01Icon').default,
  MouseLeftClick02Icon: require('./MouseLeftClick02Icon').default,
  MouseLeftClick03Icon: require('./MouseLeftClick03Icon').default,
  MouseLeftClick04Icon: require('./MouseLeftClick04Icon').default,
  MouseLeftClick05Icon: require('./MouseLeftClick05Icon').default,
  MouseLeftClick06Icon: require('./MouseLeftClick06Icon').default,
  MousePointerOffIcon: require('./MousePointerOffIcon').default,
  MouseRightClick01Icon: require('./MouseRightClick01Icon').default,
  MouseRightClick02Icon: require('./MouseRightClick02Icon').default,
  MouseRightClick03Icon: require('./MouseRightClick03Icon').default,
  MouseRightClick04Icon: require('./MouseRightClick04Icon').default,
  MouseRightClick05Icon: require('./MouseRightClick05Icon').default,
  MouseRightClick06Icon: require('./MouseRightClick06Icon').default,
  MouseScroll01Icon: require('./MouseScroll01Icon').default,
  MouseScroll02Icon: require('./MouseScroll02Icon').default,
  Move01Icon: require('./Move01Icon').default,
  Move02Icon: require('./Move02Icon').default,
  MoveBottomIcon: require('./MoveBottomIcon').default,
  MoveLeftIcon: require('./MoveLeftIcon').default,
  MoveRightIcon: require('./MoveRightIcon').default,
  MoveIcon: require('./MoveIcon').default,
  MoveToIcon: require('./MoveToIcon').default,
  MoveTopIcon: require('./MoveTopIcon').default,
  MpThree02Icon: require('./MpThree02Icon').default,
  MpFour01Icon: require('./MpFour01Icon').default,
  MpFour02Icon: require('./MpFour02Icon').default,
  Mp301Icon: require('./Mp301Icon').default,
  MuhammadIcon: require('./MuhammadIcon').default,
  MultiplicationSignCircleIcon: require('./MultiplicationSignCircleIcon').default,
  MultiplicationSignSquareIcon: require('./MultiplicationSignSquareIcon').default,
  MultiplicationSignIcon: require('./MultiplicationSignIcon').default,
  Mushroom01Icon: require('./Mushroom01Icon').default,
  MushroomIcon: require('./MushroomIcon').default,
  MusicThreeIcon: require('./MusicThreeIcon').default,
  MusicNote01Icon: require('./MusicNote01Icon').default,
  MusicNote02Icon: require('./MusicNote02Icon').default,
  MusicNote03Icon: require('./MusicNote03Icon').default,
  MusicNote04Icon: require('./MusicNote04Icon').default,
  MusicNoteSquare01Icon: require('./MusicNoteSquare01Icon').default,
  MusicNoteSquare02Icon: require('./MusicNoteSquare02Icon').default,
  MuslimIcon: require('./MuslimIcon').default,
  MuteIcon: require('./MuteIcon').default,
  MymindIcon: require('./MymindIcon').default,
  NThRootCircleIcon: require('./NThRootCircleIcon').default,
  NThRootSquareIcon: require('./NThRootSquareIcon').default,
  NThRootIcon: require('./NThRootIcon').default,
  NanoTechnologyIcon: require('./NanoTechnologyIcon').default,
  Napkins01Icon: require('./Napkins01Icon').default,
  Napkins02Icon: require('./Napkins02Icon').default,
  NaturalFoodIcon: require('./NaturalFoodIcon').default,
  Navigation01Icon: require('./Navigation01Icon').default,
  Navigation02Icon: require('./Navigation02Icon').default,
  Navigation03Icon: require('./Navigation03Icon').default,
  Navigation04Icon: require('./Navigation04Icon').default,
  Navigation05Icon: require('./Navigation05Icon').default,
  Navigation06Icon: require('./Navigation06Icon').default,
  NavigationTwoOffIcon: require('./NavigationTwoOffIcon').default,
  NavigationTwoIcon: require('./NavigationTwoIcon').default,
  NavigationOffIcon: require('./NavigationOffIcon').default,
  NavigationIcon: require('./NavigationIcon').default,
  Navigator01Icon: require('./Navigator01Icon').default,
  Navigator02Icon: require('./Navigator02Icon').default,
  NecklaceIcon: require('./NecklaceIcon').default,
  NerdIcon: require('./NerdIcon').default,
  NeuralNetworkIcon: require('./NeuralNetworkIcon').default,
  NeutralIcon: require('./NeutralIcon').default,
  NewJobIcon: require('./NewJobIcon').default,
  NewOfficeIcon: require('./NewOfficeIcon').default,
  NewReleasesIcon: require('./NewReleasesIcon').default,
  NewTwitterEllipseIcon: require('./NewTwitterEllipseIcon').default,
  NewTwitterRectangleIcon: require('./NewTwitterRectangleIcon').default,
  NewTwitterIcon: require('./NewTwitterIcon').default,
  News01Icon: require('./News01Icon').default,
  NewsIcon: require('./NewsIcon').default,
  NextIcon: require('./NextIcon').default,
  NextWeekIcon: require('./NextWeekIcon').default,
  NfcIcon: require('./NfcIcon').default,
  NikeIcon: require('./NikeIcon').default,
  NineCircleIcon: require('./NineCircleIcon').default,
  NineSquareIcon: require('./NineSquareIcon').default,
  NintendoIcon: require('./NintendoIcon').default,
  NintendoSwitchIcon: require('./NintendoSwitchIcon').default,
  NiqabIcon: require('./NiqabIcon').default,
  NoInternetIcon: require('./NoInternetIcon').default,
  NoMeetingRoomIcon: require('./NoMeetingRoomIcon').default,
  NoSignalIcon: require('./NoSignalIcon').default,
  NodeAddIcon: require('./NodeAddIcon').default,
  NodeEditIcon: require('./NodeEditIcon').default,
  NodeMoveDownIcon: require('./NodeMoveDownIcon').default,
  NodeMoveUpIcon: require('./NodeMoveUpIcon').default,
  NodeRemoveIcon: require('./NodeRemoveIcon').default,
  NoodlesIcon: require('./NoodlesIcon').default,
  NoseIcon: require('./NoseIcon').default,
  NotEqualSignCircleIcon: require('./NotEqualSignCircleIcon').default,
  NotEqualSignSquareIcon: require('./NotEqualSignSquareIcon').default,
  NotEqualSignIcon: require('./NotEqualSignIcon').default,
  Note01Icon: require('./Note01Icon').default,
  Note02Icon: require('./Note02Icon').default,
  Note03Icon: require('./Note03Icon').default,
  Note04Icon: require('./Note04Icon').default,
  Note05Icon: require('./Note05Icon').default,
  NoteAddIcon: require('./NoteAddIcon').default,
  NoteDoneIcon: require('./NoteDoneIcon').default,
  NoteEditIcon: require('./NoteEditIcon').default,
  NoteRemoveIcon: require('./NoteRemoveIcon').default,
  NoteIcon: require('./NoteIcon').default,
  Notebook01Icon: require('./Notebook01Icon').default,
  Notebook02Icon: require('./Notebook02Icon').default,
  NotebookIcon: require('./NotebookIcon').default,
  NotepadTextDashedIcon: require('./NotepadTextDashedIcon').default,
  Notification01Icon: require('./Notification01Icon').default,
  Notification02Icon: require('./Notification02Icon').default,
  Notification03Icon: require('./Notification03Icon').default,
  NotificationBlock01Icon: require('./NotificationBlock01Icon').default,
  NotificationBlock02Icon: require('./NotificationBlock02Icon').default,
  NotificationBlock03Icon: require('./NotificationBlock03Icon').default,
  NotificationBubbleIcon: require('./NotificationBubbleIcon').default,
  NotificationCircleIcon: require('./NotificationCircleIcon').default,
  NotificationOff01Icon: require('./NotificationOff01Icon').default,
  NotificationOff02Icon: require('./NotificationOff02Icon').default,
  NotificationOff03Icon: require('./NotificationOff03Icon').default,
  NotificationSnooze01Icon: require('./NotificationSnooze01Icon').default,
  NotificationSnooze02Icon: require('./NotificationSnooze02Icon').default,
  NotificationSnooze03Icon: require('./NotificationSnooze03Icon').default,
  NotificationSquareIcon: require('./NotificationSquareIcon').default,
  Notion01Icon: require('./Notion01Icon').default,
  Notion02Icon: require('./Notion02Icon').default,
  NpmIcon: require('./NpmIcon').default,
  NuclearPowerIcon: require('./NuclearPowerIcon').default,
  NutOffIcon: require('./NutOffIcon').default,
  NutIcon: require('./NutIcon').default,
  ObtuseIcon: require('./ObtuseIcon').default,
  OctagonIcon: require('./OctagonIcon').default,
  OctagonXIcon: require('./OctagonXIcon').default,
  OctopusIcon: require('./OctopusIcon').default,
  Office365Icon: require('./Office365Icon').default,
  OfficeChairIcon: require('./OfficeChairIcon').default,
  OfficeIcon: require('./OfficeIcon').default,
  OilBarrelIcon: require('./OilBarrelIcon').default,
  OkFingerIcon: require('./OkFingerIcon').default,
  OlympicTorchIcon: require('./OlympicTorchIcon').default,
  OneCircleIcon: require('./OneCircleIcon').default,
  OneSquareIcon: require('./OneSquareIcon').default,
  OnlineLearning01Icon: require('./OnlineLearning01Icon').default,
  OnlineLearning02Icon: require('./OnlineLearning02Icon').default,
  OnlineLearning03Icon: require('./OnlineLearning03Icon').default,
  OnlineLearning04Icon: require('./OnlineLearning04Icon').default,
  OpenCaptionIcon: require('./OpenCaptionIcon').default,
  OpenSourceIcon: require('./OpenSourceIcon').default,
  OptionIcon: require('./OptionIcon').default,
  OptionsCallIcon: require('./OptionsCallIcon').default,
  OrangeIcon: require('./OrangeIcon').default,
  Orbit01Icon: require('./Orbit01Icon').default,
  Orbit02Icon: require('./Orbit02Icon').default,
  OrganicFoodIcon: require('./OrganicFoodIcon').default,
  OrientationImageLandscapeToPotraitIcon: require('./OrientationImageLandscapeToPotraitIcon').default,
  OrientationImagePotraitToLandscapeIcon: require('./OrientationImagePotraitToLandscapeIcon').default,
  OrientationLandscapeToPotraitIcon: require('./OrientationLandscapeToPotraitIcon').default,
  OrientationPotraitToLandscapeIcon: require('./OrientationPotraitToLandscapeIcon').default,
  OrigamiIcon: require('./OrigamiIcon').default,
  OrthogonalEdgeIcon: require('./OrthogonalEdgeIcon').default,
  OvalIcon: require('./OvalIcon').default,
  OvenIcon: require('./OvenIcon').default,
  Package01Icon: require('./Package01Icon').default,
  Package02Icon: require('./Package02Icon').default,
  Package03Icon: require('./Package03Icon').default,
  PackageAdd01Icon: require('./PackageAdd01Icon').default,
  PackageAddIcon: require('./PackageAddIcon').default,
  PackageDelivered01Icon: require('./PackageDelivered01Icon').default,
  PackageDeliveredIcon: require('./PackageDeliveredIcon').default,
  PackageDimensions01Icon: require('./PackageDimensions01Icon').default,
  PackageDimensions02Icon: require('./PackageDimensions02Icon').default,
  PackageMoving01Icon: require('./PackageMoving01Icon').default,
  PackageMovingIcon: require('./PackageMovingIcon').default,
  PackageOpenIcon: require('./PackageOpenIcon').default,
  PackageOutOfStockIcon: require('./PackageOutOfStockIcon').default,
  PackageProcess01Icon: require('./PackageProcess01Icon').default,
  PackageProcessIcon: require('./PackageProcessIcon').default,
  PackageReceive01Icon: require('./PackageReceive01Icon').default,
  PackageReceiveIcon: require('./PackageReceiveIcon').default,
  PackageRemove01Icon: require('./PackageRemove01Icon').default,
  PackageRemoveIcon: require('./PackageRemoveIcon').default,
  PackageSearch01Icon: require('./PackageSearch01Icon').default,
  PackageSearchIcon: require('./PackageSearchIcon').default,
  PackageSent01Icon: require('./PackageSent01Icon').default,
  PackageSentIcon: require('./PackageSentIcon').default,
  PackageIcon: require('./PackageIcon').default,
  PackagingIcon: require('./PackagingIcon').default,
  Pacman01Icon: require('./Pacman01Icon').default,
  Pacman02Icon: require('./Pacman02Icon').default,
  PaellaIcon: require('./PaellaIcon').default,
  PaintBoardIcon: require('./PaintBoardIcon').default,
  PaintBrush01Icon: require('./PaintBrush01Icon').default,
  PaintBrush02Icon: require('./PaintBrush02Icon').default,
  PaintBrush03Icon: require('./PaintBrush03Icon').default,
  PaintBrush04Icon: require('./PaintBrush04Icon').default,
  PaintBucketIcon: require('./PaintBucketIcon').default,
  Pan01Icon: require('./Pan01Icon').default,
  Pan02Icon: require('./Pan02Icon').default,
  Pan03Icon: require('./Pan03Icon').default,
  PanelBottomCloseIcon: require('./PanelBottomCloseIcon').default,
  PanelLeftCloseIcon: require('./PanelLeftCloseIcon').default,
  PanelLeftDashedIcon: require('./PanelLeftDashedIcon').default,
  PanelLeftOpenIcon: require('./PanelLeftOpenIcon').default,
  PanelLeftIcon: require('./PanelLeftIcon').default,
  PanelRightCloseIcon: require('./PanelRightCloseIcon').default,
  PanelRightDashedIcon: require('./PanelRightDashedIcon').default,
  PanelRightOpenIcon: require('./PanelRightOpenIcon').default,
  PanelRightIcon: require('./PanelRightIcon').default,
  PanelTopBottomDashedIcon: require('./PanelTopBottomDashedIcon').default,
  Parabola01Icon: require('./Parabola01Icon').default,
  Parabola02Icon: require('./Parabola02Icon').default,
  Parabola03Icon: require('./Parabola03Icon').default,
  ParaglidingIcon: require('./ParaglidingIcon').default,
  ParagraphBulletsPoint01Icon: require('./ParagraphBulletsPoint01Icon').default,
  ParagraphBulletsPoint02Icon: require('./ParagraphBulletsPoint02Icon').default,
  ParagraphSpacingIcon: require('./ParagraphSpacingIcon').default,
  ParagraphIcon: require('./ParagraphIcon').default,
  ParallelogramIcon: require('./ParallelogramIcon').default,
  ParkingAreaCircleIcon: require('./ParkingAreaCircleIcon').default,
  ParkingAreaSquareIcon: require('./ParkingAreaSquareIcon').default,
  ParkingMeterIcon: require('./ParkingMeterIcon').default,
  PartyIcon: require('./PartyIcon').default,
  Passport01Icon: require('./Passport01Icon').default,
  PassportExpiredIcon: require('./PassportExpiredIcon').default,
  PassportIcon: require('./PassportIcon').default,
  PassportValidIcon: require('./PassportValidIcon').default,
  PasswordValidationIcon: require('./PasswordValidationIcon').default,
  PathIcon: require('./PathIcon').default,
  PathfinderCropIcon: require('./PathfinderCropIcon').default,
  PathfinderDivideIcon: require('./PathfinderDivideIcon').default,
  PathfinderExcludeIcon: require('./PathfinderExcludeIcon').default,
  PathfinderIntersectIcon: require('./PathfinderIntersectIcon').default,
  PathfinderMergeIcon: require('./PathfinderMergeIcon').default,
  PathfinderMinusBackIcon: require('./PathfinderMinusBackIcon').default,
  PathfinderMinusFrontIcon: require('./PathfinderMinusFrontIcon').default,
  PathfinderOutlineIcon: require('./PathfinderOutlineIcon').default,
  PathfinderTrimIcon: require('./PathfinderTrimIcon').default,
  PathfinderUniteIcon: require('./PathfinderUniteIcon').default,
  PatientIcon: require('./PatientIcon').default,
  PatioIcon: require('./PatioIcon').default,
  PauseCircleIcon: require('./PauseCircleIcon').default,
  PauseIcon: require('./PauseIcon').default,
  PavilonIcon: require('./PavilonIcon').default,
  PayByCheckIcon: require('./PayByCheckIcon').default,
  Payment01Icon: require('./Payment01Icon').default,
  Payment02Icon: require('./Payment02Icon').default,
  PaymentSuccess01Icon: require('./PaymentSuccess01Icon').default,
  PaymentSuccess02Icon: require('./PaymentSuccess02Icon').default,
  PayoneerIcon: require('./PayoneerIcon').default,
  PaypalIcon: require('./PaypalIcon').default,
  PcCaseIcon: require('./PcCaseIcon').default,
  Pdf01Icon: require('./Pdf01Icon').default,
  Pdf02Icon: require('./Pdf02Icon').default,
  PeerToPeer01Icon: require('./PeerToPeer01Icon').default,
  PeerToPeer02Icon: require('./PeerToPeer02Icon').default,
  PeerToPeer03Icon: require('./PeerToPeer03Icon').default,
  Pen01Icon: require('./Pen01Icon').default,
  Pen02Icon: require('./Pen02Icon').default,
  PenConnectBluetoothIcon: require('./PenConnectBluetoothIcon').default,
  PenConnectUsbIcon: require('./PenConnectUsbIcon').default,
  PenConnectWifiIcon: require('./PenConnectWifiIcon').default,
  PenTool01Icon: require('./PenTool01Icon').default,
  PenTool02Icon: require('./PenTool02Icon').default,
  PenTool03Icon: require('./PenTool03Icon').default,
  PenToolAddIcon: require('./PenToolAddIcon').default,
  PenToolMinusIcon: require('./PenToolMinusIcon').default,
  PencilEdit01Icon: require('./PencilEdit01Icon').default,
  PencilEdit02Icon: require('./PencilEdit02Icon').default,
  PencilRulerIcon: require('./PencilRulerIcon').default,
  PencilIcon: require('./PencilIcon').default,
  PendulumIcon: require('./PendulumIcon').default,
  PensiveIcon: require('./PensiveIcon').default,
  Pentagon01Icon: require('./Pentagon01Icon').default,
  PentagonIcon: require('./PentagonIcon').default,
  PercentCircleIcon: require('./PercentCircleIcon').default,
  PercentSquareIcon: require('./PercentSquareIcon').default,
  PercentIcon: require('./PercentIcon').default,
  PerfumeIcon: require('./PerfumeIcon').default,
  PeriscopeIcon: require('./PeriscopeIcon').default,
  PermanentJobIcon: require('./PermanentJobIcon').default,
  PerplexityAiIcon: require('./PerplexityAiIcon').default,
  PerspectiveIcon: require('./PerspectiveIcon').default,
  PetrolPumpIcon: require('./PetrolPumpIcon').default,
  PexelsIcon: require('./PexelsIcon').default,
  PhilippinePesoIcon: require('./PhilippinePesoIcon').default,
  PhoneArrowDownIcon: require('./PhoneArrowDownIcon').default,
  PhoneArrowUpIcon: require('./PhoneArrowUpIcon').default,
  PhoneCheckIcon: require('./PhoneCheckIcon').default,
  PhoneDeveloperModeIcon: require('./PhoneDeveloperModeIcon').default,
  PhoneEraseIcon: require('./PhoneEraseIcon').default,
  PhoneLockIcon: require('./PhoneLockIcon').default,
  PhoneOff01Icon: require('./PhoneOff01Icon').default,
  PhoneOff02Icon: require('./PhoneOff02Icon').default,
  PhpIcon: require('./PhpIcon').default,
  PhysicsIcon: require('./PhysicsIcon').default,
  PiCircleIcon: require('./PiCircleIcon').default,
  PiSquareIcon: require('./PiSquareIcon').default,
  PiIcon: require('./PiIcon').default,
  PicasaIcon: require('./PicasaIcon').default,
  Pickup01Icon: require('./Pickup01Icon').default,
  Pickup02Icon: require('./Pickup02Icon').default,
  PictureInPictureExitIcon: require('./PictureInPictureExitIcon').default,
  PictureInPictureOnIcon: require('./PictureInPictureOnIcon').default,
  PieChart01Icon: require('./PieChart01Icon').default,
  PieChart02Icon: require('./PieChart02Icon').default,
  PieChart03Icon: require('./PieChart03Icon').default,
  PieChart04Icon: require('./PieChart04Icon').default,
  PieChart05Icon: require('./PieChart05Icon').default,
  PieChart06Icon: require('./PieChart06Icon').default,
  PieChart07Icon: require('./PieChart07Icon').default,
  PieChart08Icon: require('./PieChart08Icon').default,
  PieChart09Icon: require('./PieChart09Icon').default,
  PieChartSquareIcon: require('./PieChartSquareIcon').default,
  PieChartIcon: require('./PieChartIcon').default,
  PieIcon: require('./PieIcon').default,
  PiggyBankIcon: require('./PiggyBankIcon').default,
  PillBottleIcon: require('./PillBottleIcon').default,
  PillOffIcon: require('./PillOffIcon').default,
  PillIcon: require('./PillIcon').default,
  PillsTabletIcon: require('./PillsTabletIcon').default,
  Pin02Icon: require('./Pin02Icon').default,
  PinCodeIcon: require('./PinCodeIcon').default,
  PinLocation01Icon: require('./PinLocation01Icon').default,
  PinLocation02Icon: require('./PinLocation02Icon').default,
  PinLocation03Icon: require('./PinLocation03Icon').default,
  PinOffIcon: require('./PinOffIcon').default,
  PinIcon: require('./PinIcon').default,
  PineTreeIcon: require('./PineTreeIcon').default,
  PinterestIcon: require('./PinterestIcon').default,
  PipelineIcon: require('./PipelineIcon').default,
  PisaTowerIcon: require('./PisaTowerIcon').default,
  PivotIcon: require('./PivotIcon').default,
  Pizza01Icon: require('./Pizza01Icon').default,
  Pizza02Icon: require('./Pizza02Icon').default,
  Pizza03Icon: require('./Pizza03Icon').default,
  Pizza04Icon: require('./Pizza04Icon').default,
  PizzaCutterIcon: require('./PizzaCutterIcon').default,
  PlaneIcon: require('./PlaneIcon').default,
  Plant01Icon: require('./Plant01Icon').default,
  Plant02Icon: require('./Plant02Icon').default,
  Plant03Icon: require('./Plant03Icon').default,
  Plant04Icon: require('./Plant04Icon').default,
  PlateIcon: require('./PlateIcon').default,
  PlaxoIcon: require('./PlaxoIcon').default,
  PlayCircle02Icon: require('./PlayCircle02Icon').default,
  PlayCircleIcon: require('./PlayCircleIcon').default,
  PlayListAddIcon: require('./PlayListAddIcon').default,
  PlayListFavourite01Icon: require('./PlayListFavourite01Icon').default,
  PlayListFavourite02Icon: require('./PlayListFavourite02Icon').default,
  PlayListMinusIcon: require('./PlayListMinusIcon').default,
  PlayListRemoveIcon: require('./PlayListRemoveIcon').default,
  PlayListIcon: require('./PlayListIcon').default,
  PlaySquareIcon: require('./PlaySquareIcon').default,
  PlayStoreIcon: require('./PlayStoreIcon').default,
  PlayIcon: require('./PlayIcon').default,
  Playlist01Icon: require('./Playlist01Icon').default,
  Playlist02Icon: require('./Playlist02Icon').default,
  Playlist03Icon: require('./Playlist03Icon').default,
  PlazaIcon: require('./PlazaIcon').default,
  Plug01Icon: require('./Plug01Icon').default,
  Plug02Icon: require('./Plug02Icon').default,
  PlugSocketIcon: require('./PlugSocketIcon').default,
  PlusMinus01Icon: require('./PlusMinus01Icon').default,
  PlusMinus02Icon: require('./PlusMinus02Icon').default,
  PlusMinus03Icon: require('./PlusMinus03Icon').default,
  PlusMinusCircle01Icon: require('./PlusMinusCircle01Icon').default,
  PlusMinusCircle02Icon: require('./PlusMinusCircle02Icon').default,
  PlusMinusSquare01Icon: require('./PlusMinusSquare01Icon').default,
  PlusMinusSquare02Icon: require('./PlusMinusSquare02Icon').default,
  PlusMinusIcon: require('./PlusMinusIcon').default,
  PlusSignCircleIcon: require('./PlusSignCircleIcon').default,
  PlusSignSquareIcon: require('./PlusSignSquareIcon').default,
  PlusSignIcon: require('./PlusSignIcon').default,
  Png01Icon: require('./Png01Icon').default,
  Png02Icon: require('./Png02Icon').default,
  PocketKnifeIcon: require('./PocketKnifeIcon').default,
  PocketIcon: require('./PocketIcon').default,
  PodcastIcon: require('./PodcastIcon').default,
  PodiumIcon: require('./PodiumIcon').default,
  PointingLeft01Icon: require('./PointingLeft01Icon').default,
  PointingLeft02Icon: require('./PointingLeft02Icon').default,
  PointingLeft03Icon: require('./PointingLeft03Icon').default,
  PointingLeft04Icon: require('./PointingLeft04Icon').default,
  PointingLeft05Icon: require('./PointingLeft05Icon').default,
  PointingLeft06Icon: require('./PointingLeft06Icon').default,
  PointingLeft07Icon: require('./PointingLeft07Icon').default,
  PointingLeft08Icon: require('./PointingLeft08Icon').default,
  PointingRight01Icon: require('./PointingRight01Icon').default,
  PointingRight02Icon: require('./PointingRight02Icon').default,
  PointingRight03Icon: require('./PointingRight03Icon').default,
  PointingRight04Icon: require('./PointingRight04Icon').default,
  PointingRight05Icon: require('./PointingRight05Icon').default,
  PointingRight06Icon: require('./PointingRight06Icon').default,
  PointingRight07Icon: require('./PointingRight07Icon').default,
  PointingRight08Icon: require('./PointingRight08Icon').default,
  PokeballIcon: require('./PokeballIcon').default,
  PokemonIcon: require('./PokemonIcon').default,
  PoliceBadgeIcon: require('./PoliceBadgeIcon').default,
  PoliceCapIcon: require('./PoliceCapIcon').default,
  PoliceCarIcon: require('./PoliceCarIcon').default,
  PoliceStationIcon: require('./PoliceStationIcon').default,
  PolicyIcon: require('./PolicyIcon').default,
  PolyTankIcon: require('./PolyTankIcon').default,
  PolygonIcon: require('./PolygonIcon').default,
  PoolIcon: require('./PoolIcon').default,
  PoolTableIcon: require('./PoolTableIcon').default,
  PoopIcon: require('./PoopIcon').default,
  PopcornIcon: require('./PopcornIcon').default,
  PopsicleIcon: require('./PopsicleIcon').default,
  Pot01Icon: require('./Pot01Icon').default,
  Pot02Icon: require('./Pot02Icon').default,
  PotionIcon: require('./PotionIcon').default,
  PoundCircleIcon: require('./PoundCircleIcon').default,
  PoundReceiveIcon: require('./PoundReceiveIcon').default,
  PoundSendIcon: require('./PoundSendIcon').default,
  PoundSquareIcon: require('./PoundSquareIcon').default,
  PoundIcon: require('./PoundIcon').default,
  PowerOffIcon: require('./PowerOffIcon').default,
  PowerServiceIcon: require('./PowerServiceIcon').default,
  PowerSocket01Icon: require('./PowerSocket01Icon').default,
  PowerSocket02Icon: require('./PowerSocket02Icon').default,
  PowerIcon: require('./PowerIcon').default,
  Ppt01Icon: require('./Ppt01Icon').default,
  Ppt02Icon: require('./Ppt02Icon').default,
  PrawnIcon: require('./PrawnIcon').default,
  PrayerRug01Icon: require('./PrayerRug01Icon').default,
  PrayerRug02Icon: require('./PrayerRug02Icon').default,
  PreferenceHorizontalIcon: require('./PreferenceHorizontalIcon').default,
  PreferenceVerticalIcon: require('./PreferenceVerticalIcon').default,
  PrescriptionIcon: require('./PrescriptionIcon').default,
  PrescriptionsIcon: require('./PrescriptionsIcon').default,
  Presentation01Icon: require('./Presentation01Icon').default,
  Presentation02Icon: require('./Presentation02Icon').default,
  Presentation03Icon: require('./Presentation03Icon').default,
  Presentation04Icon: require('./Presentation04Icon').default,
  Presentation05Icon: require('./Presentation05Icon').default,
  Presentation06Icon: require('./Presentation06Icon').default,
  Presentation07Icon: require('./Presentation07Icon').default,
  PresentationBarChart01Icon: require('./PresentationBarChart01Icon').default,
  PresentationBarChart02Icon: require('./PresentationBarChart02Icon').default,
  PresentationLineChart01Icon: require('./PresentationLineChart01Icon').default,
  PresentationLineChart02Icon: require('./PresentationLineChart02Icon').default,
  PresentationOnlineIcon: require('./PresentationOnlineIcon').default,
  PresentationPodiumIcon: require('./PresentationPodiumIcon').default,
  PreviousIcon: require('./PreviousIcon').default,
  PrinterThreeDIcon: require('./PrinterThreeDIcon').default,
  PrinterCheckIcon: require('./PrinterCheckIcon').default,
  PrinterOffIcon: require('./PrinterOffIcon').default,
  PrinterIcon: require('./PrinterIcon').default,
  PrinterXIcon: require('./PrinterXIcon').default,
  Prism01Icon: require('./Prism01Icon').default,
  PrismIcon: require('./PrismIcon').default,
  PrisonGuardIcon: require('./PrisonGuardIcon').default,
  PrisonIcon: require('./PrisonIcon').default,
  PrisonerIcon: require('./PrisonerIcon').default,
  ProductLoadingIcon: require('./ProductLoadingIcon').default,
  Profile02Icon: require('./Profile02Icon').default,
  ProfileIcon: require('./ProfileIcon').default,
  ProfitIcon: require('./ProfitIcon').default,
  ProgrammingFlagIcon: require('./ProgrammingFlagIcon').default,
  Progress01Icon: require('./Progress01Icon').default,
  Progress02Icon: require('./Progress02Icon').default,
  Progress03Icon: require('./Progress03Icon').default,
  Progress04Icon: require('./Progress04Icon').default,
  ProgressIcon: require('./ProgressIcon').default,
  Projector01Icon: require('./Projector01Icon').default,
  ProjectorIcon: require('./ProjectorIcon').default,
  PromotionIcon: require('./PromotionIcon').default,
  PropertyAddIcon: require('./PropertyAddIcon').default,
  PropertyDeleteIcon: require('./PropertyDeleteIcon').default,
  PropertyEditIcon: require('./PropertyEditIcon').default,
  PropertyNewIcon: require('./PropertyNewIcon').default,
  PropertySearchIcon: require('./PropertySearchIcon').default,
  PropertyViewIcon: require('./PropertyViewIcon').default,
  ProportionsIcon: require('./ProportionsIcon').default,
  ProtectionMaskIcon: require('./ProtectionMaskIcon').default,
  PulleyIcon: require('./PulleyIcon').default,
  Pulse01Icon: require('./Pulse01Icon').default,
  Pulse02Icon: require('./Pulse02Icon').default,
  PulseRectangle01Icon: require('./PulseRectangle01Icon').default,
  PulseRectangle02Icon: require('./PulseRectangle02Icon').default,
  PumpkinIcon: require('./PumpkinIcon').default,
  PunchIcon: require('./PunchIcon').default,
  PunchingBall01Icon: require('./PunchingBall01Icon').default,
  PunchingBall02Icon: require('./PunchingBall02Icon').default,
  Purse01Icon: require('./Purse01Icon').default,
  PurseIcon: require('./PurseIcon').default,
  PushUpBarIcon: require('./PushUpBarIcon').default,
  PuzzleIcon: require('./PuzzleIcon').default,
  PyramidMaslowoIcon: require('./PyramidMaslowoIcon').default,
  PyramidIcon: require('./PyramidIcon').default,
  PyramidStructure01Icon: require('./PyramidStructure01Icon').default,
  PyramidStructure02Icon: require('./PyramidStructure02Icon').default,
  PythonIcon: require('./PythonIcon').default,
  QqPlotIcon: require('./QqPlotIcon').default,
  QrCode01Icon: require('./QrCode01Icon').default,
  QrCodeScanIcon: require('./QrCodeScanIcon').default,
  QrCodeIcon: require('./QrCodeIcon').default,
  QuestionIcon: require('./QuestionIcon').default,
  Queue01Icon: require('./Queue01Icon').default,
  Queue02Icon: require('./Queue02Icon').default,
  QuillWrite01Icon: require('./QuillWrite01Icon').default,
  QuillWrite02Icon: require('./QuillWrite02Icon').default,
  Quiz01Icon: require('./Quiz01Icon').default,
  Quiz02Icon: require('./Quiz02Icon').default,
  Quiz03Icon: require('./Quiz03Icon').default,
  Quiz04Icon: require('./Quiz04Icon').default,
  Quiz05Icon: require('./Quiz05Icon').default,
  QuoraIcon: require('./QuoraIcon').default,
  QuoteDownCircleIcon: require('./QuoteDownCircleIcon').default,
  QuoteDownSquareIcon: require('./QuoteDownSquareIcon').default,
  QuoteDownIcon: require('./QuoteDownIcon').default,
  QuoteUpCircleIcon: require('./QuoteUpCircleIcon').default,
  QuoteUpSquareIcon: require('./QuoteUpSquareIcon').default,
  QuoteUpIcon: require('./QuoteUpIcon').default,
  QuotesIcon: require('./QuotesIcon').default,
  Quran01Icon: require('./Quran01Icon').default,
  Quran02Icon: require('./Quran02Icon').default,
  Quran03Icon: require('./Quran03Icon').default,
  QwenIcon: require('./QwenIcon').default,
  RacingFlagIcon: require('./RacingFlagIcon').default,
  Radar01Icon: require('./Radar01Icon').default,
  Radar02Icon: require('./Radar02Icon').default,
  Radar03Icon: require('./Radar03Icon').default,
  RadialIcon: require('./RadialIcon').default,
  RadiationIcon: require('./RadiationIcon').default,
  Radio01Icon: require('./Radio01Icon').default,
  Radio02Icon: require('./Radio02Icon').default,
  RadioButtonIcon: require('./RadioButtonIcon').default,
  RadioIcon: require('./RadioIcon').default,
  RadioactiveAlertIcon: require('./RadioactiveAlertIcon').default,
  RadiusIcon: require('./RadiusIcon').default,
  RailSymbolIcon: require('./RailSymbolIcon').default,
  RainDoubleDropIcon: require('./RainDoubleDropIcon').default,
  RainDropIcon: require('./RainDropIcon').default,
  RainIcon: require('./RainIcon').default,
  RainbowIcon: require('./RainbowIcon').default,
  RamMemoryIcon: require('./RamMemoryIcon').default,
  Ramadhan01Icon: require('./Ramadhan01Icon').default,
  Ramadhan02Icon: require('./Ramadhan02Icon').default,
  RamadhanMonthIcon: require('./RamadhanMonthIcon').default,
  RankingIcon: require('./RankingIcon').default,
  Rar01Icon: require('./Rar01Icon').default,
  Rar02Icon: require('./Rar02Icon').default,
  RatioIcon: require('./RatioIcon').default,
  Raw01Icon: require('./Raw01Icon').default,
  Raw02Icon: require('./Raw02Icon').default,
  ReIcon: require('./ReIcon').default,
  ReactIcon: require('./ReactIcon').default,
  RealEstate01Icon: require('./RealEstate01Icon').default,
  RealEstate02Icon: require('./RealEstate02Icon').default,
  ReceiptCentIcon: require('./ReceiptCentIcon').default,
  ReceiptDollarIcon: require('./ReceiptDollarIcon').default,
  ReceiptEuroIcon: require('./ReceiptEuroIcon').default,
  ReceiptIndianRupeeIcon: require('./ReceiptIndianRupeeIcon').default,
  ReceiptJapaneseYenIcon: require('./ReceiptJapaneseYenIcon').default,
  ReceiptPoundSterlingIcon: require('./ReceiptPoundSterlingIcon').default,
  ReceiptRussianRubleIcon: require('./ReceiptRussianRubleIcon').default,
  ReceiptSwissFrancIcon: require('./ReceiptSwissFrancIcon').default,
  ReceiptTextIcon: require('./ReceiptTextIcon').default,
  ReceiptTurkishLiraIcon: require('./ReceiptTurkishLiraIcon').default,
  RecordIcon: require('./RecordIcon').default,
  RecoveryMailIcon: require('./RecoveryMailIcon').default,
  RectangleCircleIcon: require('./RectangleCircleIcon').default,
  Rectangular01Icon: require('./Rectangular01Icon').default,
  RectangularIcon: require('./RectangularIcon').default,
  Recycle01Icon: require('./Recycle01Icon').default,
  Recycle02Icon: require('./Recycle02Icon').default,
  Recycle03Icon: require('./Recycle03Icon').default,
  RedditIcon: require('./RedditIcon').default,
  Redo02Icon: require('./Redo02Icon').default,
  Redo03Icon: require('./Redo03Icon').default,
  RedoDotIcon: require('./RedoDotIcon').default,
  RedoIcon: require('./RedoIcon').default,
  ReduceParagraphIcon: require('./ReduceParagraphIcon').default,
  ReflexIcon: require('./ReflexIcon').default,
  Refresh01Icon: require('./Refresh01Icon').default,
  Refresh03Icon: require('./Refresh03Icon').default,
  Refresh04Icon: require('./Refresh04Icon').default,
  RefreshCwOffIcon: require('./RefreshCwOffIcon').default,
  RefreshDotIcon: require('./RefreshDotIcon').default,
  RefreshIcon: require('./RefreshIcon').default,
  RefrigeratorIcon: require('./RefrigeratorIcon').default,
  RegexIcon: require('./RegexIcon').default,
  RegisterIcon: require('./RegisterIcon').default,
  RegisteredIcon: require('./RegisteredIcon').default,
  Relieved01Icon: require('./Relieved01Icon').default,
  Relieved02Icon: require('./Relieved02Icon').default,
  ReloadIcon: require('./ReloadIcon').default,
  ReminderIcon: require('./ReminderIcon').default,
  RemoteControlIcon: require('./RemoteControlIcon').default,
  Remove01Icon: require('./Remove01Icon').default,
  Remove02Icon: require('./Remove02Icon').default,
  RemoveCircleHalfDotIcon: require('./RemoveCircleHalfDotIcon').default,
  RemoveCircleIcon: require('./RemoveCircleIcon').default,
  RemoveFemaleIcon: require('./RemoveFemaleIcon').default,
  RemoveMaleIcon: require('./RemoveMaleIcon').default,
  RemovePiIcon: require('./RemovePiIcon').default,
  RemoveSquareIcon: require('./RemoveSquareIcon').default,
  RenewableEnergy01Icon: require('./RenewableEnergy01Icon').default,
  RenewableEnergyIcon: require('./RenewableEnergyIcon').default,
  RepairIcon: require('./RepairIcon').default,
  RepeatOffIcon: require('./RepeatOffIcon').default,
  RepeatOne01Icon: require('./RepeatOne01Icon').default,
  RepeatOne02Icon: require('./RepeatOne02Icon').default,
  RepeatIcon: require('./RepeatIcon').default,
  ReplaceAllIcon: require('./ReplaceAllIcon').default,
  ReplaceIcon: require('./ReplaceIcon').default,
  ReplayIcon: require('./ReplayIcon').default,
  ReplitIcon: require('./ReplitIcon').default,
  RepositoryIcon: require('./RepositoryIcon').default,
  RepostIcon: require('./RepostIcon').default,
  ResetPasswordIcon: require('./ResetPasswordIcon').default,
  Resize01Icon: require('./Resize01Icon').default,
  Resize02Icon: require('./Resize02Icon').default,
  ResizeFieldRectangleIcon: require('./ResizeFieldRectangleIcon').default,
  ResizeFieldIcon: require('./ResizeFieldIcon').default,
  ResourcesAddIcon: require('./ResourcesAddIcon').default,
  ResourcesRemoveIcon: require('./ResourcesRemoveIcon').default,
  Restaurant01Icon: require('./Restaurant01Icon').default,
  Restaurant02Icon: require('./Restaurant02Icon').default,
  Restaurant03Icon: require('./Restaurant03Icon').default,
  RestaurantIcon: require('./RestaurantIcon').default,
  RestaurantTableIcon: require('./RestaurantTableIcon').default,
  RestoreBinIcon: require('./RestoreBinIcon').default,
  ReturnRequestIcon: require('./ReturnRequestIcon').default,
  ReverseWithdrawal01Icon: require('./ReverseWithdrawal01Icon').default,
  ReverseWithdrawal02Icon: require('./ReverseWithdrawal02Icon').default,
  Rhombus01Icon: require('./Rhombus01Icon').default,
  RhombusIcon: require('./RhombusIcon').default,
  RibbonIcon: require('./RibbonIcon').default,
  RiceBowl01Icon: require('./RiceBowl01Icon').default,
  RiceBowl02Icon: require('./RiceBowl02Icon').default,
  RightAngleIcon: require('./RightAngleIcon').default,
  RightToLeftBlockQuoteIcon: require('./RightToLeftBlockQuoteIcon').default,
  RightToLeftListBulletIcon: require('./RightToLeftListBulletIcon').default,
  RightToLeftListDashIcon: require('./RightToLeftListDashIcon').default,
  RightToLeftListNumberIcon: require('./RightToLeftListNumberIcon').default,
  RightToLeftListTriangleIcon: require('./RightToLeftListTriangleIcon').default,
  RightTriangleIcon: require('./RightTriangleIcon').default,
  RippleIcon: require('./RippleIcon').default,
  RiyalRectangleIcon: require('./RiyalRectangleIcon').default,
  RiyalIcon: require('./RiyalIcon').default,
  Road01Icon: require('./Road01Icon').default,
  Road02Icon: require('./Road02Icon').default,
  RoadLocation01Icon: require('./RoadLocation01Icon').default,
  RoadLocation02Icon: require('./RoadLocation02Icon').default,
  RoadIcon: require('./RoadIcon').default,
  RoadWaysideIcon: require('./RoadWaysideIcon').default,
  Robot01Icon: require('./Robot01Icon').default,
  Robot02Icon: require('./Robot02Icon').default,
  RoboticIcon: require('./RoboticIcon').default,
  Rocket01Icon: require('./Rocket01Icon').default,
  Rocket02Icon: require('./Rocket02Icon').default,
  RocketIcon: require('./RocketIcon').default,
  RockingChairIcon: require('./RockingChairIcon').default,
  RockingHorseIcon: require('./RockingHorseIcon').default,
  RollerCoasterIcon: require('./RollerCoasterIcon').default,
  RollerSkateIcon: require('./RollerSkateIcon').default,
  RollingPinIcon: require('./RollingPinIcon').default,
  Root01Icon: require('./Root01Icon').default,
  Root02Icon: require('./Root02Icon').default,
  RootFirstBracketIcon: require('./RootFirstBracketIcon').default,
  RootSecondBracketIcon: require('./RootSecondBracketIcon').default,
  RootThirdBracketIcon: require('./RootThirdBracketIcon').default,
  RootCircleIcon: require('./RootCircleIcon').default,
  RoseIcon: require('./RoseIcon').default,
  Rotate01Icon: require('./Rotate01Icon').default,
  Rotate02Icon: require('./Rotate02Icon').default,
  Rotate360Icon: require('./Rotate360Icon').default,
  RotateBottomLeftIcon: require('./RotateBottomLeftIcon').default,
  RotateBottomRightIcon: require('./RotateBottomRightIcon').default,
  RotateCcwSquareIcon: require('./RotateCcwSquareIcon').default,
  RotateClockwiseIcon: require('./RotateClockwiseIcon').default,
  RotateCropIcon: require('./RotateCropIcon').default,
  RotateCwSquareIcon: require('./RotateCwSquareIcon').default,
  RotateLeft01Icon: require('./RotateLeft01Icon').default,
  RotateLeft02Icon: require('./RotateLeft02Icon').default,
  RotateLeft03Icon: require('./RotateLeft03Icon').default,
  RotateLeft04Icon: require('./RotateLeft04Icon').default,
  RotateLeft05Icon: require('./RotateLeft05Icon').default,
  RotateLeft06Icon: require('./RotateLeft06Icon').default,
  RotateRight01Icon: require('./RotateRight01Icon').default,
  RotateRight02Icon: require('./RotateRight02Icon').default,
  RotateRight03Icon: require('./RotateRight03Icon').default,
  RotateRight04Icon: require('./RotateRight04Icon').default,
  RotateRight05Icon: require('./RotateRight05Icon').default,
  RotateRight06Icon: require('./RotateRight06Icon').default,
  RotateSquareIcon: require('./RotateSquareIcon').default,
  RotateTopLeftIcon: require('./RotateTopLeftIcon').default,
  RotateTopRightIcon: require('./RotateTopRightIcon').default,
  Route01Icon: require('./Route01Icon').default,
  Route02Icon: require('./Route02Icon').default,
  Route03Icon: require('./Route03Icon').default,
  RouteBlockIcon: require('./RouteBlockIcon').default,
  Router01Icon: require('./Router01Icon').default,
  Router02Icon: require('./Router02Icon').default,
  RouterIcon: require('./RouterIcon').default,
  RowDeleteIcon: require('./RowDeleteIcon').default,
  RowInsertIcon: require('./RowInsertIcon').default,
  RssConnected01Icon: require('./RssConnected01Icon').default,
  RssConnected02Icon: require('./RssConnected02Icon').default,
  RssErrorIcon: require('./RssErrorIcon').default,
  RssLockedIcon: require('./RssLockedIcon').default,
  RssIcon: require('./RssIcon').default,
  RssUnlockedIcon: require('./RssUnlockedIcon').default,
  RubElHizbIcon: require('./RubElHizbIcon').default,
  RubberDuckIcon: require('./RubberDuckIcon').default,
  RubiksCubeIcon: require('./RubiksCubeIcon').default,
  RukuIcon: require('./RukuIcon').default,
  RulerIcon: require('./RulerIcon').default,
  RunningShoesIcon: require('./RunningShoesIcon').default,
  RupeeCircleIcon: require('./RupeeCircleIcon').default,
  RupeeShieldIcon: require('./RupeeShieldIcon').default,
  RupeeSquareIcon: require('./RupeeSquareIcon').default,
  RupeeIcon: require('./RupeeIcon').default,
  RussianRubleIcon: require('./RussianRubleIcon').default,
  Sad01Icon: require('./Sad01Icon').default,
  Sad02Icon: require('./Sad02Icon').default,
  SadDizzyIcon: require('./SadDizzyIcon').default,
  SafariIcon: require('./SafariIcon').default,
  SafeBoxIcon: require('./SafeBoxIcon').default,
  SafeDelivery01Icon: require('./SafeDelivery01Icon').default,
  SafeDelivery02Icon: require('./SafeDelivery02Icon').default,
  SafeIcon: require('./SafeIcon').default,
  SafetyPin01Icon: require('./SafetyPin01Icon').default,
  SafetyPin02Icon: require('./SafetyPin02Icon').default,
  SailboatCoastalIcon: require('./SailboatCoastalIcon').default,
  SailboatOffshoreIcon: require('./SailboatOffshoreIcon').default,
  SakuraIcon: require('./SakuraIcon').default,
  SaladIcon: require('./SaladIcon').default,
  SalahIcon: require('./SalahIcon').default,
  SalahTimeIcon: require('./SalahTimeIcon').default,
  SaleTag01Icon: require('./SaleTag01Icon').default,
  SaleTag02Icon: require('./SaleTag02Icon').default,
  SandalsIcon: require('./SandalsIcon').default,
  Satellite01Icon: require('./Satellite01Icon').default,
  Satellite02Icon: require('./Satellite02Icon').default,
  Satellite03Icon: require('./Satellite03Icon').default,
  SatelliteIcon: require('./SatelliteIcon').default,
  Saturn01Icon: require('./Saturn01Icon').default,
  Saturn02Icon: require('./Saturn02Icon').default,
  SaturnIcon: require('./SaturnIcon').default,
  SaudiRiyalIcon: require('./SaudiRiyalIcon').default,
  SausageIcon: require('./SausageIcon').default,
  SaveAllIcon: require('./SaveAllIcon').default,
  SaveEnergy01Icon: require('./SaveEnergy01Icon').default,
  SaveEnergy02Icon: require('./SaveEnergy02Icon').default,
  SaveMoneyDollarIcon: require('./SaveMoneyDollarIcon').default,
  SaveMoneyEuroIcon: require('./SaveMoneyEuroIcon').default,
  SaveMoneyPoundIcon: require('./SaveMoneyPoundIcon').default,
  SaveMoneyYenIcon: require('./SaveMoneyYenIcon').default,
  SaveOffIcon: require('./SaveOffIcon').default,
  SaveIcon: require('./SaveIcon').default,
  SavingsIcon: require('./SavingsIcon').default,
  ScanEyeIcon: require('./ScanEyeIcon').default,
  ScanHeartIcon: require('./ScanHeartIcon').default,
  ScanImageIcon: require('./ScanImageIcon').default,
  ScanIcon: require('./ScanIcon').default,
  SchemeIcon: require('./SchemeIcon').default,
  School01Icon: require('./School01Icon').default,
  SchoolBell01Icon: require('./SchoolBell01Icon').default,
  SchoolBell02Icon: require('./SchoolBell02Icon').default,
  SchoolBusIcon: require('./SchoolBusIcon').default,
  SchoolReportCardIcon: require('./SchoolReportCardIcon').default,
  SchoolIcon: require('./SchoolIcon').default,
  SchoolTieIcon: require('./SchoolTieIcon').default,
  Scissor01Icon: require('./Scissor01Icon').default,
  ScissorRectangleIcon: require('./ScissorRectangleIcon').default,
  ScissorIcon: require('./ScissorIcon').default,
  Scooter01Icon: require('./Scooter01Icon').default,
  Scooter02Icon: require('./Scooter02Icon').default,
  Scooter03Icon: require('./Scooter03Icon').default,
  Scooter04Icon: require('./Scooter04Icon').default,
  ScooterElectricIcon: require('./ScooterElectricIcon').default,
  ScratchCardIcon: require('./ScratchCardIcon').default,
  ScreenAddToHome02Icon: require('./ScreenAddToHome02Icon').default,
  ScreenAddToHomeIcon: require('./ScreenAddToHomeIcon').default,
  ScreenLockRotationIcon: require('./ScreenLockRotationIcon').default,
  ScreenRotationIcon: require('./ScreenRotationIcon').default,
  ScribdIcon: require('./ScribdIcon').default,
  Scroll01Icon: require('./Scroll01Icon').default,
  ScrollHorizontalIcon: require('./ScrollHorizontalIcon').default,
  ScrollIcon: require('./ScrollIcon').default,
  ScrollVerticalIcon: require('./ScrollVerticalIcon').default,
  SdCardIcon: require('./SdCardIcon').default,
  SealIcon: require('./SealIcon').default,
  Search01Icon: require('./Search01Icon').default,
  Search02Icon: require('./Search02Icon').default,
  SearchAddIcon: require('./SearchAddIcon').default,
  SearchAreaIcon: require('./SearchAreaIcon').default,
  SearchCircleIcon: require('./SearchCircleIcon').default,
  SearchCodeIcon: require('./SearchCodeIcon').default,
  SearchDollarIcon: require('./SearchDollarIcon').default,
  SearchFocusIcon: require('./SearchFocusIcon').default,
  SearchList01Icon: require('./SearchList01Icon').default,
  SearchList02Icon: require('./SearchList02Icon').default,
  SearchMinusIcon: require('./SearchMinusIcon').default,
  SearchRemoveIcon: require('./SearchRemoveIcon').default,
  SearchReplaceIcon: require('./SearchReplaceIcon').default,
  SearchSquareIcon: require('./SearchSquareIcon').default,
  SearchVisualIcon: require('./SearchVisualIcon').default,
  SearchingIcon: require('./SearchingIcon').default,
  SeatSelectorIcon: require('./SeatSelectorIcon').default,
  SectionIcon: require('./SectionIcon').default,
  SecuredNetworkIcon: require('./SecuredNetworkIcon').default,
  SecurityBlockIcon: require('./SecurityBlockIcon').default,
  SecurityCheckIcon: require('./SecurityCheckIcon').default,
  SecurityKeyUsbIcon: require('./SecurityKeyUsbIcon').default,
  SecurityLockIcon: require('./SecurityLockIcon').default,
  SecurityPasswordIcon: require('./SecurityPasswordIcon').default,
  SecurityIcon: require('./SecurityIcon').default,
  SecurityValidationIcon: require('./SecurityValidationIcon').default,
  SecurityWarningIcon: require('./SecurityWarningIcon').default,
  SecurityWifiIcon: require('./SecurityWifiIcon').default,
  SeesawIcon: require('./SeesawIcon').default,
  SegmentIcon: require('./SegmentIcon').default,
  Select01Icon: require('./Select01Icon').default,
  Select02Icon: require('./Select02Icon').default,
  SelfTransferIcon: require('./SelfTransferIcon').default,
  SemiTruckIcon: require('./SemiTruckIcon').default,
  SendToBackIcon: require('./SendToBackIcon').default,
  SendToMobile02Icon: require('./SendToMobile02Icon').default,
  SendToMobileIcon: require('./SendToMobileIcon').default,
  SendingOrderIcon: require('./SendingOrderIcon').default,
  SenselessIcon: require('./SenselessIcon').default,
  Sent02Icon: require('./Sent02Icon').default,
  SentIcon: require('./SentIcon').default,
  SeoIcon: require('./SeoIcon').default,
  SeparatorHorizontalIcon: require('./SeparatorHorizontalIcon').default,
  ServerStack01Icon: require('./ServerStack01Icon').default,
  ServerStack02Icon: require('./ServerStack02Icon').default,
  ServerStack03Icon: require('./ServerStack03Icon').default,
  ServiceIcon: require('./ServiceIcon').default,
  ServingFoodIcon: require('./ServingFoodIcon').default,
  Setting06Icon: require('./Setting06Icon').default,
  Setting07Icon: require('./Setting07Icon').default,
  SettingDone01Icon: require('./SettingDone01Icon').default,
  SettingDone02Icon: require('./SettingDone02Icon').default,
  SettingDone03Icon: require('./SettingDone03Icon').default,
  SettingDone04Icon: require('./SettingDone04Icon').default,
  SettingError03Icon: require('./SettingError03Icon').default,
  SettingError04Icon: require('./SettingError04Icon').default,
  Settings01Icon: require('./Settings01Icon').default,
  Settings02Icon: require('./Settings02Icon').default,
  Settings03Icon: require('./Settings03Icon').default,
  Settings04Icon: require('./Settings04Icon').default,
  Settings05Icon: require('./Settings05Icon').default,
  SettingsError01Icon: require('./SettingsError01Icon').default,
  SettingsError02Icon: require('./SettingsError02Icon').default,
  Setup01Icon: require('./Setup01Icon').default,
  Setup02Icon: require('./Setup02Icon').default,
  SevenCircleIcon: require('./SevenCircleIcon').default,
  SevenSquareIcon: require('./SevenSquareIcon').default,
  ShadcnSquareIcon: require('./ShadcnSquareIcon').default,
  ShadcnIcon: require('./ShadcnIcon').default,
  Shaka01Icon: require('./Shaka01Icon').default,
  Shaka02Icon: require('./Shaka02Icon').default,
  Shaka03Icon: require('./Shaka03Icon').default,
  Shaka04Icon: require('./Shaka04Icon').default,
  ShampooIcon: require('./ShampooIcon').default,
  ShapeCollectionIcon: require('./ShapeCollectionIcon').default,
  Shapes01Icon: require('./Shapes01Icon').default,
  ShapesIcon: require('./ShapesIcon').default,
  Share01Icon: require('./Share01Icon').default,
  Share02Icon: require('./Share02Icon').default,
  Share03Icon: require('./Share03Icon').default,
  Share04Icon: require('./Share04Icon').default,
  Share05Icon: require('./Share05Icon').default,
  Share06Icon: require('./Share06Icon').default,
  Share07Icon: require('./Share07Icon').default,
  Share08Icon: require('./Share08Icon').default,
  ShareKnowledgeIcon: require('./ShareKnowledgeIcon').default,
  ShareLocation01Icon: require('./ShareLocation01Icon').default,
  ShareLocation02Icon: require('./ShareLocation02Icon').default,
  SharedDriveIcon: require('./SharedDriveIcon').default,
  SharedWifiIcon: require('./SharedWifiIcon').default,
  SharingIcon: require('./SharingIcon').default,
  ShellIcon: require('./ShellIcon').default,
  ShellfishIcon: require('./ShellfishIcon').default,
  Sheriff01Icon: require('./Sheriff01Icon').default,
  Sheriff02Icon: require('./Sheriff02Icon').default,
  Shield01Icon: require('./Shield01Icon').default,
  Shield02Icon: require('./Shield02Icon').default,
  ShieldBanIcon: require('./ShieldBanIcon').default,
  ShieldBlockchainIcon: require('./ShieldBlockchainIcon').default,
  ShieldEnergyIcon: require('./ShieldEnergyIcon').default,
  ShieldHalfIcon: require('./ShieldHalfIcon').default,
  ShieldKeyIcon: require('./ShieldKeyIcon').default,
  ShieldMinusIcon: require('./ShieldMinusIcon').default,
  ShieldPlusIcon: require('./ShieldPlusIcon').default,
  ShieldQuestionMarkIcon: require('./ShieldQuestionMarkIcon').default,
  ShieldUserIcon: require('./ShieldUserIcon').default,
  ShipmentTrackingIcon: require('./ShipmentTrackingIcon').default,
  ShippingCenterIcon: require('./ShippingCenterIcon').default,
  ShippingLoadingIcon: require('./ShippingLoadingIcon').default,
  ShippingTruck01Icon: require('./ShippingTruck01Icon').default,
  ShippingTruck02Icon: require('./ShippingTruck02Icon').default,
  Shirt01Icon: require('./Shirt01Icon').default,
  ShockedIcon: require('./ShockedIcon').default,
  ShopSignIcon: require('./ShopSignIcon').default,
  ShopifyIcon: require('./ShopifyIcon').default,
  ShoppingBag01Icon: require('./ShoppingBag01Icon').default,
  ShoppingBag02Icon: require('./ShoppingBag02Icon').default,
  ShoppingBag03Icon: require('./ShoppingBag03Icon').default,
  ShoppingBagAddIcon: require('./ShoppingBagAddIcon').default,
  ShoppingBagCheckIcon: require('./ShoppingBagCheckIcon').default,
  ShoppingBagFavoriteIcon: require('./ShoppingBagFavoriteIcon').default,
  ShoppingBagRemoveIcon: require('./ShoppingBagRemoveIcon').default,
  ShoppingBasket01Icon: require('./ShoppingBasket01Icon').default,
  ShoppingBasket02Icon: require('./ShoppingBasket02Icon').default,
  ShoppingBasket03Icon: require('./ShoppingBasket03Icon').default,
  ShoppingBasketAdd01Icon: require('./ShoppingBasketAdd01Icon').default,
  ShoppingBasketAdd02Icon: require('./ShoppingBasketAdd02Icon').default,
  ShoppingBasketAdd03Icon: require('./ShoppingBasketAdd03Icon').default,
  ShoppingBasketCheckIn01Icon: require('./ShoppingBasketCheckIn01Icon').default,
  ShoppingBasketCheckIn02Icon: require('./ShoppingBasketCheckIn02Icon').default,
  ShoppingBasketCheckIn03Icon: require('./ShoppingBasketCheckIn03Icon').default,
  ShoppingBasketCheckOut01Icon: require('./ShoppingBasketCheckOut01Icon').default,
  ShoppingBasketCheckOut02Icon: require('./ShoppingBasketCheckOut02Icon').default,
  ShoppingBasketCheckOut03Icon: require('./ShoppingBasketCheckOut03Icon').default,
  ShoppingBasketDone01Icon: require('./ShoppingBasketDone01Icon').default,
  ShoppingBasketDone02Icon: require('./ShoppingBasketDone02Icon').default,
  ShoppingBasketDone03Icon: require('./ShoppingBasketDone03Icon').default,
  ShoppingBasketFavorite01Icon: require('./ShoppingBasketFavorite01Icon').default,
  ShoppingBasketFavorite02Icon: require('./ShoppingBasketFavorite02Icon').default,
  ShoppingBasketFavorite03Icon: require('./ShoppingBasketFavorite03Icon').default,
  ShoppingBasketRemove01Icon: require('./ShoppingBasketRemove01Icon').default,
  ShoppingBasketRemove02Icon: require('./ShoppingBasketRemove02Icon').default,
  ShoppingBasketRemove03Icon: require('./ShoppingBasketRemove03Icon').default,
  ShoppingBasketSecure01Icon: require('./ShoppingBasketSecure01Icon').default,
  ShoppingBasketSecure02Icon: require('./ShoppingBasketSecure02Icon').default,
  ShoppingBasketSecure03Icon: require('./ShoppingBasketSecure03Icon').default,
  ShoppingCart01Icon: require('./ShoppingCart01Icon').default,
  ShoppingCart02Icon: require('./ShoppingCart02Icon').default,
  ShoppingCartAdd01Icon: require('./ShoppingCartAdd01Icon').default,
  ShoppingCartAdd02Icon: require('./ShoppingCartAdd02Icon').default,
  ShoppingCartCheck01Icon: require('./ShoppingCartCheck01Icon').default,
  ShoppingCartCheck02Icon: require('./ShoppingCartCheck02Icon').default,
  ShoppingCartCheckIn01Icon: require('./ShoppingCartCheckIn01Icon').default,
  ShoppingCartCheckIn02Icon: require('./ShoppingCartCheckIn02Icon').default,
  ShoppingCartCheckOut01Icon: require('./ShoppingCartCheckOut01Icon').default,
  ShoppingCartCheckOut02Icon: require('./ShoppingCartCheckOut02Icon').default,
  ShoppingCartFavorite01Icon: require('./ShoppingCartFavorite01Icon').default,
  ShoppingCartFavorite02Icon: require('./ShoppingCartFavorite02Icon').default,
  ShoppingCartRemove01Icon: require('./ShoppingCartRemove01Icon').default,
  ShoppingCartRemove02Icon: require('./ShoppingCartRemove02Icon').default,
  ShortsPantsIcon: require('./ShortsPantsIcon').default,
  ShoulderIcon: require('./ShoulderIcon').default,
  ShovelIcon: require('./ShovelIcon').default,
  ShowerHeadIcon: require('./ShowerHeadIcon').default,
  ShrinkDotIcon: require('./ShrinkDotIcon').default,
  ShuffleSquareIcon: require('./ShuffleSquareIcon').default,
  ShuffleIcon: require('./ShuffleIcon').default,
  ShutDownIcon: require('./ShutDownIcon').default,
  ShutterstockIcon: require('./ShutterstockIcon').default,
  SidebarBottomIcon: require('./SidebarBottomIcon').default,
  SidebarLeft01Icon: require('./SidebarLeft01Icon').default,
  SidebarLeftIcon: require('./SidebarLeftIcon').default,
  SidebarRight01Icon: require('./SidebarRight01Icon').default,
  SidebarRightIcon: require('./SidebarRightIcon').default,
  SidebarTopIcon: require('./SidebarTopIcon').default,
  SignLanguageCIcon: require('./SignLanguageCIcon').default,
  SignalFull01Icon: require('./SignalFull01Icon').default,
  SignalFull02Icon: require('./SignalFull02Icon').default,
  SignalLow01Icon: require('./SignalLow01Icon').default,
  SignalLow02Icon: require('./SignalLow02Icon').default,
  SignalLowMediumIcon: require('./SignalLowMediumIcon').default,
  SignalMedium01Icon: require('./SignalMedium01Icon').default,
  SignalMedium02Icon: require('./SignalMedium02Icon').default,
  SignalNo01Icon: require('./SignalNo01Icon').default,
  SignalNo02Icon: require('./SignalNo02Icon').default,
  SignalIcon: require('./SignalIcon').default,
  SignatureIcon: require('./SignatureIcon').default,
  SilenceIcon: require('./SilenceIcon').default,
  Simcard01Icon: require('./Simcard01Icon').default,
  Simcard02Icon: require('./Simcard02Icon').default,
  SimcardDualIcon: require('./SimcardDualIcon').default,
  SinIcon: require('./SinIcon').default,
  Sine01Icon: require('./Sine01Icon').default,
  Sine02Icon: require('./Sine02Icon').default,
  SingLeftIcon: require('./SingLeftIcon').default,
  SingRightIcon: require('./SingRightIcon').default,
  Sink01Icon: require('./Sink01Icon').default,
  Sink02Icon: require('./Sink02Icon').default,
  SiriNewIcon: require('./SiriNewIcon').default,
  SiriIcon: require('./SiriIcon').default,
  SixCircleIcon: require('./SixCircleIcon').default,
  SixSquareIcon: require('./SixSquareIcon').default,
  SketchIcon: require('./SketchIcon').default,
  SkewIcon: require('./SkewIcon').default,
  SkiIcon: require('./SkiIcon').default,
  SkippingRopeIcon: require('./SkippingRopeIcon').default,
  SkoolIcon: require('./SkoolIcon').default,
  SkullIcon: require('./SkullIcon').default,
  SkypeIcon: require('./SkypeIcon').default,
  SlackIcon: require('./SlackIcon').default,
  SleepingIcon: require('./SleepingIcon').default,
  SleevelessIcon: require('./SleevelessIcon').default,
  SlideIcon: require('./SlideIcon').default,
  SlidersHorizontalIcon: require('./SlidersHorizontalIcon').default,
  SlidersVerticalIcon: require('./SlidersVerticalIcon').default,
  SlideshareIcon: require('./SlideshareIcon').default,
  SlowWindsIcon: require('./SlowWindsIcon').default,
  SmartAcIcon: require('./SmartAcIcon').default,
  SmartPhone01Icon: require('./SmartPhone01Icon').default,
  SmartPhone02Icon: require('./SmartPhone02Icon').default,
  SmartPhone03Icon: require('./SmartPhone03Icon').default,
  SmartPhone04Icon: require('./SmartPhone04Icon').default,
  SmartPhoneLandscape02Icon: require('./SmartPhoneLandscape02Icon').default,
  SmartPhoneLandscapeIcon: require('./SmartPhoneLandscapeIcon').default,
  SmartIcon: require('./SmartIcon').default,
  SmartWatch01Icon: require('./SmartWatch01Icon').default,
  SmartWatch02Icon: require('./SmartWatch02Icon').default,
  SmartWatch03Icon: require('./SmartWatch03Icon').default,
  SmartWatch04Icon: require('./SmartWatch04Icon').default,
  SmartphoneChargingIcon: require('./SmartphoneChargingIcon').default,
  SmartphoneLostWifiIcon: require('./SmartphoneLostWifiIcon').default,
  SmartphoneNfcIcon: require('./SmartphoneNfcIcon').default,
  SmartphoneWifiIcon: require('./SmartphoneWifiIcon').default,
  SmileDizzyIcon: require('./SmileDizzyIcon').default,
  SmilePlusIcon: require('./SmilePlusIcon').default,
  SmileIcon: require('./SmileIcon').default,
  SmsCodeIcon: require('./SmsCodeIcon').default,
  SnailIcon: require('./SnailIcon').default,
  SnapchatIcon: require('./SnapchatIcon').default,
  SnowIcon: require('./SnowIcon').default,
  SocksIcon: require('./SocksIcon').default,
  SodaCanIcon: require('./SodaCanIcon').default,
  Sofa01Icon: require('./Sofa01Icon').default,
  Sofa02Icon: require('./Sofa02Icon').default,
  Sofa03Icon: require('./Sofa03Icon').default,
  SofaSingleIcon: require('./SofaSingleIcon').default,
  SoftDrink01Icon: require('./SoftDrink01Icon').default,
  SoftDrink02Icon: require('./SoftDrink02Icon').default,
  SoftwareLicenseIcon: require('./SoftwareLicenseIcon').default,
  SoftwareIcon: require('./SoftwareIcon').default,
  SoftwareUninstallIcon: require('./SoftwareUninstallIcon').default,
  SoilMoistureFieldIcon: require('./SoilMoistureFieldIcon').default,
  SoilMoistureGlobalIcon: require('./SoilMoistureGlobalIcon').default,
  SoilTemperatureFieldIcon: require('./SoilTemperatureFieldIcon').default,
  SoilTemperatureGlobalIcon: require('./SoilTemperatureGlobalIcon').default,
  SolarEnergyIcon: require('./SolarEnergyIcon').default,
  SolarPanel01Icon: require('./SolarPanel01Icon').default,
  SolarPanel02Icon: require('./SolarPanel02Icon').default,
  SolarPanel03Icon: require('./SolarPanel03Icon').default,
  SolarPanel04Icon: require('./SolarPanel04Icon').default,
  SolarPanel05Icon: require('./SolarPanel05Icon').default,
  SolarPowerIcon: require('./SolarPowerIcon').default,
  SolarSystem01Icon: require('./SolarSystem01Icon').default,
  SolarSystemIcon: require('./SolarSystemIcon').default,
  SolidLine01Icon: require('./SolidLine01Icon').default,
  SolidLine02Icon: require('./SolidLine02Icon').default,
  SortByDown01Icon: require('./SortByDown01Icon').default,
  SortByDown02Icon: require('./SortByDown02Icon').default,
  SortByUp01Icon: require('./SortByUp01Icon').default,
  SortByUp02Icon: require('./SortByUp02Icon').default,
  SortDescendingIcon: require('./SortDescendingIcon').default,
  Sorting01Icon: require('./Sorting01Icon').default,
  Sorting02Icon: require('./Sorting02Icon').default,
  Sorting03Icon: require('./Sorting03Icon').default,
  Sorting04Icon: require('./Sorting04Icon').default,
  Sorting05Icon: require('./Sorting05Icon').default,
  SortingOneNineIcon: require('./SortingOneNineIcon').default,
  SortingNineOneIcon: require('./SortingNineOneIcon').default,
  SortingAZ01Icon: require('./SortingAZ01Icon').default,
  SortingAZ02Icon: require('./SortingAZ02Icon').default,
  SortingDownIcon: require('./SortingDownIcon').default,
  SortingUpIcon: require('./SortingUpIcon').default,
  SortingZA01Icon: require('./SortingZA01Icon').default,
  SoundcloudIcon: require('./SoundcloudIcon').default,
  SourceCodeCircleIcon: require('./SourceCodeCircleIcon').default,
  SourceCodeSquareIcon: require('./SourceCodeSquareIcon').default,
  SourceCodeIcon: require('./SourceCodeIcon').default,
  SpaceshipIcon: require('./SpaceshipIcon').default,
  SpadesIcon: require('./SpadesIcon').default,
  SpaghettiIcon: require('./SpaghettiIcon').default,
  SpamIcon: require('./SpamIcon').default,
  SparklesIcon: require('./SparklesIcon').default,
  SpartanHelmetIcon: require('./SpartanHelmetIcon').default,
  SpatulaIcon: require('./SpatulaIcon').default,
  Speaker01Icon: require('./Speaker01Icon').default,
  SpeakerIcon: require('./SpeakerIcon').default,
  SpeechIcon: require('./SpeechIcon').default,
  SpeechToTextIcon: require('./SpeechToTextIcon').default,
  SpeedTrain01Icon: require('./SpeedTrain01Icon').default,
  SpeedTrain02Icon: require('./SpeedTrain02Icon').default,
  SpermIcon: require('./SpermIcon').default,
  SphereIcon: require('./SphereIcon').default,
  SpiralsIcon: require('./SpiralsIcon').default,
  SplinePointerIcon: require('./SplinePointerIcon').default,
  SplitIcon: require('./SplitIcon').default,
  SpoolIcon: require('./SpoolIcon').default,
  SpoonAndForkIcon: require('./SpoonAndForkIcon').default,
  SpoonAndKnifeIcon: require('./SpoonAndKnifeIcon').default,
  SpoonIcon: require('./SpoonIcon').default,
  SpotifyIcon: require('./SpotifyIcon').default,
  SpotlightIcon: require('./SpotlightIcon').default,
  SprayCanIcon: require('./SprayCanIcon').default,
  SqlIcon: require('./SqlIcon').default,
  Square01Icon: require('./Square01Icon').default,
  SquareArrowDataTransferDiagonalIcon: require('./SquareArrowDataTransferDiagonalIcon').default,
  SquareArrowDataTransferHorizontalIcon: require('./SquareArrowDataTransferHorizontalIcon').default,
  SquareArrowDataTransferVerticalIcon: require('./SquareArrowDataTransferVerticalIcon').default,
  SquareArrowDiagonal01Icon: require('./SquareArrowDiagonal01Icon').default,
  SquareArrowDiagonal02Icon: require('./SquareArrowDiagonal02Icon').default,
  SquareArrowDown01Icon: require('./SquareArrowDown01Icon').default,
  SquareArrowDown02Icon: require('./SquareArrowDown02Icon').default,
  SquareArrowDown03Icon: require('./SquareArrowDown03Icon').default,
  SquareArrowDownDoubleIcon: require('./SquareArrowDownDoubleIcon').default,
  SquareArrowDownLeftIcon: require('./SquareArrowDownLeftIcon').default,
  SquareArrowDownRightIcon: require('./SquareArrowDownRightIcon').default,
  SquareArrowExpand01Icon: require('./SquareArrowExpand01Icon').default,
  SquareArrowExpand02Icon: require('./SquareArrowExpand02Icon').default,
  SquareArrowHorizontalIcon: require('./SquareArrowHorizontalIcon').default,
  SquareArrowLeft01Icon: require('./SquareArrowLeft01Icon').default,
  SquareArrowLeft02Icon: require('./SquareArrowLeft02Icon').default,
  SquareArrowLeft03Icon: require('./SquareArrowLeft03Icon').default,
  SquareArrowLeftDoubleIcon: require('./SquareArrowLeftDoubleIcon').default,
  SquareArrowLeftRightIcon: require('./SquareArrowLeftRightIcon').default,
  SquareArrowMoveDownLeftIcon: require('./SquareArrowMoveDownLeftIcon').default,
  SquareArrowMoveDownRightIcon: require('./SquareArrowMoveDownRightIcon').default,
  SquareArrowMoveLeftDownIcon: require('./SquareArrowMoveLeftDownIcon').default,
  SquareArrowMoveLeftUpIcon: require('./SquareArrowMoveLeftUpIcon').default,
  SquareArrowMoveRightDownIcon: require('./SquareArrowMoveRightDownIcon').default,
  SquareArrowMoveRightUpIcon: require('./SquareArrowMoveRightUpIcon').default,
  SquareArrowReload01Icon: require('./SquareArrowReload01Icon').default,
  SquareArrowReload02Icon: require('./SquareArrowReload02Icon').default,
  SquareArrowRight01Icon: require('./SquareArrowRight01Icon').default,
  SquareArrowRight02Icon: require('./SquareArrowRight02Icon').default,
  SquareArrowRight03Icon: require('./SquareArrowRight03Icon').default,
  SquareArrowRightDoubleIcon: require('./SquareArrowRightDoubleIcon').default,
  SquareArrowShrink01Icon: require('./SquareArrowShrink01Icon').default,
  SquareArrowShrink02Icon: require('./SquareArrowShrink02Icon').default,
  SquareArrowUp01Icon: require('./SquareArrowUp01Icon').default,
  SquareArrowUp02Icon: require('./SquareArrowUp02Icon').default,
  SquareArrowUp03Icon: require('./SquareArrowUp03Icon').default,
  SquareArrowUpDoubleIcon: require('./SquareArrowUpDoubleIcon').default,
  SquareArrowUpDownIcon: require('./SquareArrowUpDownIcon').default,
  SquareArrowUpLeftIcon: require('./SquareArrowUpLeftIcon').default,
  SquareArrowUpRight02Icon: require('./SquareArrowUpRight02Icon').default,
  SquareArrowUpRightIcon: require('./SquareArrowUpRightIcon').default,
  SquareArrowVerticalIcon: require('./SquareArrowVerticalIcon').default,
  SquareAsteriskIcon: require('./SquareAsteriskIcon').default,
  SquareBottomDashedScissorsIcon: require('./SquareBottomDashedScissorsIcon').default,
  SquareChartGanttIcon: require('./SquareChartGanttIcon').default,
  SquareCircleIcon: require('./SquareCircleIcon').default,
  SquareDashedKanbanIcon: require('./SquareDashedKanbanIcon').default,
  SquareDashedTopSolidIcon: require('./SquareDashedTopSolidIcon').default,
  SquareFIcon: require('./SquareFIcon').default,
  SquareLock01Icon: require('./SquareLock01Icon').default,
  SquareLock02Icon: require('./SquareLock02Icon').default,
  SquareLockAdd01Icon: require('./SquareLockAdd01Icon').default,
  SquareLockAdd02Icon: require('./SquareLockAdd02Icon').default,
  SquareLockCheck01Icon: require('./SquareLockCheck01Icon').default,
  SquareLockCheck02Icon: require('./SquareLockCheck02Icon').default,
  SquareLockMinus01Icon: require('./SquareLockMinus01Icon').default,
  SquareLockMinus02Icon: require('./SquareLockMinus02Icon').default,
  SquareLockPasswordIcon: require('./SquareLockPasswordIcon').default,
  SquareLockRemove01Icon: require('./SquareLockRemove01Icon').default,
  SquareLockRemove02Icon: require('./SquareLockRemove02Icon').default,
  SquareMIcon: require('./SquareMIcon').default,
  SquareMousePointerIcon: require('./SquareMousePointerIcon').default,
  SquareParkingOffIcon: require('./SquareParkingOffIcon').default,
  SquarePowerIcon: require('./SquarePowerIcon').default,
  SquareRootSquareIcon: require('./SquareRootSquareIcon').default,
  SquareRoundCornerIcon: require('./SquareRoundCornerIcon').default,
  SquareSquareIcon: require('./SquareSquareIcon').default,
  SquareStackIcon: require('./SquareStackIcon').default,
  SquareIcon: require('./SquareIcon').default,
  SquareUnlock01Icon: require('./SquareUnlock01Icon').default,
  SquareUnlock02Icon: require('./SquareUnlock02Icon').default,
  SquaresExcludeIcon: require('./SquaresExcludeIcon').default,
  StackStarIcon: require('./StackStarIcon').default,
  Stairs01Icon: require('./Stairs01Icon').default,
  Stairs02Icon: require('./Stairs02Icon').default,
  Stairs03Icon: require('./Stairs03Icon').default,
  Stairs04Icon: require('./Stairs04Icon').default,
  StakeIcon: require('./StakeIcon').default,
  Stamp01Icon: require('./Stamp01Icon').default,
  Stamp02Icon: require('./Stamp02Icon').default,
  StampIcon: require('./StampIcon').default,
  StarAward01Icon: require('./StarAward01Icon').default,
  StarAward02Icon: require('./StarAward02Icon').default,
  StarCircleIcon: require('./StarCircleIcon').default,
  StarFaceIcon: require('./StarFaceIcon').default,
  StarHalfIcon: require('./StarHalfIcon').default,
  StarOffIcon: require('./StarOffIcon').default,
  StarSquareIcon: require('./StarSquareIcon').default,
  StarIcon: require('./StarIcon').default,
  StarsIcon: require('./StarsIcon').default,
  StartUp01Icon: require('./StartUp01Icon').default,
  StartUp02Icon: require('./StartUp02Icon').default,
  StationeryIcon: require('./StationeryIcon').default,
  StatusIcon: require('./StatusIcon').default,
  SteakIcon: require('./SteakIcon').default,
  SteeringIcon: require('./SteeringIcon').default,
  StepIntoIcon: require('./StepIntoIcon').default,
  StepOutIcon: require('./StepOutIcon').default,
  StepOverIcon: require('./StepOverIcon').default,
  Stethoscope02Icon: require('./Stethoscope02Icon').default,
  StethoscopeIcon: require('./StethoscopeIcon').default,
  StickerIcon: require('./StickerIcon').default,
  StickyNote01Icon: require('./StickyNote01Icon').default,
  StickyNote02Icon: require('./StickyNote02Icon').default,
  StickyNote03Icon: require('./StickyNote03Icon').default,
  StopCircleIcon: require('./StopCircleIcon').default,
  StopLossOrderIcon: require('./StopLossOrderIcon').default,
  StopIcon: require('./StopIcon').default,
  StopWatchIcon: require('./StopWatchIcon').default,
  Store01Icon: require('./Store01Icon').default,
  Store02Icon: require('./Store02Icon').default,
  Store03Icon: require('./Store03Icon').default,
  Store04Icon: require('./Store04Icon').default,
  StoreAdd01Icon: require('./StoreAdd01Icon').default,
  StoreAdd02Icon: require('./StoreAdd02Icon').default,
  StoreLocation01Icon: require('./StoreLocation01Icon').default,
  StoreLocation02Icon: require('./StoreLocation02Icon').default,
  StoreManagement01Icon: require('./StoreManagement01Icon').default,
  StoreManagement02Icon: require('./StoreManagement02Icon').default,
  StoreRemove01Icon: require('./StoreRemove01Icon').default,
  StoreRemove02Icon: require('./StoreRemove02Icon').default,
  StoreVerified01Icon: require('./StoreVerified01Icon').default,
  StoreVerified02Icon: require('./StoreVerified02Icon').default,
  StraightEdgeIcon: require('./StraightEdgeIcon').default,
  StrategyIcon: require('./StrategyIcon').default,
  StreeringWheelIcon: require('./StreeringWheelIcon').default,
  StreetFoodIcon: require('./StreetFoodIcon').default,
  StripeIcon: require('./StripeIcon').default,
  StrokeBottomIcon: require('./StrokeBottomIcon').default,
  StrokeCenterIcon: require('./StrokeCenterIcon').default,
  StrokeInsideIcon: require('./StrokeInsideIcon').default,
  StrokeLeftIcon: require('./StrokeLeftIcon').default,
  StrokeOutsideIcon: require('./StrokeOutsideIcon').default,
  StrokeRightIcon: require('./StrokeRightIcon').default,
  StrokeTopIcon: require('./StrokeTopIcon').default,
  Structure01Icon: require('./Structure01Icon').default,
  Structure02Icon: require('./Structure02Icon').default,
  Structure03Icon: require('./Structure03Icon').default,
  Structure04Icon: require('./Structure04Icon').default,
  Structure05Icon: require('./Structure05Icon').default,
  StructureAddIcon: require('./StructureAddIcon').default,
  StructureCheckIcon: require('./StructureCheckIcon').default,
  StructureFailIcon: require('./StructureFailIcon').default,
  StructureFolderCircleIcon: require('./StructureFolderCircleIcon').default,
  StructureFolderIcon: require('./StructureFolderIcon').default,
  StudentCardIcon: require('./StudentCardIcon').default,
  StudentIcon: require('./StudentIcon').default,
  StudentsIcon: require('./StudentsIcon').default,
  StudyDeskIcon: require('./StudyDeskIcon').default,
  StudyLampIcon: require('./StudyLampIcon').default,
  StumbleuponIcon: require('./StumbleuponIcon').default,
  SubmarineIcon: require('./SubmarineIcon').default,
  SubmergeIcon: require('./SubmergeIcon').default,
  SubnodeAddIcon: require('./SubnodeAddIcon').default,
  SubnodeDeleteIcon: require('./SubnodeDeleteIcon').default,
  SubpoenaIcon: require('./SubpoenaIcon').default,
  SubtitleIcon: require('./SubtitleIcon').default,
  Suit01Icon: require('./Suit01Icon').default,
  Suit02Icon: require('./Suit02Icon').default,
  SujoodIcon: require('./SujoodIcon').default,
  Summation01Icon: require('./Summation01Icon').default,
  Summation02Icon: require('./Summation02Icon').default,
  SummationCircleIcon: require('./SummationCircleIcon').default,
  SummationSquareIcon: require('./SummationSquareIcon').default,
  Sun01Icon: require('./Sun01Icon').default,
  Sun02Icon: require('./Sun02Icon').default,
  Sun03Icon: require('./Sun03Icon').default,
  SunCloud01Icon: require('./SunCloud01Icon').default,
  SunCloud02Icon: require('./SunCloud02Icon').default,
  SunCloudAngledRain01Icon: require('./SunCloudAngledRain01Icon').default,
  SunCloudAngledRain02Icon: require('./SunCloudAngledRain02Icon').default,
  SunCloudAngledRainZap01Icon: require('./SunCloudAngledRainZap01Icon').default,
  SunCloudAngledRainZap02Icon: require('./SunCloudAngledRainZap02Icon').default,
  SunCloudAngledZap01Icon: require('./SunCloudAngledZap01Icon').default,
  SunCloudAngledZap02Icon: require('./SunCloudAngledZap02Icon').default,
  SunCloudBigRain01Icon: require('./SunCloudBigRain01Icon').default,
  SunCloudBigRain02Icon: require('./SunCloudBigRain02Icon').default,
  SunCloudFastWind01Icon: require('./SunCloudFastWind01Icon').default,
  SunCloudFastWind02Icon: require('./SunCloudFastWind02Icon').default,
  SunCloudHailstone01Icon: require('./SunCloudHailstone01Icon').default,
  SunCloudHailstone02Icon: require('./SunCloudHailstone02Icon').default,
  SunCloudLittleRain01Icon: require('./SunCloudLittleRain01Icon').default,
  SunCloudLittleRain02Icon: require('./SunCloudLittleRain02Icon').default,
  SunCloudLittleSnow01Icon: require('./SunCloudLittleSnow01Icon').default,
  SunCloudLittleSnow02Icon: require('./SunCloudLittleSnow02Icon').default,
  SunCloudMidRain01Icon: require('./SunCloudMidRain01Icon').default,
  SunCloudMidRain02Icon: require('./SunCloudMidRain02Icon').default,
  SunCloudMidSnow01Icon: require('./SunCloudMidSnow01Icon').default,
  SunCloudMidSnow02Icon: require('./SunCloudMidSnow02Icon').default,
  SunCloudSlowWind01Icon: require('./SunCloudSlowWind01Icon').default,
  SunCloudSlowWind02Icon: require('./SunCloudSlowWind02Icon').default,
  SunCloudSnow01Icon: require('./SunCloudSnow01Icon').default,
  SunCloudSnow02Icon: require('./SunCloudSnow02Icon').default,
  SunglassesIcon: require('./SunglassesIcon').default,
  SunriseIcon: require('./SunriseIcon').default,
  SunsetIcon: require('./SunsetIcon').default,
  SuperMarioIcon: require('./SuperMarioIcon').default,
  SuperMarioToadIcon: require('./SuperMarioToadIcon').default,
  SurfboardIcon: require('./SurfboardIcon').default,
  SurpriseIcon: require('./SurpriseIcon').default,
  Sushi01Icon: require('./Sushi01Icon').default,
  Sushi02Icon: require('./Sushi02Icon').default,
  Sushi03Icon: require('./Sushi03Icon').default,
  SuspiciousIcon: require('./SuspiciousIcon').default,
  SustainableEnergyIcon: require('./SustainableEnergyIcon').default,
  Svg01Icon: require('./Svg01Icon').default,
  Svg02Icon: require('./Svg02Icon').default,
  SwarmIcon: require('./SwarmIcon').default,
  SwatchIcon: require('./SwatchIcon').default,
  SwimmingCapIcon: require('./SwimmingCapIcon').default,
  SwimmingIcon: require('./SwimmingIcon').default,
  SwipeDown01Icon: require('./SwipeDown01Icon').default,
  SwipeDown02Icon: require('./SwipeDown02Icon').default,
  SwipeDown03Icon: require('./SwipeDown03Icon').default,
  SwipeDown04Icon: require('./SwipeDown04Icon').default,
  SwipeDown05Icon: require('./SwipeDown05Icon').default,
  SwipeDown06Icon: require('./SwipeDown06Icon').default,
  SwipeDown07Icon: require('./SwipeDown07Icon').default,
  SwipeDown08Icon: require('./SwipeDown08Icon').default,
  SwipeLeft01Icon: require('./SwipeLeft01Icon').default,
  SwipeLeft02Icon: require('./SwipeLeft02Icon').default,
  SwipeLeft03Icon: require('./SwipeLeft03Icon').default,
  SwipeLeft04Icon: require('./SwipeLeft04Icon').default,
  SwipeLeft05Icon: require('./SwipeLeft05Icon').default,
  SwipeLeft06Icon: require('./SwipeLeft06Icon').default,
  SwipeLeft07Icon: require('./SwipeLeft07Icon').default,
  SwipeLeft08Icon: require('./SwipeLeft08Icon').default,
  SwipeLeft09Icon: require('./SwipeLeft09Icon').default,
  SwipeRight01Icon: require('./SwipeRight01Icon').default,
  SwipeRight02Icon: require('./SwipeRight02Icon').default,
  SwipeRight03Icon: require('./SwipeRight03Icon').default,
  SwipeRight04Icon: require('./SwipeRight04Icon').default,
  SwipeRight05Icon: require('./SwipeRight05Icon').default,
  SwipeRight06Icon: require('./SwipeRight06Icon').default,
  SwipeRight07Icon: require('./SwipeRight07Icon').default,
  SwipeRight08Icon: require('./SwipeRight08Icon').default,
  SwipeRight09Icon: require('./SwipeRight09Icon').default,
  SwipeUp01Icon: require('./SwipeUp01Icon').default,
  SwipeUp02Icon: require('./SwipeUp02Icon').default,
  SwipeUp03Icon: require('./SwipeUp03Icon').default,
  SwipeUp04Icon: require('./SwipeUp04Icon').default,
  SwipeUp05Icon: require('./SwipeUp05Icon').default,
  SwipeUp06Icon: require('./SwipeUp06Icon').default,
  SwipeUp07Icon: require('./SwipeUp07Icon').default,
  SwipeUp08Icon: require('./SwipeUp08Icon').default,
  SwissFrancIcon: require('./SwissFrancIcon').default,
  SwitchCameraIcon: require('./SwitchCameraIcon').default,
  Sword01Icon: require('./Sword01Icon').default,
  Sword02Icon: require('./Sword02Icon').default,
  Sword03Icon: require('./Sword03Icon').default,
  SystemUpdate01Icon: require('./SystemUpdate01Icon').default,
  SystemUpdate02Icon: require('./SystemUpdate02Icon').default,
  TShirtIcon: require('./TShirtIcon').default,
  Table01Icon: require('./Table01Icon').default,
  Table02Icon: require('./Table02Icon').default,
  Table03Icon: require('./Table03Icon').default,
  TableColumnsSplitIcon: require('./TableColumnsSplitIcon').default,
  TableLamp01Icon: require('./TableLamp01Icon').default,
  TableLamp02Icon: require('./TableLamp02Icon').default,
  TableRoundIcon: require('./TableRoundIcon').default,
  TableRowsSplitIcon: require('./TableRowsSplitIcon').default,
  TableIcon: require('./TableIcon').default,
  TableTennisBatIcon: require('./TableTennisBatIcon').default,
  Tablet01Icon: require('./Tablet01Icon').default,
  Tablet02Icon: require('./Tablet02Icon').default,
  TabletConnectedBluetoothIcon: require('./TabletConnectedBluetoothIcon').default,
  TabletConnectedUsbIcon: require('./TabletConnectedUsbIcon').default,
  TabletConnectedWifiIcon: require('./TabletConnectedWifiIcon').default,
  TabletPenIcon: require('./TabletPenIcon').default,
  TabletsIcon: require('./TabletsIcon').default,
  Taco01Icon: require('./Taco01Icon').default,
  Taco02Icon: require('./Taco02Icon').default,
  Tag01Icon: require('./Tag01Icon').default,
  Tag02Icon: require('./Tag02Icon').default,
  TagsIcon: require('./TagsIcon').default,
  TailwindcssIcon: require('./TailwindcssIcon').default,
  TajMahalIcon: require('./TajMahalIcon').default,
  TallyOneIcon: require('./TallyOneIcon').default,
  TallyTwoIcon: require('./TallyTwoIcon').default,
  TallyThreeIcon: require('./TallyThreeIcon').default,
  TallyFourIcon: require('./TallyFourIcon').default,
  TallyFiveIcon: require('./TallyFiveIcon').default,
  TanIcon: require('./TanIcon').default,
  TangentIcon: require('./TangentIcon').default,
  TankTopIcon: require('./TankTopIcon').default,
  TankerTruckIcon: require('./TankerTruckIcon').default,
  Tap01Icon: require('./Tap01Icon').default,
  Tap02Icon: require('./Tap02Icon').default,
  Tap03Icon: require('./Tap03Icon').default,
  Tap04Icon: require('./Tap04Icon').default,
  Tap05Icon: require('./Tap05Icon').default,
  Tap06Icon: require('./Tap06Icon').default,
  Tap07Icon: require('./Tap07Icon').default,
  Tap08Icon: require('./Tap08Icon').default,
  TapeMeasureIcon: require('./TapeMeasureIcon').default,
  Target01Icon: require('./Target01Icon').default,
  Target02Icon: require('./Target02Icon').default,
  Target03Icon: require('./Target03Icon').default,
  TargetDollarIcon: require('./TargetDollarIcon').default,
  TasbihIcon: require('./TasbihIcon').default,
  Task01Icon: require('./Task01Icon').default,
  Task02Icon: require('./Task02Icon').default,
  TaskAdd01Icon: require('./TaskAdd01Icon').default,
  TaskAdd02Icon: require('./TaskAdd02Icon').default,
  TaskDaily01Icon: require('./TaskDaily01Icon').default,
  TaskDaily02Icon: require('./TaskDaily02Icon').default,
  TaskDone01Icon: require('./TaskDone01Icon').default,
  TaskDone02Icon: require('./TaskDone02Icon').default,
  TaskEdit01Icon: require('./TaskEdit01Icon').default,
  TaskEdit02Icon: require('./TaskEdit02Icon').default,
  TaskRemove01Icon: require('./TaskRemove01Icon').default,
  TaskRemove02Icon: require('./TaskRemove02Icon').default,
  TaxesIcon: require('./TaxesIcon').default,
  Taxi02Icon: require('./Taxi02Icon').default,
  TaxiIcon: require('./TaxiIcon').default,
  TeaPodIcon: require('./TeaPodIcon').default,
  TeaIcon: require('./TeaIcon').default,
  TeacherIcon: require('./TeacherIcon').default,
  TeachingIcon: require('./TeachingIcon').default,
  TeamWorkIcon: require('./TeamWorkIcon').default,
  TeamviewerIcon: require('./TeamviewerIcon').default,
  TelegramIcon: require('./TelegramIcon').default,
  TelephoneIcon: require('./TelephoneIcon').default,
  Telescope01Icon: require('./Telescope01Icon').default,
  Telescope02Icon: require('./Telescope02Icon').default,
  TelevisionTableIcon: require('./TelevisionTableIcon').default,
  TemperatureIcon: require('./TemperatureIcon').default,
  TennisBallIcon: require('./TennisBallIcon').default,
  TennisRacketIcon: require('./TennisRacketIcon').default,
  TentIcon: require('./TentIcon').default,
  TentTreeIcon: require('./TentTreeIcon').default,
  TerminalIcon: require('./TerminalIcon').default,
  TerraceIcon: require('./TerraceIcon').default,
  TestTube01Icon: require('./TestTube01Icon').default,
  TestTube02Icon: require('./TestTube02Icon').default,
  TestTube03Icon: require('./TestTube03Icon').default,
  TestTubeDiagonalIcon: require('./TestTubeDiagonalIcon').default,
  TestTubeIcon: require('./TestTubeIcon').default,
  TestTubesIcon: require('./TestTubesIcon').default,
  TetrisIcon: require('./TetrisIcon').default,
  TextAlignCenterIcon: require('./TextAlignCenterIcon').default,
  TextAlignJustifyCenterIcon: require('./TextAlignJustifyCenterIcon').default,
  TextAlignJustifyLeftIcon: require('./TextAlignJustifyLeftIcon').default,
  TextAlignJustifyRightIcon: require('./TextAlignJustifyRightIcon').default,
  TextAlignLeft01Icon: require('./TextAlignLeft01Icon').default,
  TextAlignLeftIcon: require('./TextAlignLeftIcon').default,
  TextAlignRight01Icon: require('./TextAlignRight01Icon').default,
  TextAlignRightIcon: require('./TextAlignRightIcon').default,
  TextAllCapsIcon: require('./TextAllCapsIcon').default,
  TextBoldIcon: require('./TextBoldIcon').default,
  TextCenterlineCenterTopIcon: require('./TextCenterlineCenterTopIcon').default,
  TextCenterlineLeftIcon: require('./TextCenterlineLeftIcon').default,
  TextCenterlineMiddleIcon: require('./TextCenterlineMiddleIcon').default,
  TextCenterlineRightIcon: require('./TextCenterlineRightIcon').default,
  TextCheckIcon: require('./TextCheckIcon').default,
  TextCircleIcon: require('./TextCircleIcon').default,
  TextClearIcon: require('./TextClearIcon').default,
  TextColorIcon: require('./TextColorIcon').default,
  TextCreationIcon: require('./TextCreationIcon').default,
  TextFirstlineLeftIcon: require('./TextFirstlineLeftIcon').default,
  TextFirstlineRightIcon: require('./TextFirstlineRightIcon').default,
  TextFontIcon: require('./TextFontIcon').default,
  TextFootnoteIcon: require('./TextFootnoteIcon').default,
  TextIndent01Icon: require('./TextIndent01Icon').default,
  TextIndentLessIcon: require('./TextIndentLessIcon').default,
  TextIndentMoreIcon: require('./TextIndentMoreIcon').default,
  TextIndentIcon: require('./TextIndentIcon').default,
  TextItalicSlashIcon: require('./TextItalicSlashIcon').default,
  TextItalicIcon: require('./TextItalicIcon').default,
  TextKerningIcon: require('./TextKerningIcon').default,
  TextNumberSignIcon: require('./TextNumberSignIcon').default,
  TextSelectIcon: require('./TextSelectIcon').default,
  TextSelectionIcon: require('./TextSelectionIcon').default,
  TextSmallcapsIcon: require('./TextSmallcapsIcon').default,
  TextSquareIcon: require('./TextSquareIcon').default,
  TextStrikethroughIcon: require('./TextStrikethroughIcon').default,
  TextIcon: require('./TextIcon').default,
  TextSubscriptIcon: require('./TextSubscriptIcon').default,
  TextSuperscriptIcon: require('./TextSuperscriptIcon').default,
  TextTrackingIcon: require('./TextTrackingIcon').default,
  TextUnderlineIcon: require('./TextUnderlineIcon').default,
  TextVariableFrontIcon: require('./TextVariableFrontIcon').default,
  TextVerticalAlignmentIcon: require('./TextVerticalAlignmentIcon').default,
  TextWrapIcon: require('./TextWrapIcon').default,
  TheProphetsMosqueIcon: require('./TheProphetsMosqueIcon').default,
  TheaterIcon: require('./TheaterIcon').default,
  ThermometerColdIcon: require('./ThermometerColdIcon').default,
  ThermometerIcon: require('./ThermometerIcon').default,
  ThermometerWarmIcon: require('./ThermometerWarmIcon').default,
  ThreadIcon: require('./ThreadIcon').default,
  ThreadsEllipseIcon: require('./ThreadsEllipseIcon').default,
  ThreadsRectangleIcon: require('./ThreadsRectangleIcon').default,
  ThreadsIcon: require('./ThreadsIcon').default,
  ThreeCircleIcon: require('./ThreeCircleIcon').default,
  ThreeFinger01Icon: require('./ThreeFinger01Icon').default,
  ThreeFinger02Icon: require('./ThreeFinger02Icon').default,
  ThreeFinger03Icon: require('./ThreeFinger03Icon').default,
  ThreeFinger04Icon: require('./ThreeFinger04Icon').default,
  ThreeFinger05Icon: require('./ThreeFinger05Icon').default,
  ThreeSquareIcon: require('./ThreeSquareIcon').default,
  ThumbsDownEllipseIcon: require('./ThumbsDownEllipseIcon').default,
  ThumbsDownRectangleIcon: require('./ThumbsDownRectangleIcon').default,
  ThumbsDownIcon: require('./ThumbsDownIcon').default,
  ThumbsUpDownIcon: require('./ThumbsUpDownIcon').default,
  ThumbsUpEllipseIcon: require('./ThumbsUpEllipseIcon').default,
  ThumbsUpRectangleIcon: require('./ThumbsUpRectangleIcon').default,
  ThumbsUpIcon: require('./ThumbsUpIcon').default,
  TicTacToeIcon: require('./TicTacToeIcon').default,
  Tick01Icon: require('./Tick01Icon').default,
  Tick02Icon: require('./Tick02Icon').default,
  Tick03Icon: require('./Tick03Icon').default,
  Tick04Icon: require('./Tick04Icon').default,
  TickDouble01Icon: require('./TickDouble01Icon').default,
  TickDouble02Icon: require('./TickDouble02Icon').default,
  TickDouble03Icon: require('./TickDouble03Icon').default,
  TickDouble04Icon: require('./TickDouble04Icon').default,
  Ticket01Icon: require('./Ticket01Icon').default,
  Ticket02Icon: require('./Ticket02Icon').default,
  Ticket03Icon: require('./Ticket03Icon').default,
  TicketStarIcon: require('./TicketStarIcon').default,
  TieIcon: require('./TieIcon').default,
  Tiff01Icon: require('./Tiff01Icon').default,
  Tiff02Icon: require('./Tiff02Icon').default,
  TiktokIcon: require('./TiktokIcon').default,
  TiltifyIcon: require('./TiltifyIcon').default,
  Time01Icon: require('./Time01Icon').default,
  Time02Icon: require('./Time02Icon').default,
  Time03Icon: require('./Time03Icon').default,
  Time04Icon: require('./Time04Icon').default,
  TimeHalfPassIcon: require('./TimeHalfPassIcon').default,
  TimeManagementCircleIcon: require('./TimeManagementCircleIcon').default,
  TimeManagementIcon: require('./TimeManagementIcon').default,
  TimeQuarter02Icon: require('./TimeQuarter02Icon').default,
  TimeQuarterPassIcon: require('./TimeQuarterPassIcon').default,
  TimeQuarterIcon: require('./TimeQuarterIcon').default,
  TimeScheduleIcon: require('./TimeScheduleIcon').default,
  TimeSetting01Icon: require('./TimeSetting01Icon').default,
  TimeSetting02Icon: require('./TimeSetting02Icon').default,
  TimeSetting03Icon: require('./TimeSetting03Icon').default,
  TimeZoneIcon: require('./TimeZoneIcon').default,
  TimelineEventIcon: require('./TimelineEventIcon').default,
  TimelineListIcon: require('./TimelineListIcon').default,
  TimelineIcon: require('./TimelineIcon').default,
  Timer01Icon: require('./Timer01Icon').default,
  Timer02Icon: require('./Timer02Icon').default,
  TipsIcon: require('./TipsIcon').default,
  TireIcon: require('./TireIcon').default,
  Tired01Icon: require('./Tired01Icon').default,
  Tired02Icon: require('./Tired02Icon').default,
  TissuePaperIcon: require('./TissuePaperIcon').default,
  ToggleOffIcon: require('./ToggleOffIcon').default,
  ToggleOnIcon: require('./ToggleOnIcon').default,
  Toilet01Icon: require('./Toilet01Icon').default,
  Toilet02Icon: require('./Toilet02Icon').default,
  TokenCircleIcon: require('./TokenCircleIcon').default,
  TokenSquareIcon: require('./TokenSquareIcon').default,
  Tongue01Icon: require('./Tongue01Icon').default,
  TongueIcon: require('./TongueIcon').default,
  TongueWinkLeftIcon: require('./TongueWinkLeftIcon').default,
  TongueWinkRightIcon: require('./TongueWinkRightIcon').default,
  ToolCaseIcon: require('./ToolCaseIcon').default,
  ToolboxIcon: require('./ToolboxIcon').default,
  ToolsIcon: require('./ToolsIcon').default,
  Tornado01Icon: require('./Tornado01Icon').default,
  Tornado02Icon: require('./Tornado02Icon').default,
  TorriGateIcon: require('./TorriGateIcon').default,
  TorusIcon: require('./TorusIcon').default,
  Touch01Icon: require('./Touch01Icon').default,
  Touch02Icon: require('./Touch02Icon').default,
  Touch03Icon: require('./Touch03Icon').default,
  Touch04Icon: require('./Touch04Icon').default,
  Touch05Icon: require('./Touch05Icon').default,
  Touch06Icon: require('./Touch06Icon').default,
  Touch07Icon: require('./Touch07Icon').default,
  Touch08Icon: require('./Touch08Icon').default,
  Touch09Icon: require('./Touch09Icon').default,
  Touch10Icon: require('./Touch10Icon').default,
  TouchInteraction01Icon: require('./TouchInteraction01Icon').default,
  TouchInteraction02Icon: require('./TouchInteraction02Icon').default,
  TouchInteraction03Icon: require('./TouchInteraction03Icon').default,
  TouchInteraction04Icon: require('./TouchInteraction04Icon').default,
  TouchLocked01Icon: require('./TouchLocked01Icon').default,
  TouchLocked02Icon: require('./TouchLocked02Icon').default,
  TouchLocked03Icon: require('./TouchLocked03Icon').default,
  TouchLocked04Icon: require('./TouchLocked04Icon').default,
  Touchpad01Icon: require('./Touchpad01Icon').default,
  Touchpad02Icon: require('./Touchpad02Icon').default,
  Touchpad03Icon: require('./Touchpad03Icon').default,
  Touchpad04Icon: require('./Touchpad04Icon').default,
  TouchpadOffIcon: require('./TouchpadOffIcon').default,
  TowTruckIcon: require('./TowTruckIcon').default,
  TowelsIcon: require('./TowelsIcon').default,
  ToyBrickIcon: require('./ToyBrickIcon').default,
  ToyTrainIcon: require('./ToyTrainIcon').default,
  TractorIcon: require('./TractorIcon').default,
  TradeDownIcon: require('./TradeDownIcon').default,
  TradeMarkIcon: require('./TradeMarkIcon').default,
  TradeUpIcon: require('./TradeUpIcon').default,
  TrafficIncidentIcon: require('./TrafficIncidentIcon').default,
  TrafficJam01Icon: require('./TrafficJam01Icon').default,
  TrafficJam02Icon: require('./TrafficJam02Icon').default,
  TrafficLightIcon: require('./TrafficLightIcon').default,
  Train01Icon: require('./Train01Icon').default,
  Train02Icon: require('./Train02Icon').default,
  TrainTrackIcon: require('./TrainTrackIcon').default,
  TramIcon: require('./TramIcon').default,
  TrampolineIcon: require('./TrampolineIcon').default,
  TransactionHistoryIcon: require('./TransactionHistoryIcon').default,
  TransactionIcon: require('./TransactionIcon').default,
  TransitionBottomIcon: require('./TransitionBottomIcon').default,
  TransitionLeftIcon: require('./TransitionLeftIcon').default,
  TransitionRightIcon: require('./TransitionRightIcon').default,
  TransitionTopIcon: require('./TransitionTopIcon').default,
  TranslateIcon: require('./TranslateIcon').default,
  TranslationIcon: require('./TranslationIcon').default,
  TransmissionIcon: require('./TransmissionIcon').default,
  TransparencyIcon: require('./TransparencyIcon').default,
  TrapezoidLineHorizontalIcon: require('./TrapezoidLineHorizontalIcon').default,
  TrapezoidLineVerticalIcon: require('./TrapezoidLineVerticalIcon').default,
  TravelBagIcon: require('./TravelBagIcon').default,
  Treadmill01Icon: require('./Treadmill01Icon').default,
  Treadmill02Icon: require('./Treadmill02Icon').default,
  TreatmentIcon: require('./TreatmentIcon').default,
  Tree01Icon: require('./Tree01Icon').default,
  Tree02Icon: require('./Tree02Icon').default,
  Tree03Icon: require('./Tree03Icon').default,
  Tree04Icon: require('./Tree04Icon').default,
  Tree05Icon: require('./Tree05Icon').default,
  Tree06Icon: require('./Tree06Icon').default,
  Tree07Icon: require('./Tree07Icon').default,
  TreePalmIcon: require('./TreePalmIcon').default,
  TreesIcon: require('./TreesIcon').default,
  TrelloIcon: require('./TrelloIcon').default,
  TrendingUpDownIcon: require('./TrendingUpDownIcon').default,
  Triangle01Icon: require('./Triangle01Icon').default,
  Triangle02Icon: require('./Triangle02Icon').default,
  Triangle03Icon: require('./Triangle03Icon').default,
  TriangleDashIcon: require('./TriangleDashIcon').default,
  TriangleRightIcon: require('./TriangleRightIcon').default,
  TriangleIcon: require('./TriangleIcon').default,
  Trolley01Icon: require('./Trolley01Icon').default,
  Trolley02Icon: require('./Trolley02Icon').default,
  TropicalStormIcon: require('./TropicalStormIcon').default,
  TropicalStormTracks01Icon: require('./TropicalStormTracks01Icon').default,
  TropicalStormTracks02Icon: require('./TropicalStormTracks02Icon').default,
  TruckDeliveryIcon: require('./TruckDeliveryIcon').default,
  TruckMonsterIcon: require('./TruckMonsterIcon').default,
  TruckReturnIcon: require('./TruckReturnIcon').default,
  TruckIcon: require('./TruckIcon').default,
  TrulliIcon: require('./TrulliIcon').default,
  TsunamiIcon: require('./TsunamiIcon').default,
  TulipIcon: require('./TulipIcon').default,
  TumblrIcon: require('./TumblrIcon').default,
  TurkishLiraIcon: require('./TurkishLiraIcon').default,
  TurtleNeckIcon: require('./TurtleNeckIcon').default,
  Tv01Icon: require('./Tv01Icon').default,
  Tv02Icon: require('./Tv02Icon').default,
  TvFixIcon: require('./TvFixIcon').default,
  TvIssueIcon: require('./TvIssueIcon').default,
  TvSmartIcon: require('./TvSmartIcon').default,
  TwinTowerIcon: require('./TwinTowerIcon').default,
  TwitchIcon: require('./TwitchIcon').default,
  TwitterSquareIcon: require('./TwitterSquareIcon').default,
  TwitterIcon: require('./TwitterIcon').default,
  TwoCircleIcon: require('./TwoCircleIcon').default,
  TwoFactorAccessIcon: require('./TwoFactorAccessIcon').default,
  TwoFinger01Icon: require('./TwoFinger01Icon').default,
  TwoFinger02Icon: require('./TwoFinger02Icon').default,
  TwoFinger03Icon: require('./TwoFinger03Icon').default,
  TwoFinger04Icon: require('./TwoFinger04Icon').default,
  TwoFinger05Icon: require('./TwoFinger05Icon').default,
  TwoSquareIcon: require('./TwoSquareIcon').default,
  Txt01Icon: require('./Txt01Icon').default,
  Txt02Icon: require('./Txt02Icon').default,
  TypeCursorIcon: require('./TypeCursorIcon').default,
  Typescript01Icon: require('./Typescript01Icon').default,
  Typescript02Icon: require('./Typescript02Icon').default,
  Typescript03Icon: require('./Typescript03Icon').default,
  UberIcon: require('./UberIcon').default,
  Ufo01Icon: require('./Ufo01Icon').default,
  UfoIcon: require('./UfoIcon').default,
  UmbrellaDollarIcon: require('./UmbrellaDollarIcon').default,
  UmbrellaOffIcon: require('./UmbrellaOffIcon').default,
  UmbrellaIcon: require('./UmbrellaIcon').default,
  UnamusedIcon: require('./UnamusedIcon').default,
  Unarchive03Icon: require('./Unarchive03Icon').default,
  UnavailableIcon: require('./UnavailableIcon').default,
  Underpants01Icon: require('./Underpants01Icon').default,
  Underpants02Icon: require('./Underpants02Icon').default,
  Underpants03Icon: require('./Underpants03Icon').default,
  Undo02Icon: require('./Undo02Icon').default,
  Undo03Icon: require('./Undo03Icon').default,
  UndoIcon: require('./UndoIcon').default,
  UnfoldLessIcon: require('./UnfoldLessIcon').default,
  UnfoldMoreDownIcon: require('./UnfoldMoreDownIcon').default,
  UnfoldMoreIcon: require('./UnfoldMoreIcon').default,
  UnfoldMoreUpIcon: require('./UnfoldMoreUpIcon').default,
  UngroupItemsIcon: require('./UngroupItemsIcon').default,
  UngroupLayersIcon: require('./UngroupLayersIcon').default,
  UngroupIcon: require('./UngroupIcon').default,
  UnhappyIcon: require('./UnhappyIcon').default,
  UniversalAccessCircleIcon: require('./UniversalAccessCircleIcon').default,
  UniversalAccessIcon: require('./UniversalAccessIcon').default,
  UniversityIcon: require('./UniversityIcon').default,
  Unlink01Icon: require('./Unlink01Icon').default,
  Unlink02Icon: require('./Unlink02Icon').default,
  Unlink03Icon: require('./Unlink03Icon').default,
  Unlink04Icon: require('./Unlink04Icon').default,
  Unlink05Icon: require('./Unlink05Icon').default,
  Unlink06Icon: require('./Unlink06Icon').default,
  UnsplashIcon: require('./UnsplashIcon').default,
  Upload01Icon: require('./Upload01Icon').default,
  Upload02Icon: require('./Upload02Icon').default,
  Upload03Icon: require('./Upload03Icon').default,
  Upload04Icon: require('./Upload04Icon').default,
  Upload05Icon: require('./Upload05Icon').default,
  Upload06Icon: require('./Upload06Icon').default,
  UploadCircle01Icon: require('./UploadCircle01Icon').default,
  UploadCircle02Icon: require('./UploadCircle02Icon').default,
  UploadSquare01Icon: require('./UploadSquare01Icon').default,
  UploadSquare02Icon: require('./UploadSquare02Icon').default,
  UpworkIcon: require('./UpworkIcon').default,
  UsbBugsIcon: require('./UsbBugsIcon').default,
  UsbConnected01Icon: require('./UsbConnected01Icon').default,
  UsbConnected02Icon: require('./UsbConnected02Icon').default,
  UsbConnected03Icon: require('./UsbConnected03Icon').default,
  UsbErrorIcon: require('./UsbErrorIcon').default,
  UsbMemory01Icon: require('./UsbMemory01Icon').default,
  UsbMemory02Icon: require('./UsbMemory02Icon').default,
  UsbNotConnected01Icon: require('./UsbNotConnected01Icon').default,
  UsbNotConnected02Icon: require('./UsbNotConnected02Icon').default,
  UsbIcon: require('./UsbIcon').default,
  UsdtIcon: require('./UsdtIcon').default,
  User02Icon: require('./User02Icon').default,
  User03Icon: require('./User03Icon').default,
  UserAccountIcon: require('./UserAccountIcon').default,
  UserAdd01Icon: require('./UserAdd01Icon').default,
  UserAdd02Icon: require('./UserAdd02Icon').default,
  UserAiIcon: require('./UserAiIcon').default,
  UserArrowLeftRightIcon: require('./UserArrowLeftRightIcon').default,
  UserBlock01Icon: require('./UserBlock01Icon').default,
  UserBlock02Icon: require('./UserBlock02Icon').default,
  UserCheck01Icon: require('./UserCheck01Icon').default,
  UserCheck02Icon: require('./UserCheck02Icon').default,
  UserCircle02Icon: require('./UserCircle02Icon').default,
  UserCircleIcon: require('./UserCircleIcon').default,
  UserDollarIcon: require('./UserDollarIcon').default,
  UserEdit01Icon: require('./UserEdit01Icon').default,
  UserFullViewIcon: require('./UserFullViewIcon').default,
  UserGroup02Icon: require('./UserGroup02Icon').default,
  UserGroup03Icon: require('./UserGroup03Icon').default,
  UserGroupIcon: require('./UserGroupIcon').default,
  UserIdVerificationIcon: require('./UserIdVerificationIcon').default,
  UserListIcon: require('./UserListIcon').default,
  UserLock01Icon: require('./UserLock01Icon').default,
  UserLock02Icon: require('./UserLock02Icon').default,
  UserLove01Icon: require('./UserLove01Icon').default,
  UserLove02Icon: require('./UserLove02Icon').default,
  UserMinus01Icon: require('./UserMinus01Icon').default,
  UserMinus02Icon: require('./UserMinus02Icon').default,
  UserMultiple02Icon: require('./UserMultiple02Icon').default,
  UserMultiple03Icon: require('./UserMultiple03Icon').default,
  UserMultipleIcon: require('./UserMultipleIcon').default,
  UserQuestion01Icon: require('./UserQuestion01Icon').default,
  UserQuestion02Icon: require('./UserQuestion02Icon').default,
  UserRemove01Icon: require('./UserRemove01Icon').default,
  UserRemove02Icon: require('./UserRemove02Icon').default,
  UserRoadsideIcon: require('./UserRoadsideIcon').default,
  UserSearch01Icon: require('./UserSearch01Icon').default,
  UserSearch02Icon: require('./UserSearch02Icon').default,
  UserSettings01Icon: require('./UserSettings01Icon').default,
  UserSettings02Icon: require('./UserSettings02Icon').default,
  UserSharingIcon: require('./UserSharingIcon').default,
  UserShield01Icon: require('./UserShield01Icon').default,
  UserShield02Icon: require('./UserShield02Icon').default,
  UserSquareIcon: require('./UserSquareIcon').default,
  UserStar01Icon: require('./UserStar01Icon').default,
  UserStar02Icon: require('./UserStar02Icon').default,
  UserStatusIcon: require('./UserStatusIcon').default,
  UserStoryIcon: require('./UserStoryIcon').default,
  UserIcon: require('./UserIcon').default,
  UserSwitchIcon: require('./UserSwitchIcon').default,
  UserTime01Icon: require('./UserTime01Icon').default,
  UserTime02Icon: require('./UserTime02Icon').default,
  UserTime03Icon: require('./UserTime03Icon').default,
  UserUnlock01Icon: require('./UserUnlock01Icon').default,
  UserUnlock02Icon: require('./UserUnlock02Icon').default,
  UserWarning01Icon: require('./UserWarning01Icon').default,
  UserWarning02Icon: require('./UserWarning02Icon').default,
  UserWarning03Icon: require('./UserWarning03Icon').default,
  UtilityPoleIcon: require('./UtilityPoleIcon').default,
  Uv01Icon: require('./Uv01Icon').default,
  Uv02Icon: require('./Uv02Icon').default,
  Uv03Icon: require('./Uv03Icon').default,
  VaccineIcon: require('./VaccineIcon').default,
  VacuumCleanerIcon: require('./VacuumCleanerIcon').default,
  ValidationApprovalIcon: require('./ValidationApprovalIcon').default,
  ValidationIcon: require('./ValidationIcon').default,
  VanIcon: require('./VanIcon').default,
  VariableIcon: require('./VariableIcon').default,
  VectorSquareIcon: require('./VectorSquareIcon').default,
  VegetarianFoodIcon: require('./VegetarianFoodIcon').default,
  VenetianMaskIcon: require('./VenetianMaskIcon').default,
  VersusIcon: require('./VersusIcon').default,
  VerticalResizeIcon: require('./VerticalResizeIcon').default,
  VerticalScrollPointIcon: require('./VerticalScrollPointIcon').default,
  VestIcon: require('./VestIcon').default,
  ViberIcon: require('./ViberIcon').default,
  VibrateIcon: require('./VibrateIcon').default,
  VictoryFinger01Icon: require('./VictoryFinger01Icon').default,
  VictoryFinger02Icon: require('./VictoryFinger02Icon').default,
  VictoryFinger03Icon: require('./VictoryFinger03Icon').default,
  Video01Icon: require('./Video01Icon').default,
  Video02Icon: require('./Video02Icon').default,
  VideoAiIcon: require('./VideoAiIcon').default,
  VideoCameraAiIcon: require('./VideoCameraAiIcon').default,
  VideoConsoleIcon: require('./VideoConsoleIcon').default,
  VideoOffIcon: require('./VideoOffIcon').default,
  VideoReplayIcon: require('./VideoReplayIcon').default,
  VideotapeIcon: require('./VideotapeIcon').default,
  ViewAgendaIcon: require('./ViewAgendaIcon').default,
  ViewOffSlashIcon: require('./ViewOffSlashIcon').default,
  ViewOffIcon: require('./ViewOffIcon').default,
  ViewSidebarLeftIcon: require('./ViewSidebarLeftIcon').default,
  ViewSidebarRightIcon: require('./ViewSidebarRightIcon').default,
  ViewIcon: require('./ViewIcon').default,
  Villa01Icon: require('./Villa01Icon').default,
  Villa02Icon: require('./Villa02Icon').default,
  VimeoIcon: require('./VimeoIcon').default,
  VineSquareIcon: require('./VineSquareIcon').default,
  VineIcon: require('./VineIcon').default,
  VintageClockIcon: require('./VintageClockIcon').default,
  VirtualRealityVr01Icon: require('./VirtualRealityVr01Icon').default,
  VirtualRealityVr02Icon: require('./VirtualRealityVr02Icon').default,
  VisionIcon: require('./VisionIcon').default,
  VisualStudioCodeIcon: require('./VisualStudioCodeIcon').default,
  VkSquareIcon: require('./VkSquareIcon').default,
  VkIcon: require('./VkIcon').default,
  VoiceIdIcon: require('./VoiceIdIcon').default,
  VoiceIcon: require('./VoiceIcon').default,
  VolleyballIcon: require('./VolleyballIcon').default,
  VolumeHighIcon: require('./VolumeHighIcon').default,
  VolumeLowIcon: require('./VolumeLowIcon').default,
  VolumeMinusIcon: require('./VolumeMinusIcon').default,
  VolumeMute01Icon: require('./VolumeMute01Icon').default,
  VolumeMute02Icon: require('./VolumeMute02Icon').default,
  VolumeOffIcon: require('./VolumeOffIcon').default,
  VolumeUpIcon: require('./VolumeUpIcon').default,
  VomitingIcon: require('./VomitingIcon').default,
  VoucherIcon: require('./VoucherIcon').default,
  VrGlassesIcon: require('./VrGlassesIcon').default,
  VrIcon: require('./VrIcon').default,
  Vynil01Icon: require('./Vynil01Icon').default,
  Vynil02Icon: require('./Vynil02Icon').default,
  Vynil03Icon: require('./Vynil03Icon').default,
  WThreeSchoolsIcon: require('./WThreeSchoolsIcon').default,
  WaiterIcon: require('./WaiterIcon').default,
  WaitersIcon: require('./WaitersIcon').default,
  WalkingIcon: require('./WalkingIcon').default,
  WallLampIcon: require('./WallLampIcon').default,
  Wallet01Icon: require('./Wallet01Icon').default,
  Wallet02Icon: require('./Wallet02Icon').default,
  Wallet03Icon: require('./Wallet03Icon').default,
  Wallet04Icon: require('./Wallet04Icon').default,
  Wallet05Icon: require('./Wallet05Icon').default,
  WalletAdd01Icon: require('./WalletAdd01Icon').default,
  WalletAdd02Icon: require('./WalletAdd02Icon').default,
  WalletCardsIcon: require('./WalletCardsIcon').default,
  WalletDone01Icon: require('./WalletDone01Icon').default,
  WalletDone02Icon: require('./WalletDone02Icon').default,
  WalletNotFound01Icon: require('./WalletNotFound01Icon').default,
  WalletNotFound02Icon: require('./WalletNotFound02Icon').default,
  WalletRemove01Icon: require('./WalletRemove01Icon').default,
  WalletRemove02Icon: require('./WalletRemove02Icon').default,
  WalpaperIcon: require('./WalpaperIcon').default,
  WantedIcon: require('./WantedIcon').default,
  Wardrobe01Icon: require('./Wardrobe01Icon').default,
  Wardrobe02Icon: require('./Wardrobe02Icon').default,
  Wardrobe03Icon: require('./Wardrobe03Icon').default,
  Wardrobe04Icon: require('./Wardrobe04Icon').default,
  WarehouseIcon: require('./WarehouseIcon').default,
  WashingMachineIcon: require('./WashingMachineIcon').default,
  WashingtonMonumentIcon: require('./WashingtonMonumentIcon').default,
  WasteRestoreIcon: require('./WasteRestoreIcon').default,
  WasteIcon: require('./WasteIcon').default,
  Watch01Icon: require('./Watch01Icon').default,
  Watch02Icon: require('./Watch02Icon').default,
  WaterEnergyIcon: require('./WaterEnergyIcon').default,
  WaterPoloIcon: require('./WaterPoloIcon').default,
  WaterPumpIcon: require('./WaterPumpIcon').default,
  WaterfallDown01Icon: require('./WaterfallDown01Icon').default,
  WaterfallDown03Icon: require('./WaterfallDown03Icon').default,
  WaterfallUp01Icon: require('./WaterfallUp01Icon').default,
  WaterfallUp02Icon: require('./WaterfallUp02Icon').default,
  WatermelonIcon: require('./WatermelonIcon').default,
  WattpadSquareIcon: require('./WattpadSquareIcon').default,
  WattpadIcon: require('./WattpadIcon').default,
  Wav01Icon: require('./Wav01Icon').default,
  Wav02Icon: require('./Wav02Icon').default,
  WaveSquareIcon: require('./WaveSquareIcon').default,
  WaveIcon: require('./WaveIcon').default,
  WaveTriangleIcon: require('./WaveTriangleIcon').default,
  WavingHand01Icon: require('./WavingHand01Icon').default,
  WavingHand02Icon: require('./WavingHand02Icon').default,
  WazeIcon: require('./WazeIcon').default,
  WebDesign01Icon: require('./WebDesign01Icon').default,
  WebDesign02Icon: require('./WebDesign02Icon').default,
  WebProgrammingIcon: require('./WebProgrammingIcon').default,
  WebProtectionIcon: require('./WebProtectionIcon').default,
  WebSecurityIcon: require('./WebSecurityIcon').default,
  WebValidationIcon: require('./WebValidationIcon').default,
  WebflowEllipseIcon: require('./WebflowEllipseIcon').default,
  WebflowRectangleIcon: require('./WebflowRectangleIcon').default,
  WebflowIcon: require('./WebflowIcon').default,
  WebhookOffIcon: require('./WebhookOffIcon').default,
  WebhookIcon: require('./WebhookIcon').default,
  WechatIcon: require('./WechatIcon').default,
  WeddingIcon: require('./WeddingIcon').default,
  WeightScale01Icon: require('./WeightScale01Icon').default,
  WeightScaleIcon: require('./WeightScaleIcon').default,
  WeightIcon: require('./WeightIcon').default,
  WellnessIcon: require('./WellnessIcon').default,
  WhatsappBusinessIcon: require('./WhatsappBusinessIcon').default,
  WhatsappIcon: require('./WhatsappIcon').default,
  WheatOffIcon: require('./WheatOffIcon').default,
  WheatIcon: require('./WheatIcon').default,
  WheelchairIcon: require('./WheelchairIcon').default,
  WhiskIcon: require('./WhiskIcon').default,
  WhistleIcon: require('./WhistleIcon').default,
  WhiteboardIcon: require('./WhiteboardIcon').default,
  Wifi01Icon: require('./Wifi01Icon').default,
  Wifi02Icon: require('./Wifi02Icon').default,
  WifiCircleIcon: require('./WifiCircleIcon').default,
  WifiConnected01Icon: require('./WifiConnected01Icon').default,
  WifiConnected02Icon: require('./WifiConnected02Icon').default,
  WifiConnected03Icon: require('./WifiConnected03Icon').default,
  WifiDisconnected01Icon: require('./WifiDisconnected01Icon').default,
  WifiDisconnected02Icon: require('./WifiDisconnected02Icon').default,
  WifiDisconnected03Icon: require('./WifiDisconnected03Icon').default,
  WifiDisconnected04Icon: require('./WifiDisconnected04Icon').default,
  WifiError01Icon: require('./WifiError01Icon').default,
  WifiError02Icon: require('./WifiError02Icon').default,
  WifiFullSignalIcon: require('./WifiFullSignalIcon').default,
  WifiLocationIcon: require('./WifiLocationIcon').default,
  WifiLockIcon: require('./WifiLockIcon').default,
  WifiLowSignalIcon: require('./WifiLowSignalIcon').default,
  WifiMediumSignalIcon: require('./WifiMediumSignalIcon').default,
  WifiNoSignalIcon: require('./WifiNoSignalIcon').default,
  WifiOff01Icon: require('./WifiOff01Icon').default,
  WifiOff02Icon: require('./WifiOff02Icon').default,
  WifiPenIcon: require('./WifiPenIcon').default,
  WifiSquareIcon: require('./WifiSquareIcon').default,
  WifiSyncIcon: require('./WifiSyncIcon').default,
  WifiUnlockIcon: require('./WifiUnlockIcon').default,
  WikipediaIcon: require('./WikipediaIcon').default,
  WindPower01Icon: require('./WindPower01Icon').default,
  WindPower02Icon: require('./WindPower02Icon').default,
  WindPower03Icon: require('./WindPower03Icon').default,
  WindPowerIcon: require('./WindPowerIcon').default,
  WindSurfIcon: require('./WindSurfIcon').default,
  WindTurbineIcon: require('./WindTurbineIcon').default,
  WindowsNewIcon: require('./WindowsNewIcon').default,
  WindowsOldIcon: require('./WindowsOldIcon').default,
  WinkIcon: require('./WinkIcon').default,
  WinkingIcon: require('./WinkingIcon').default,
  WirelessCloudAccessIcon: require('./WirelessCloudAccessIcon').default,
  WirelessIcon: require('./WirelessIcon').default,
  WiseIcon: require('./WiseIcon').default,
  WomanIcon: require('./WomanIcon').default,
  WordpressIcon: require('./WordpressIcon').default,
  WorkAlertIcon: require('./WorkAlertIcon').default,
  WorkHistoryIcon: require('./WorkHistoryIcon').default,
  WorkIcon: require('./WorkIcon').default,
  WorkUpdateIcon: require('./WorkUpdateIcon').default,
  WorkflowCircle01Icon: require('./WorkflowCircle01Icon').default,
  WorkflowCircle02Icon: require('./WorkflowCircle02Icon').default,
  WorkflowCircle03Icon: require('./WorkflowCircle03Icon').default,
  WorkflowCircle04Icon: require('./WorkflowCircle04Icon').default,
  WorkflowCircle05Icon: require('./WorkflowCircle05Icon').default,
  WorkflowCircle06Icon: require('./WorkflowCircle06Icon').default,
  WorkflowSquare01Icon: require('./WorkflowSquare01Icon').default,
  WorkflowSquare02Icon: require('./WorkflowSquare02Icon').default,
  WorkflowSquare03Icon: require('./WorkflowSquare03Icon').default,
  WorkflowSquare04Icon: require('./WorkflowSquare04Icon').default,
  WorkflowSquare05Icon: require('./WorkflowSquare05Icon').default,
  WorkflowSquare06Icon: require('./WorkflowSquare06Icon').default,
  WorkflowSquare07Icon: require('./WorkflowSquare07Icon').default,
  WorkflowSquare08Icon: require('./WorkflowSquare08Icon').default,
  WorkflowSquare09Icon: require('./WorkflowSquare09Icon').default,
  WorkflowSquare10Icon: require('./WorkflowSquare10Icon').default,
  WorkoutBattleRopesIcon: require('./WorkoutBattleRopesIcon').default,
  WorkoutGymnasticsIcon: require('./WorkoutGymnasticsIcon').default,
  WorkoutKickingIcon: require('./WorkoutKickingIcon').default,
  WorkoutRunIcon: require('./WorkoutRunIcon').default,
  WorkoutSportIcon: require('./WorkoutSportIcon').default,
  WorkoutSquatsIcon: require('./WorkoutSquatsIcon').default,
  WorkoutStretchingIcon: require('./WorkoutStretchingIcon').default,
  WorkoutWarmUpIcon: require('./WorkoutWarmUpIcon').default,
  WorryIcon: require('./WorryIcon').default,
  WpsOfficeRectangleIcon: require('./WpsOfficeRectangleIcon').default,
  WpsOfficeIcon: require('./WpsOfficeIcon').default,
  Wrench01Icon: require('./Wrench01Icon').default,
  Wrench02Icon: require('./Wrench02Icon').default,
  WuduIcon: require('./WuduIcon').default,
  XRayIcon: require('./XRayIcon').default,
  XVariableCircleIcon: require('./XVariableCircleIcon').default,
  XVariableSquareIcon: require('./XVariableSquareIcon').default,
  XVariableIcon: require('./XVariableIcon').default,
  XingIcon: require('./XingIcon').default,
  Xls01Icon: require('./Xls01Icon').default,
  Xls02Icon: require('./Xls02Icon').default,
  Xml01Icon: require('./Xml01Icon').default,
  Xml02Icon: require('./Xml02Icon').default,
  Xsl01Icon: require('./Xsl01Icon').default,
  Xsl02Icon: require('./Xsl02Icon').default,
  YelpIcon: require('./YelpIcon').default,
  YenCircleIcon: require('./YenCircleIcon').default,
  YenReceiveIcon: require('./YenReceiveIcon').default,
  YenSendIcon: require('./YenSendIcon').default,
  YenSquareIcon: require('./YenSquareIcon').default,
  YenIcon: require('./YenIcon').default,
  Yoga01Icon: require('./Yoga01Icon').default,
  Yoga02Icon: require('./Yoga02Icon').default,
  Yoga03Icon: require('./Yoga03Icon').default,
  YogaBallIcon: require('./YogaBallIcon').default,
  YogaMatIcon: require('./YogaMatIcon').default,
  YogurtIcon: require('./YogurtIcon').default,
  YoutubeIcon: require('./YoutubeIcon').default,
  YurtIcon: require('./YurtIcon').default,
  ZakatIcon: require('./ZakatIcon').default,
  ZapIcon: require('./ZapIcon').default,
  ZeppelinIcon: require('./ZeppelinIcon').default,
  ZeroCircleIcon: require('./ZeroCircleIcon').default,
  ZeroSquareIcon: require('./ZeroSquareIcon').default,
  Zip01Icon: require('./Zip01Icon').default,
  Zip02Icon: require('./Zip02Icon').default,
  ZoomCircleIcon: require('./ZoomCircleIcon').default,
  ZoomInAreaIcon: require('./ZoomInAreaIcon').default,
  ZoomOutAreaIcon: require('./ZoomOutAreaIcon').default,
  ZoomSquareIcon: require('./ZoomSquareIcon').default,
  ZoomIcon: require('./ZoomIcon').default,
  ZshIcon: require('./ZshIcon').default,
  ZzzIcon: require('./ZzzIcon').default,
};

// Keep cache for API consistency
const iconCache = new Map<string, IconSvgObject>();

export function loadIcon(iconName: string): Promise<IconSvgObject> {
  if (iconCache.has(iconName)) return Promise.resolve(iconCache.get(iconName)!);
  const iconData = mods[iconName];
  if (!iconData) throw new Error(`Icon not found: ${iconName}`);
  iconCache.set(iconName, iconData);
  return Promise.resolve(iconData);
}

export function loadIcons(iconNames: string[]): Promise<IconSvgObject[]> {
  return Promise.all(iconNames.map(loadIcon));
}

export function iconExists(iconName: string): boolean {
  return !!mods[iconName];
}

export function clearIconCache(): void {
  iconCache.clear();
}

export function getCacheSize(): number {
  return iconCache.size;
}

// Style-specific aliases for multi-package usage
export const loadIconStrokeRounded = loadIcon;
export const loadIconsStrokeRounded = loadIcons;

export default { loadIcon, loadIcons, iconExists, clearIconCache, getCacheSize };
